export const resources = {
  cn: {
    sustainFactors: {
      updateSustainRates: '更新Sustain Rate',
      sustainFactorsPage: 'Sustain因子页面',
      properties: {
        countryName: '国家名称',
        electricityPurchasedMarketBased: '基于市场的购电',
        electricityChange: '基于位置的购电',
        districtHeating: '集中供暖',
        gas: '燃气',
        districtCooling: '集中供冷',
        bioFuel: '生物燃料',
        electricityGenerated: '发电量',
        water: '水',
        waste: '填埋的废弃物',
      },
    },
    common: {
      id: 'ID',
      reltp: 'RELTP CN 2.0',
      saveColumns: '保存列',
      returnedNotification: '已退回！',
      requiredField: '必填项目',
      actions: '执行',
      reason: '原因',
      projects: '项目',
      confirm: '确认',
      quantity: '数量',
      fy: '财年',
      country: '国家',
      total: '全部',
      email: '邮箱地址',
      role: '角色',
      bulkUpdate: '更新',
      businessUnit: '业务单位',
      countryCode: '国家代码',
      createDraft: '创建草稿',
      changeStatus: '更改状态',
      mergeByReferenceID: '按参考 ID 合并',
      removeFromSubmission: '从提交中删除',
      sendToArchive: '发送存档',
      fillTheRestAndPropose: '填写其余部分并提议',
      createDraftProject: '创建项目草稿',
      fiscalYear: '财年',
      view: '查看',
      returnMessage: '返回信息',
      projectResources: '项目资源',
      updateAndPropose: '更新并提议',
      updateAndApprove: '更新并批准',
      viewProject: '查看项目',
      updateProject: '更新项目',
      update: '更新',
      hours: '小时',
      name: '名称',
      delete: '删除',
      archive: '存档',
      discard: '放弃',
      cancel: '取消',
      warning: '注意',
      deleteTheseProjects: '您确定要删除这些项目吗？',
      archiveTheseProjects: '您确定要归档这​​些项目吗？',
      bulkEdit: '批量编辑',
      loadingMsg: {
        checkingYourPermissions: '检查您的权限',
      },
      totalEUR: '欧元总额',
      areYouSure: '您确定吗？',
      discardConfirmationMessage: '您做了一些修改，是否放弃并关闭？',
      revertFromArchive: '从存档中恢复',
      bulk: '批量',
      close: '关闭',
      resetColumns: '',
    },
    appBar: {
      openSettings: '打开设置',
      mobileMenu: {
        accountOfCurrentUser: '当前用户的帐户',
      },
      notificationMenu: {
        noNotifications: '没有通知',
        new: '新的',
        returnedProjects: '退回的项目',
        showOldNotifications: '显示旧通知',
        plannedProjects: '计划的项目',
      },
      navigation: {
        submissiontTab: '提交',
        archiveTab: '归档',
        projectsTab: '项目',
      },
      countrySelect: {
        chooseCountry: '选择国家',
      },
    },
    login: {
      loginMessages: '登录',
    },
    projects: {
      manageProjects: '管理项目',
      createProject: '创建项目',
      bulkCreateProject: '批量创建项目',
      replaceCafmAssets: '替换 CAFM 资产',
      returned: '回来',
      totalProjects: '项目总数',
      projectsAvailableForUser: '用户可获取的所有项目',
      asset: '资产',
      archiveProject: '存档项目',
      changeProjectStatus: '更改项目状态',
      newStatus: '新状态',
      assets: '资产',
      requestChanges: '请求更改',
      pushToEtr: '推送到 ETR',
      etrSync: '与 ETR 同步',
      notEtrSync: '未与 ETR 同步',
      notSyncedWithEtrMessage:
        'ETR 与 RELTP 的项目版本不同。在批准此项目之前，请与 RE 用户协调，将最新更改从 RELTP 推送到 ETR',
      mergeProjects: '合并项目',
      additionalApproval: '额外批准',
      properties: {
        totalProjectInvestmentCostDescription: '项目总投资至少应为',
        projectsSelected: '选定的项目',
        additionalApprovalBody: '项目现在处于计划状态。您是否获得了额外批准？',
        additionalApprovalWarningSwitch: '您即将将项目状态切换为已批准',
        additionalApprovalRequired: '需要额外批准',
        totalInvestment: '总投资额',
        districtHeatNetKwh: '集中供暖净千瓦时',
        depreciationAccount: '折旧科目',
        cpmFm: 'CPM FM',
        annualCostImpactNetEUR: '年度成本影响净额 欧元',
        totalInvestmentEUR: '总投资 欧元',
        investmentAmount: '投资金额',
        status: '状态',
        bioFuelsNetKwh: '生物燃料净千瓦时',
        projectInfo: '项目信息',
        retailCost: '零售成本',
        benefitsAndRisk: '成效和风险',
        riskAvoidance: '风险规避',
        riskAvoidancePlaceholder: '不做这个项目会有什么风险？',
        depreciation: '折旧',
        paybackYears: '投资回报（年）',
        annualPAndLImpact: '年度对于P&L的影响',
        recurringYearlySavings: '经常性年度节省',
        operationalCost: '运营成本',
        totalInvestments: '总投资',
        land: '土地',
        benefitsAndRisks: '成效和风险',
        additionalInformation: '附加信息',
        projectName: '项目名称',
        businessUnitFullName: '地点名称',
        projectStatus: '项目状态',
        totalProjectInvestmentEUR: '项目总投资 欧元',
        annualCostImpactNet: '年度净成本影响',
        biofuelsNetKwh: '生物燃料净千瓦时',
        co2eNet: 'Co2e 净值',
        etrprojectID: 'ETR 项目 ID',
        etrSolutionID: 'ETR 解决方案 ID',
        etrUnitID: 'ETR 业务单位 ID',
        unifierID: '统一ID',
        clusterFMSpecialist: '大区工程设施管理专员',
        districtFM: '区域工程设施管理经理',
        responsiblLead: '负责人（Leader）',
        unitFM: '业务单位工程设施管理经理',
        cpm: 'CPM',
        assetManagement: '资产管理',
        externalPM: '外部 PM',
        referenceID: '参考ID',
        projectID: '项目ID',
        etrID: 'ETR ID',
        projectAssets: '项目资产',
        bu: '业务单位',
        landCost: '土地成本',
        solutionPurpose: '解决方案目标',
        solutionType: '解决方案类型',
        startDate: '开始日期',
        completionDate: '完成日期',
        landCG1: '土地 (CG1)',
        landCG1EUR: '土地 (CG1) 欧元',
        propertyInvestmentCG111: '房地产投资 (CG1-11)',
        propertyInvestmentCG111EUR: '房地产投资 (CG1-11) 欧元',
        retailCostCG1516: '零售成本 (CG15-16)',
        retailCostCG1516EUR: '零售成本 (CG15-16) 欧元',
        accountable: '责任人',
        priority: '优先级',
        annualCostImpact: '年度成本影响',
        currency: '货币',
        engineer: '工程师',
        portfolio: 'Portfolio',
        potentialYearlyIncome: '潜在年度收入',
        projectStartFiscalYear: '项目启动财年',
        projectCompletionFiscalYear: '项目完成财年',
        recurringYearlyOperationalCost: '经常性年度运营成本',
        retailInvestmentCG1214: '零售投资 (CG12-14)',
        retailInvestmentCG1214EUR: '零售投资 (CG12-14) 欧元',
        unitType: '业务单位类型',
        updatedAt: '更新于',
        co2eSociety: 'Co2e Society',
        createdBy: '被创建',
        propertyInvestment: '房地产投资',
        totalElectricity: '购电',
        retailInvestment: '零售投资',
        sustainID: 'Sustain ID',
        additionalInformationProject: '附加信息（项目背景）',
        mergedWithProject: '与项目合并',
        programmeName: '计划名称',
        programmeStatus: '计划 是/否',
        projectCompletionFY: '项目完成财年',
        projectEndFY: '项目结束财年',
        projectStartFY: '项目启动财年',
        SISANDimensionSolutionPurpose: 'SISAN 维度（解决方案目标）',
        totalProjectInvestment: '项目总投资',
        LandCG01: '土地 (CG01)',
        propertyInvestmentBuilding: '房地产投资（建筑+土地）（CG01-11）',
        bioFuel: '生物燃料',
        districtCooling: '集中供冷',
        districHeat: '集中供暖',
        naturalGas: '天然气',
        electricityGenerated: '发电量',
        locationBasedCO2: '基于位置的 CO2（基于国家平均排放因子）',
        ingkaClimateFootprintCalculated:
          '英格卡气候足迹（基于市场与实际站点的排放因子）',
        wasteReduction: '填埋的废弃物',
        waterReduction: '水',
        netkWh: '净千瓦时',
        pnlImpact: '对于P&L的影响',
        depreciationAmount: '折旧金额',
        depreciationEur: '折旧 欧元',
        districtCoolingNetKwh: '集中供冷 净千瓦时',
        districtFm: '区域工程设施管理经理',
        etrProjectId: 'ETR 项目 ID',
        etrSolutionId: 'ETR 解决方案 ID',
        etrUnitId: 'ETR 业务单位 ID',
        externalContractorsNeeded: '需要外部承包商',
        gasNetKwh: '燃气 净千瓦时',
        generatedNetKwh: '生成的 净千瓦时',
        impactYear1: '首年影响',
        impactYear1Eur: '首年影响 欧元',
        legalUnit: '法定单位',
        mtoolId: 'Mtool ID',
        co2e: 'Co2e',
        operationalCostEUR: '运营成本 欧元',
        plImpactAccount: 'P&L影响科目',
        plImpactAmountPerAccount: '每个P&L科目的影响金额',
        potentialYearlyIncomeEUR: '潜在年度收入 欧元',
        realEstateDevelopment: '房地产开发',
        recurringYearlyOperationalCostEUR: '经常性年度运营成本 欧元',
        recurringYearlySavingsEUR: '经常性年度节省 欧元',
        payback: '投资回报',
        referenceId: '参考ID',
        sustainId: 'Sustain ID',
        totalElectricityNetKwh: '购电净千瓦时',
        unifierId: '统一ID',
        unitCategory: '业务单位类别',
        unitFm: '业务单位工程设施管理经理',
        wasteReductionT: '减少废弃物（吨）',
        waterReductionM3: '减水量（立方米）',
        pnLImpact: '对于P&L的影响',
        projectMergeWithProjectReferenceId: '合并项目（输入项目参考 ID）',
        localUniqueId: '本地唯一 ID',
        changeProjectMessage:
          '您即将更改项目的开始和结束年份，该项目已添加到最新提交中（已创建 M-Tool ID 并且项目状态为已批准）。请从以下可能的后续步骤中选择',
        projectEndDate: '项目结束日期',
        projectStartDate: '项目开始日期',
        actionCategory: '行动类别',
        budgeting: '预算（仅限俄罗斯）',
        subcategory: '子类别（仅限俄罗斯）',
        etrPriority: 'ETR 优先级',
      },
      hintMessage: {
        chooseABU: '选择一个业务单位',
        chooseBUs: '选择 业务单位',
      },
      create: {
        projectInvestment: '项目投资',
        opexImpact: 'OPEX影响',
        energyInformation: '能源信息',
        createAndPropose: '创建与提议',
        riskAvoidance: '风险规避',
        descriptionForEnergyInformation: '输入项目产生的年度变化，减少量为负值',
        generalForm: {
          startFyIsBiggerErrorMessage: '启动财年大于结束财年',
          hintMessage: {
            additionalProjectInformationErrorMessage:
              '业务单位被更换的数量，特定部分被替换的数量，或与替换部件有关的品牌名称等',
          },
        },
        opexForm: {
          positivePAndLImpact: '对于P&L的正向影响',
          negativePAndLImpact: '对于P&L的负向影响',
          savingAsNegative: '重要提示：节省输入值为负数',
          depreciationCalculated: '折旧 - 计算值',
          annualCostImpactCalculation: '年度成本影响净额 - 计算值',
          paybackYearsCalculated: '投资回报 - 计算值',
          paybackYears: '投资回报（年）',
          annualPAndLImpactCalculated: '年度对于P&L的影响 - 计算值',
          annualPAndLImpact: '年度对于P&L的影响',
        },
      },
      userModal: {
        userBusinessUnits: '用户业务单位',
        userClusters: '用户大区',
        userCountry: '用户国家',
      },
      createProjectsFromCafmAssets: '从 CAFM 资产创建项目',
    },
    bulkCreate: {
      createProjects: '创建项目',
      editProjects: '编辑项目',
      table: {
        removeRow: '删除行',
        copyRow: '复制行',
        addNewRow: '添加新行',
      },
      investmentModal: {
        projectInvestments: '项目投资',
        updateInvestments: '更新投资',
      },
      createDraftProjects: '创建草稿项目',
    },
    flight: {
      makeSubmission: '提交',
      retailPortfolio: '零售Portfolio',
      retailCountryUnit: '零售Country/Unit',
      centres: '购物中心',
      newInfo: '新信息',
      projectsQueue: '项目队列',
      boarded: '已添加至提交列表',
      submitted: '添加到提交',
      loadingProjects: '加载项目',
      noProjectsAvailable: '没有可获取的项目',
      addToSubmission: '添加到提交',
      noSubmissionsForAGivenCountry: '没有针对特定Country/Unit的提交',
      submission: {
        flightSubmissionTableNewInfo: '项目需要被复查，数据在上次提交后被更新',
        flightSubmissionTableBoarded: '当前提交中包含的项目',
        flightSubmissionTableQueue:
          '复查并选择将包含在当前提交中的项目或向项目创建者请求更改',
        flightSubmissionTableReturned: '已要求更改的项目',
      },
      submissionHeader: {
        submissionFinancialCard: {
          exportReport: '导出报告',
        },
      },
      createSubmissionModal: {
        createSubmission: '创建提交',
        submissionName: '提交名称',
        sendToETR: '发送到 ETR',
      },
      newInfoModal: {
        info: '信息',
        projectDataWasUpdated: '项目数据已更新',
        dataUpdateTable: {
          loadingMessage: '加载更改',
          noPreviousValue: '没有以前的值',
        },
      },
      revertProjectModal: {
        revertProjects: '恢复项目',
        revertToDraft: '恢复为草稿',
        projectsRevertedToDraftStatus: '将恢复为草稿状态的项目',
        bulkCommentForRevertedProjects: '已恢复项目的批量注释',
      },
      table: {
        tootTips: {
          projectDataWasChangedClickToViewDetails:
            '项目数据已更改。点击查看详情。',
          boardedProject: '已添加至提交列表的项目',
        },
      },
    },
    user: {
      properties: {
        cluster: '大区',
        userName: '用户名',
      },
    },
    admin: {
      adminPage: '管理员页面',
      updateUser: '更新用户',
      addUser: '添加用户',
    },
    currency: {
      currencyPage: '货币页面',
      updateCurrencyRates: '更新货币汇率',
      currencyTable: {
        currencyCode: '货币代码',
        currencyRate: '货币汇率',
      },
    },
    filter: {
      allFilters: '所有过滤器',
      projectsFilters: '项目过滤器',
      clearFilters: '清除过滤器',
    },
    assets: {
      addNewAsset: '添加新资产',
      addAsset: '添加资产',
      manufacturerModelYear: '制造商、型号、年份等...',
      properties: {
        assetDescription: '资产描述',
        endDate: '结束日期',
        replacementCost: '更换成本',
        manufacturer: '制造商',
        model: '模型',
        organization: '组织',
        unitId: '业务单位ID',
        assetGroup: '资产组',
        replaceAssetsDescription:
          '资产按照 CAFM 中的资产结束日期排列。请从您的业务单位中选择您要更换的资产。您还可以根据资产描述搜索资产。',
      },
      replaceAsset: {
        cafmAssetsErrorMsg: '选定的业务单位没有 CAFM 资产',
        replaceAssets: '更换资产',
      },
    },
    snackbarMessages: {
      sustainFactorsUpdated: 'Sustain因子更新成功',
      sustainFactorsUpdateError: '无法更新Sustain因子',
      fetchProjectError: '获取项目的问题',
      projectCreated: '已创建项目',
      couldNotCreateProject: '无法创建项目',
      projectsSuccessfullyCreated: '项目创建成功',
      couldNotCreateProjects: '无法创建项目',
      projectUpdated: '项目更新',
      projectCouldNotBeUpdated: '无法更新项目',
      couldNotFetchAssets: '无法获取资产',
      couldNotFetchCafmAssets: '无法获取CAFM资产',
      couldNotFetchUsers: '无法获取用户',
      updatedUserSuccessfully: '更新用户成功',
      deletedUserSuccessfully: '删除用户成功',
      couldNotDeleteUser: '无法删除用户',
      couldNotUpdateUser: '无法更新用户',
      projectsStatusesWereUpdated: '项目状态已更新',
      couldNotUpdateProjectsStatuses: '无法更新项目状态',
      problemGettingBusinessUnits: '获取业务单位时的问题',
      problemGettingUserData: '获取用户数据的问题',
      problemGettingFlightData: '获取已提交数据的问题',
      couldNotCreateNewSubmission: '无法创建新提交',
      couldNotFetchArchiveData: '无法获取存档数据',
      couldNotSendProjectsToArchive: '无法将项目发送存档',
      couldNotFetchProjectChanges: '无法获取项目更改',
      couldNotFetchCurrencyData: '无法获取货币数据',
      successfullyUpdatedCurrencyRates: '更新货币汇率成功',
      couldNotUpdateCurrencyData: '无法更新货币数据',
      problemGettingUpdatedProjects: '获取更新项目的问题',
      couldNotMergeProjects: '无法合并项目',
      couldNotFetchSustainFactors: '无法获取Sustain因子',
      successfullyUpdatedSustainFactors: '更新Sustain因子成功',
      successfullyUpdatedProjects: '项目更新成功',
      couldNotUpdateProjects: '无法更新项目',
      cannotEditApprovedOrPlannedProjects:
        '一些项目已从批量编辑中删除，因为它们有MTool ID并已批准或计划',
      problemToAddArchived: '某些选定的项目无法存档，因为它们有 M-Tool ID',
      problemPushToEtr: '推送到 ETR 时出错',
      successPushToEtr: '项目将在几分钟内同步到 ETR',
      projectsUnArchived: '项目从存档中移出成功',
      projectsUnArchivedError: '无法从存档中移动项目',
    },
    validationMessages: {
      projectNameIsRequired: '项目名称为必填项',
      buIsRequired: '业务单位为必填项',
      additionalInformationIsRequired: '附加信息为必填项',
      benefitsAndRiskIsRequired: '成效和风险为必填项',
      priorityIsRequired: '优先级为必填项',
      solutionPurposeIsRequired: '解决方案目标为必填项',
      solutionTypeIsRequired: '解决方案类型为必填项',
      completionFYIsRequired: '完成财年为必填项',
      sourceChannelIsRequired: '采购渠道为必填项',
      programmeIsRequired: '计划为必填项',
      startFYIsRequired: '启动财年为必填项',
      landValueMustBeANumber: '土地价值必须是数字',
      landValueIsRequired: '土地价值为必填项',
      propertyInvestmentMustbeANumber: '房地产投资必须是一个数字',
      propertyInvestmentIsRequired: '房地产投资为必填项',
      retailInvestmentMustBeANumber: '零售投资必须是一个数字',
      retailInvestmentIsRequired: '零售投资为必填项',
      retailCostMustbeANumber: '零售成本必须是数字',
      retailCostIsRequired: '零售成本为必填项',
      totalElectricityMustBeANumber: '购电必须是一个数字',
      totalElectricityIsRequired: '购电为必填项',
      gasMustBeANumber: '燃气必须是数字',
      gasIsRequired: '燃气为必填项',
      biofuelsMustBeANumber: '生物燃料必须是一个数字',
      biofuelsIsrequired: '生物燃料为必填项',
      districtHeatMustBeANumber: '集中供暖必须是数字',
      districtHeatIsRequired: '集中供暖为必填项',
      districtCoolingMustBeANumber: '集中供冷必须是数字',
      districtCoolingIsRequired: '集中供冷为必填项',
      generatedkWhMustBeANumber: '生成的千瓦时必须是数字',
      generatedkWhIsRequired: '生成的千瓦时为必填项',
      waterReductionMustBeANumber: '水必须是数字',
      waterReductionIsRequired: '水为必填项',
      wasteReductionMustBeANumber: '填埋的废弃物必须是一个数字',
      wasteReductionIsRequired: '填埋的废弃物为必填项',
      yearlyOperationalCostMustBeANumber: '年度运营成本必须是数字',
      yearlyOperationalCostIsRequired: '年度运营成本为必填项',
      yearlySavingsMustBeANumber: '年度节省必须是数字',
      yearlySavingsCostIsRequired: '年度节省成本为必填项',
      yearlyIncomeMustbeANumber: '年度收入必须是数字',
      yearlyIncomeCostIsRequired: '年度收入/成本为必填项',
      nameIsRequired: '名称为必填项',
      mustBeAValidEmail: '必须是有效的邮箱地址',
      emailIsRequired: '邮箱地址为必填项',
      userMustHaveARole: '用户必须有一个角色',
      userMustHaveAtLeastOneBusinessUnit: '用户必须至少有一个业务单位',
      userMustHaveAtLeastOneCountry: '用户必须至少有一个国家',
      userMustBelongToAtLeastOneCluster: '用户必须至少属于一个大区',
      propertyInvestmentShouldBeMoreThanLandCost:
        '房地产投资（建筑+土地）应大于或等于土地。',
      riskAvoidanceRequired: '风险规避为必填项',
      validationError: '验证失败',
      shouldBeDateFormatProjectStart: '项目开始日期应为 YYYY/MM/DD 格式',
      shouldBeDateFormatProjectEnd: '项目结束日期应为 YYYY/MM/DD 格式',
    },
    solutionPuposes: {
      costsavings: '节约成本',
      businessContinuity: '业务连续性',
      compliance: '合规',
      lifeCycle: '生命周期',
      sustainability: '可持续性',
    },
    solutionTypes: {
      bmsUpgrade: 'BMS升级',
      commercialRepairs: '商业维修',
      energyEfficiency: '能源效率',
      led: '引领',
      facadeRepairs: '外墙维修',
      fuelCell: '燃料电池',
      generators: '发电机',
      hvac: '暖通空调',
      lightingNonLED: '照明（非 LED）',
      parkingRepairs: '停车场维修',
      publicInfrastructureIntervention: '公共基础设施干预',
      photovoltaicPanels: '光伏板',
      restrooms: '洗手间',
      rhc: 'RHC',
      roofRepairs: '屋顶维修',
      structuralUpgradesAndRepairs: '结构升级和维修',
      equipmentReplacementOrUpgrade: '设备更换或升级',
      tradeDressReplacement: '商业外观更换',
      wasteOther: '其它废弃物',
      waterRelatedSystems: '与水相关的系统',
      ecopilot: '生态试行',
      flooringRepairs: '地坪维修',
      safetyAndSecurity: '安全和安保',
      wasteWaterManagement: '废水管理',
      evChargers: '电动汽车充电器',
      legalOrContractual: '法律或合同',
      wasteBaler: '垃圾打包机',
      poweroptimiserEPower: '功率优化器（E-power）',
      energyEnvelopeDoors: '周界门',
      energyEnvelopeRoof: '屋面',
      metering: '计量',
      energyEnvelopeFacade: '保温外墙',
      adaptiveScheduling: '自适应调度和优化',
      'Commercial use': '商业用途',
      'Other Food solution': '其他食品解决方案',
    },
    projectPriorities: {
      critical: '1 - 至关重要的',
      necessary: '2 - 必要的',
      recommended: '3 - 推荐',
    },
    programmes: {
      ecopilot: '生态试行',
      electricVehicles: '电动汽车',
      led: 'LED',
      metering: '计量',
      powerOptimizer: '功率优化器 (E-Power)',
      wasteBalers: '垃圾打包机',
      eVChargers: '电动汽车充电器',
      buildingManagementSystems: '楼宇管理系统 [LEGACY]',
      electricalSystems: '电气系统 [LEGACY]',
      wasteHandling: '废物处理设备 [LEGACY]',
    },
    statuses: {
      UNQUALIFIED: '编辑',
      QUALIFIED: '建议的',
      RETURNED: '回',
      DRAFT: '草稿',
      NOT_STARTED: '没有开始',
      RUNNING: '跑步',
      DELIVERED: '完全的',
      CLOSED: 'Closed',
      CANCELLED: '取消',
      ON_HOLD: '等候接听',
    },
    buTypes: {
      ikeaStore: '宜家商场',
      ikeaSmallStoreS: '宜家S小店',
      ikeaSmallStoreXS: '宜家XS小店',
      ikeaShop: '宜家商店',
      ikeaPlanAndOrderPoint: '宜家规划和订购点',
      ikeaMiniPlanAndOrderPoint: '宜家迷你规划和订购点',
      ikeaPickUpAndOrderPoint: '宜家取货点',
      ikeaPickUpPointBranded: '宜家取货点（品牌）',
      ikeaPickUpPointUnbranded: '宜家取货点（无品牌）',
      ikeaPopUp: '宜家快闪店',
      ingkaCentresShopgMall: '英格卡购物中心 - Shopg 购物中心',
      ingkaCentresRetailPark: '英格卡购物中心 - 零售公园',
      ingkaCentresOutletCentre: '英格卡购物中心 - 奥特莱斯中心',
      customerSupportCentreCSC: '客户支持中心 (CSC)',
      distributionCentreDC: '配送中心 (DC)',
      customerDistributionCentreCDC: '客户配送中心 (CDC)',
      centralParcelUnitCPU: '小件配送中心 (CPU)',
      serviceOffice: '服务办公室',
      externalMerchandisePickUpUnitEMPU: '外部商品取货单位 (EMPU)',
      externalWarehouse: '外部仓库',
      landbank: '土地银行',
      explorationCase: '勘探案例',
      other: '其他',
    },
    plImpact: {
      positive: '正向的',
      negative: '负向的',
    },
    roles: {
      Admin: '管理员',
      FM: '项目创建者',
      OA: '项目提交者',
    },
    status: {
      draft: {
        description: '项目仍处于草稿阶段',
      },
      proposed: {
        description:
          '项目由项目创建者向大区运营负责人提议，以决定是否将项目包含在提交中',
      },
      returned: {
        description: '项目返回项目创建者，根据反馈进行修改',
      },
      submitted: {
        description:
          '提交项目以纳入国家的商业计划，包括Portfolio，购物中心的商业计划',
      },
      planned: {
        description:
          '项目现在在财务计划中，但可能需要根据项目总成本进行额外批准',
      },
      approved: {
        description: '项目已获得额外的适用批准（IR、BC 等），现在可以执行',
      },
      cancelled: {
        description: '项目被取消',
      },
      postponed: {
        description: '项目被推迟或暂缓',
      },
      running: {
        description: '项目正在进行或处于预研究（研究）模式',
      },
      completed: {
        description: '项目完成',
      },
    },
    measurements: {
      kgCo2Ton: 'CO2e 千克/吨',
      kgCo2M3: 'CO2e 千克/立方米',
      kgCo2Kwh: 'CO2e 千克/千瓦时',
    },
    tooltips: {
      reltp: 'Real Estate Long-Term Planning 2.0 Digital Product',
      saveColumns: '保存列选择以适合您的视图',
      reason: '退回项目的原因',
      projects: '典型的 SISAN 项目',
      bulkUpdate: '更新/保存更改',
      businessUnit: '业务单位从 CBD 引入',
      createDraft: '创建项目并将其另存为草稿',
      updateProject: '更新/保存项目详细信息',
      changeStatus: '更改项目状态',
      mergeByReferenceID: '如果项目要与另一个项目合并，请单击此处',
      removeFromSubmission: '项目被发送回提交屏幕本身的队列',
      sendToArchive: '项目已归档',
      fillTheRestAndPropose: '填写剩余项目信息并提出作为可能的候选人提交',
      createDraftProject: '创建项目并将其另存为草稿',
      fiscalYear: '例如：FY24财年为 2023 年 9 月 1 日至 2024 年 8 月 31 日',
      returnMessage: '退回项目的原因',
      projectResources: '执行项目所需的资源',
      updateAndPropose: '更新/保存更改并建议作为可能的候选提交',
      updateAndApprove: '更新/保存选择并批准项目',
      requestChanges: '从提交屏幕中删除项目并请求项目创建者对项目进行更改',
      pushToEtr: '将选定的项目推送到 ETR',
      etrSync: '提交已与 ETR 同步',
      notEtrSync: '提交未与 ETR 同步',
      mergeProjects:
        '合并项目仅通过引用参考 ID 将一个或多个项目链接到另一个，而不合并实际项目数据',
      additionalApproval: '投资组合项目需要额外的批准，可以从以下选项中选择',
      totalProjectInvestmentCostDescription:
        '这是基于 CAFM 重置成本数据，仅供参考',
      annualCostImpactNetEUR: '不包括折旧',
      benefitsAndRisk: '根据其他字段自动生成',
      annualPAndLImpact: '年度对于P&L的影响（包含折旧）',
      annualCostImpactNet: '年度净成本影响，但不包括折旧',
      referenceID: 'RELTP 2.0 中系统生成的唯一项目参考 ID',
      locationBasedCO2: '根据 Sustain supersuer在 RELTP 2.0 中设置的因子计算',
      ingkaClimateFootprintCalculated: '通过Sustain工具计算',
      payback: '把项目总投资拆分为年度成本影响计算的净值',
      localUniqueId:
        '为项目添加本地国家/地区唯一 ID 的字段（RELTP 1.0 中的“项目编号”字段，例如在法国等市场中）',
      projectName: '已创建项目的名称',
      additionalInformation: '有关该项目的附加信息',
      priority: '项目优先级',
      SISANDimensionSolutionPurpose: '项目的SISAN解决方案目的',
      solutionType: '项目的解决方案类型',
      sourceChannel: '项目的采购渠道',
      removeAsset: '从项目中移除资产',
      programmeStatus: '选择计划是否适用于该项目',
      replaceAssets: '更换选定的资产',
      landCost: '项目土地成本',
      programmeName: '选择计划名称',
      assetQuantity: '请注明新增资产数量',
      propertyInvestmentBuilding: '项目的房地产投资',
      retailInvestment: '项目的零售投资',
      retailCost: '项目的零售成本',
      'recurringYearlyOperationalCost:': '项目的经常性年度运营成本',
      recurringYearlySavings: '项目的经常性年度节省',
      asset: '请指定资产组',
      depreciationCalculated: '项目的折旧计算值',
      addAsset: '将资产添加到项目',
      potentialYearlyIncome: '项目的潜在年度收入',
      addNewAsset: '添加新资产',
      replaceAsset: '从列表中更换现有资产',
      riskAvoidance: '请为项目设置风险规避',
      totalElectricity: '项目总用电量',
      naturalGas: '项目用的天然气',
      bioFuel: '该项目的生物燃料',
      districtHeat: '项目的集中供暖',
      districtCooling: '项目的集中供冷',
      electricityGenerated: '项目的发电量',
      waterReduction: '项目的减水量',
      wasteReduction: '项目减少废弃物的量',
      createAndPropose: '创建项目并作为候选提交项目提议',
      discard: '放弃更改并关闭',
      openNotifications: '打开通知菜单',
      changeLanguage: '更改应用程序的语言',
      update: '更新/保存项目',
      createProject: '创建项目',
      edit: '编辑多个项目',
      delete: '删除选定的项目',
      copy: '复制',
      revertFromArchive: '从存档中恢复项目',
      BulkCreateProject: '一次创建多个项目',
      countrySelectArchive: '选择国家以查看该国家的存档项目',
      createProjectsFromCafmAssets: '从CAFM资产创建项目',
      fySelectFlight: '选择财政年度以查看该年度的提交',
      countrySelectFlight: '选择国家以查看来自该国家/地区的提交',
      makeSubmission: '创建提交',
      addToSubmission: '将项目添加到当前提交',
      submissionName: '新创建的提交的名称',
      archiveTab: '按Tab以查看存档项目',
      submissionTab: '按Tab以查看提交',
      projectsTab: '按Tab以管理提交',
      projectsPageBUSelect: '选择业务单位以查看它的项目',
      filterAll: '单击打开过滤器模式',
      filterRetail: '单击以按零售Portfolio筛选项目',
      filterRetailCountry: '单击以按零售Country/Unit筛选项目',
      filterCentre: '单击以按购物中心过滤项目',
      totalInvestmentByType: '每种项目类型的总投资额',
      actionCategory: '请选择行动类别',
      BulkCreateFromProject: '从选定的项目创建新项目',
      etrPriority: 'ETR 给予的优先级',
      bulkExistingProject: '此项目已存在且处于编辑模式',
      bulkExistingApprovedProject: '已批准的项目无法在此页面编辑',
      unitType: '',
      resetColumns: '',
    },
    approval: {
      irApproved: 'IR已批准',
      businessCaseApproved: 'Business Case已批准',
    },
    notApplicable: '不适用/不需要Business Case批准',
    privacy: {
      title: '隐私声明',
      header:
        '当您使用 RELTP 2.0 时，英格卡集团公司数据管理者（定义如下）将收集有关您的某些个人数据。',
      personalDataBold: '收集的个人资料是：',
      personalData: '工作邮箱地址、名和姓',
      purposeBold: '收集这些数据的目的是：',
      purpose:
        '为确保用户的责任和活动记录，在 RELTP2.0 中，我们保存了同事的姓名和邮箱地址，因为我们需要知道谁创建了项目以及对项目执行操作的历史记录。',
      legalBold: '处理的法律依据是：',
      legal: '数据管理者为其员工提供必要工具和应用程序的合法利益。',
      dataBold: '数据将被存储于：',
      data: '数据将一直保存到员工离开宜家的日期',
      controllerBold: '处理个人数据的数据管理者是：',
      controller: 'IKEA Limited',
      footer:
        '您的个人数据可能会与英格卡集团的其他公司以及英格卡集团的服务提供商共享，旨在为RELTP 2.0 提供有效信息',
      rights:
        '您拥有与您的个人相关的某些权利。了解更多有关此类权利的信息，请访问',
    },
    actionCategories: {
      water: '水',
      energy: '能量',
      waste: '废弃物',
      na: 'N/A',
    },
    projectETRPriorities: {
      A: '高',
      B: '中',
      C: '低',
    },
  },
  fr: {
    sustainFactors: {
      updateSustainRates: 'Mettre à jour les taux de maintien',
      sustainFactorsPage: 'Page Facteurs de maintien',
      properties: {
        countryName: 'Nom du pays',
        electricityPurchasedMarketBased: '',
        electricityChange: 'Électricité achetée',
        districtHeating: 'Chauffage urbain',
        gas: 'Gaz',
        districtCooling: 'Refroidissement urbain',
        bioFuel: 'Biocarburant',
        electricityGenerated: 'Électricité générée',
        water: 'Eau',
        waste: 'Déchets à la décharge',
      },
    },
    common: {
      id: 'IDENTIFIANT',
      reltp: 'RELTP FR 2.0',
      saveColumns: 'ENREGISTRER LES COLONNES',
      returnedNotification: 'revenu!',
      requiredField: 'champs requis',
      actions: 'Actions',
      reason: 'Raison',
      projects: 'Projets',
      confirm: 'Confirmer',
      quantity: 'Quantité',
      fy: 'AF',
      country: 'Pays',
      total: 'Total',
      email: 'E-mail',
      role: 'Rôle',
      bulkUpdate: 'Mise à jour',
      businessUnit: 'Unité commerciale',
      countryCode: 'Code postal',
      createDraft: 'Créer un brouillon',
      changeStatus: 'Modifier le statut',
      mergeByReferenceID: 'Fusionner par ID de référence',
      removeFromSubmission: 'Supprimer de la soumission',
      sendToArchive: 'Envoyer aux archives',
      fillTheRestAndPropose: 'Remplissez le reste et proposez',
      createDraftProject: 'Créer un brouillon de projet',
      fiscalYear: 'Exercice fiscal',
      view: 'Vue',
      returnMessage: 'Message de retour',
      projectResources: 'Ressources du projet',
      updateAndPropose: 'Mettre à jour et proposer',
      updateAndApprove: 'Mettre à jour et approuver',
      viewProject: 'Voir le projet',
      updateProject: 'Mettre à jour le projet',
      update: 'Mettre à jour',
      hours: 'Heures',
      name: 'Nom',
      delete: 'Effacer',
      archive: 'Archiver',
      discard: 'Jeter',
      cancel: 'Annuler',
      warning: 'Avertissement',
      deleteTheseProjects: 'Voulez-vous vraiment supprimer ces projets ?',
      archiveTheseProjects: 'Voulez-vous vraiment archiver ces projets ?',
      bulkEdit: 'Modification groupée',
      loadingMsg: {
        checkingYourPermissions: 'Vérification de vos autorisations',
      },
      totalEUR: 'Total en euros',
      areYouSure: 'Êtes-vous sûr?',
      discardConfirmationMessage:
        'Vous avez apporté des modifications, voulez-vous les supprimer et fermer le modal ?',
      revertFromArchive: `Rétablir l'archive`,
      bulk: 'En gros',
      close: 'proche',
      resetColumns: '',
    },
    appBar: {
      openSettings: 'Ouvrir les paramètres',
      mobileMenu: {
        accountOfCurrentUser: `compte de l'utilisateur actuel`,
      },
      notificationMenu: {
        noNotifications: 'Aucune notification',
        new: 'Nouveau',
        returnedProjects: 'Projets retournés',
        showOldNotifications: 'Afficher les anciennes notifications',
        plannedProjects: 'Projets prévus',
      },
      navigation: {
        submissiontTab: 'Soumission',
        archiveTab: 'Archive',
        projectsTab: 'Projets',
      },
      countrySelect: {
        chooseCountry: 'Choisissez un pays',
      },
    },
    login: {
      loginMessages: 'Vous connecter',
    },
    projects: {
      manageProjects: 'Gérer des projets',
      createProject: 'Créer un projet',
      bulkCreateProject: 'Créer des projets en masse',
      replaceCafmAssets: 'Remplacer les actifs CAFM',
      returned: 'Retourné',
      totalProjects: 'Total des projéts',
      projectsAvailableForUser: `Tous les projets disponibles pour l'utilisateur`,
      asset: 'Actif',
      archiveProject: `Projet d'archivage`,
      changeProjectStatus: 'Modifier le statut du projet',
      newStatus: 'Nouveau statut',
      assets: 'Les actifs',
      requestChanges: 'Demander des modifications',
      pushToEtr: 'Transférer vers ETR',
      etrSync: 'Synchronisé avec ETR',
      notEtrSync: 'Non synchronisé avec ETR',
      notSyncedWithEtrMessage: `ETR a une version différente de ce projet que celle de RELTP. Veuillez vous aligner avec l'utilisateur RE pour pousser les dernières modifications de RELTP vers ETR, avant d'approuver ce projet`,
      mergeProjects: 'Fusionner des projets',
      additionalApproval: 'Approbations supplémentaires',
      properties: {
        totalProjectInvestmentCostDescription: `L'investissement total du projet doit être au moins égal à`,
        projectsSelected: 'Projets sélectionnés',
        additionalApprovalBody: `Le projet est maintenant à l'état Planifié. Avez-vous obtenu des approbations supplémentaires ?`,
        additionalApprovalWarningSwitch:
          'Vous êtes sur le point de faire passer le statut du projet à Approuvé',
        additionalApprovalRequired: 'Approbation supplémentaire requise',
        totalInvestment: 'Investissement total',
        districtHeatNetKwh: 'Chauffage urbain Kwh net',
        depreciationAccount: `Compte d'amortissement`,
        cpmFm: 'CPM FM',
        annualCostImpactNetEUR: 'Impact sur les coûts annuels net EUR',
        totalInvestmentEUR: 'Investissement total EUR',
        investmentAmount: `Coût d'investissement`,
        status: 'Statut',
        bioFuelsNetKwh: 'Biocarburants Kwh Net',
        projectInfo: 'Informations sur le projet',
        retailCost: 'Coût Retail',
        benefitsAndRisk: 'Avantages et risques',
        riskAvoidance: 'Prévention des risques',
        riskAvoidancePlaceholder:
          'Quel serait le risque de ne pas réaliser ce projet ?',
        depreciation: 'Dépréciation',
        paybackYears: 'Amortissement (années)',
        annualPAndLImpact: 'Impact annuel sur le P&L',
        recurringYearlySavings: 'Économies annuelles récurrentes',
        operationalCost: 'Le coût opérationnel',
        totalInvestments: 'Investissements totaux',
        land: 'Terrain',
        benefitsAndRisks: 'Avantages et risques',
        additionalInformation: 'Informations Complémentaires',
        projectName: 'Nom du projet',
        businessUnitFullName: 'Nom du site',
        projectStatus: 'Statut du projet',
        totalProjectInvestmentEUR: 'Investissement total du projet EUR',
        annualCostImpactNet: 'Impact net sur les coûts annuels',
        biofuelsNetKwh: 'Biocarburants NetKwh',
        co2eNet: 'Co2e net',
        etrprojectID: 'ID ETR du projet',
        etrSolutionID: 'ID ETR de la solution',
        etrUnitID: `ID ETR d'unité`,
        unifierID: 'ID Unifier',
        clusterFMSpecialist: 'Spécialiste FM Cluster',
        districtFM: 'District FM',
        responsiblLead: 'Responsable (leader)',
        unitFM: 'FM du site',
        cpm: 'CPM',
        assetManagement: 'Gestion des actifs',
        externalPM: 'PM externe',
        referenceID: 'Numéro de référence',
        projectID: 'Numéro de projet',
        etrID: 'Numéro ETR',
        projectAssets: 'Actifs du projet',
        bu: 'BU',
        landCost: 'Coût du terrain',
        solutionPurpose: 'Objectif de la solution',
        solutionType: 'Type de solutions',
        startDate: 'Date de début',
        completionDate: `Date d'achèvement`,
        landCG1: 'Terrain (CG1)',
        landCG1EUR: 'Terrain (CG1) EUR',
        propertyInvestmentCG111: 'Investissement immobilier (CG1-11)',
        propertyInvestmentCG111EUR: 'Investissement immobilier (CG1-11) EUR',
        retailCostCG1516: 'Coût Retail (CG15-16)',
        retailCostCG1516EUR: 'Coût Retail (CG15-16) EUR',
        accountable: 'Responsable',
        priority: 'Priorité',
        annualCostImpact: 'Impact sur les coûts annuels',
        currency: 'Devise',
        engineer: 'Ingénieur',
        portfolio: 'Portefeuille',
        potentialYearlyIncome: 'Revenu annuel potentiel',
        projectStartFiscalYear: 'Année fiscale de début du projet',
        projectCompletionFiscalYear: `Année fiscale d'achèvement du projet`,
        recurringYearlyOperationalCost: 'Coût opérationnel annuel récurrent',
        retailInvestmentCG1214: 'Investissement Retail (CG12-14)',
        retailInvestmentCG1214EUR: 'Investissement Retail (CG12-14) EUR',
        unitType: `Type d'unité`,
        updatedAt: 'Mis à jour à',
        co2eSociety: 'Co2e Société',
        createdBy: 'Créé par',
        propertyInvestment: 'Investissement immobilier',
        totalElectricity: 'Électricité achetée',
        retailInvestment: 'Investissement Retail',
        sustainID: 'ID Sustain',
        additionalInformationProject:
          'Informations supplémentaires (contexte du projet)',
        mergedWithProject: 'Fusionné avec le projet',
        programmeName: 'Nom du programme',
        programmeStatus: 'Programme O/N',
        projectCompletionFY: `Année fiscale de l'Accomplissement du projet`,
        projectEndFY: 'Année fiscale de la Fin du projet',
        projectStartFY: 'Année fiscale du Début du projet',
        SISANDimensionSolutionPurpose:
          'Dimension SISAN (objectif de la solution)',
        totalProjectInvestment: 'Investissement total du projet',
        LandCG01: 'Terrain (CG01)',
        propertyInvestmentBuilding:
          'Investissement immobilier (bâtiment + terrain) (CG01-11)',
        bioFuel: 'Biocarburant',
        districtCooling: 'Refroidissement urbain',
        districHeat: 'Chauffage urbain',
        naturalGas: 'Gaz naturel',
        electricityGenerated: 'Électricité générée',
        locationBasedCO2: `CO2 en fonction de la localisation (sur la base des facteurs d'émission moyens du pays)`,
        ingkaClimateFootprintCalculated: `Empreinte climatique d'Ingka (facteurs d'émission réels du site basés sur le marché)`,
        wasteReduction: 'Déchets mis en décharge',
        waterReduction: 'Eau',
        netkWh: 'kWh nets',
        pnlImpact: 'Impact PnL',
        depreciationAmount: `Montant de l'amortissement`,
        depreciationEur: 'Amortissement en euros',
        districtCoolingNetKwh: 'Kwh net de refroidissement urbain',
        districtFm: 'Fm de district',
        etrProjectId: 'ID de projet ETR',
        etrSolutionId: 'ID de solution ETR',
        etrUnitId: `ID d'unité Etr`,
        externalContractorsNeeded: 'Entrepreneurs externes nécessaires',
        gasNetKwh: 'Gaz Net Kwh',
        generatedNetKwh: 'Kwh net généré',
        impactYear1: `Année d'impact1`,
        impactYear1Eur: 'impact Année1Eur',
        legalUnit: 'Unité juridique',
        mtoolId: 'Identifiant Mtool',
        co2e: 'Co2e',
        operationalCostEUR: 'Coût opérationnel EUR',
        plImpactAccount: 'Compte Pl Impact',
        plImpactAmountPerAccount: 'Pl Impact Montant Par Compte',
        potentialYearlyIncomeEUR: 'Revenu Annuel Potentiel EUR',
        realEstateDevelopment: 'Développement immobilier',
        recurringYearlyOperationalCostEUR:
          'Coût opérationnel annuel récurrent EUR',
        recurringYearlySavingsEUR: 'Économies annuelles récurrentes EUR',
        payback: 'Remboursement',
        referenceId: `Pièce d'identité`,
        sustainId: 'Identifiant de maintien',
        totalElectricityNetKwh: 'Électricité achetée Net Kwh',
        unifierId: `Identifiant de l'unificateur`,
        unitCategory: `Catégorie d'unité`,
        unitFm: 'Unité Fm',
        wasteReductionT: 'Réduction des déchets (t)',
        waterReductionM3: `Réduction d'eau (m3)`,
        pnLImpact: 'Impact PNL',
        projectMergeWithProjectReferenceId: `Projet fusionné avec (Entrez l'ID de référence du projet)`,
        localUniqueId: '',
        changeProjectMessage: `Vous êtes sur le point de modifier l'année de début et de fin du projet  qui a déjà été ajoutée à la dernière soumission (l'ID M-Tool est créé et le statut du projet est approuvé). Veuillez choisir parmi les étapes suivantes possibles ci-dessous`,
        projectEndDate: 'Date de fin du projet',
        projectStartDate: 'Date de début du projet',
        actionCategory: `Catégorie d'action`,
        budgeting: 'Budgétisation (Russie uniquement)',
        subcategory: 'Sous-catégorie (Russie uniquement)',
        etrPriority: 'Priorité ETR',
      },
      hintMessage: {
        chooseABU: 'Choisissez une BU',
        chooseBUs: 'Choisissez les BU',
      },
      create: {
        projectInvestment: 'Investissement de projet',
        opexImpact: `Incidence sur les dépenses d'exploitation`,
        energyInformation: `Informations sur l'énergie`,
        createAndPropose: 'Créer et proposer',
        riskAvoidance: 'Évitement des risques',
        descriptionForEnergyInformation:
          'Entrez les changements annuels générés par le projet avec des réductions comme valeurs négatives',
        generalForm: {
          startFyIsBiggerErrorMessage: `L'exercice de début est supérieur à l'exercice de fin`,
          hintMessage: {
            additionalProjectInformationErrorMessage: `Nombre d'unités remplacées de pièces spécifiques remplacées ou de noms de marque liés aux remplacements etc.`,
          },
        },
        opexForm: {
          positivePAndLImpact: 'Impact positif sur le compte de résultat',
          negativePAndLImpact: 'Impact négatif sur le compte de résultat',
          savingAsNegative:
            'IMPORTANT : saisissez les économies sous forme de nombre négatif',
          depreciationCalculated: 'Amortissement - CALCULÉ',
          annualCostImpactCalculation:
            'Impact sur les coûts annuels net - CALCULÉ',
          paybackYearsCalculated: 'Amortissement (Années) - CALCULÉ',
          paybackYears: 'Amortissement (années)',
          annualPAndLImpactCalculated: 'Impact P&L annuel - CALCULÉ',
          annualPAndLImpact: 'Impact annuel sur le P&L',
        },
      },
      userModal: {
        userBusinessUnits: 'Unités commerciales utilisateur',
        userClusters: `Groupes d'utilisateurs`,
        userCountry: `Pays de l'utilisateur`,
      },
      createProjectsFromCafmAssets:
        'Créer des projets à partir des actifs CAFM',
    },
    bulkCreate: {
      createProjects: 'Créer des projets',
      editProjects: 'Modifier les projets',
      table: {
        removeRow: 'Supprimer la ligne',
        copyRow: 'Copier la ligne',
        addNewRow: 'Ajouter une nouvelle ligne',
      },
      investmentModal: {
        projectInvestments: 'Investissements de projet',
        updateInvestments: 'Mettre à jour les investissements',
      },
      createDraftProjects: 'Créer des brouillons de projet(s)',
    },
    flight: {
      makeSubmission: 'Faire une soumission',
      retailPortfolio: 'Portefeuille de vente au détail',
      retailCountryUnit: 'Pays/unité de vente au détail',
      centres: 'Centres',
      newInfo: 'Nouvelles informations',
      projectsQueue: `File d'attente des projets`,
      boarded: 'Embarquement',
      submitted: 'Ajouté à la soumission',
      loadingProjects: 'Chargement des projets',
      noProjectsAvailable: 'Aucun projet disponible',
      addToSubmission: 'Ajouter à la soumission',
      noSubmissionsForAGivenCountry: 'Aucune soumission pour un pays donné',
      submission: {
        flightSubmissionTableNewInfo:
          'Projets qui doivent être examinés parce que les données ont été mises à jour après la soumission précédente',
        flightSubmissionTableBoarded:
          'Projets inclus dans la soumission actuelle',
        flightSubmissionTableQueue:
          'Examinez et choisissez les projets qui seront inclus dans la soumission actuelle ou demandez des modifications au créateur du projet',
        flightSubmissionTableReturned:
          'Projets dont on a demandé la modification',
      },
      submissionHeader: {
        submissionFinancialCard: {
          exportReport: `Rapport d'exportation`,
        },
      },
      createSubmissionModal: {
        createSubmission: 'Créer une soumission',
        submissionName: 'Nom de la soumission',
        sendToETR: 'Envoyer à ETR',
      },
      newInfoModal: {
        info: 'Info',
        projectDataWasUpdated: 'Les données du projet ont été mises à jour',
        dataUpdateTable: {
          loadingMessage: 'Chargement des modifications',
          noPreviousValue: 'Aucune valeur précédente',
        },
      },
      revertProjectModal: {
        revertProjects: 'Rétablir les projets',
        revertToDraft: 'Revenir au brouillon',
        projectsRevertedToDraftStatus:
          'Projets qui seront rétablis au statut de brouillon',
        bulkCommentForRevertedProjects:
          'Commentaire groupé pour les projets annulés',
      },
      table: {
        tootTips: {
          projectDataWasChangedClickToViewDetails:
            'Les données du projet ont été modifiées. Cliquez pour afficher les détails.',
          boardedProject: 'Projet embarqué',
        },
      },
    },
    user: {
      properties: {
        cluster: 'Cluster',
        userName: `Nom d'utilisateur`,
      },
    },
    admin: {
      adminPage: `Page d'administration`,
      updateUser: `Mettre à jour l'utilisateur`,
      addUser: 'Ajouter un utilisateur',
    },
    currency: {
      currencyPage: 'Devise',
      updateCurrencyRates: 'Mettre à jour les taux de change',
      currencyTable: {
        currencyCode: 'Code de devise',
        currencyRate: 'Cours des devises',
      },
    },
    filter: {
      allFilters: 'Tous les filtres',
      projectsFilters: 'Filtres de projets',
      clearFilters: 'Effacer les filtres',
    },
    assets: {
      addNewAsset: 'Ajouter un nouvel actif',
      addAsset: 'Ajouter un élément',
      manufacturerModelYear: 'Fabricant,  modèle,  année etc…',
      properties: {
        assetDescription: `Description de l'actif`,
        endDate: 'Date de fin',
        replacementCost: 'Coût de remplacement',
        manufacturer: 'Fabricant',
        model: 'Modèle',
        organization: 'Organisation',
        unitId: `Identifiant de l'unité`,
        assetGroup: `Groupe d'actifs`,
        replaceAssetsDescription: `Les actifs sont classés selon leur date de fin de vie dans CAFM. Veuillez choisir les actifs que vous souhaitez remplacer dans votre BU. Vous pouvez également rechercher les actifs en fonction de la description de l'actif.`,
      },
      replaceAsset: {
        cafmAssetsErrorMsg: `Il n'y a pas d'actifs CAFM pour la BU sélectionnée`,
        replaceAssets: 'Remplacer les actifs',
      },
    },
    snackbarMessages: {
      sustainFactorsUpdated:
        'Les facteurs de maintien ont été mis à jour avec succès',
      sustainFactorsUpdateError:
        'Impossible de mettre à jour les facteurs de maintien',
      fetchProjectError: 'Problème pour obtenir des projets',
      projectCreated: 'Projet créé',
      couldNotCreateProject: 'Impossible de créer le projet',
      projectsSuccessfullyCreated: 'Projets créés avec succès',
      couldNotCreateProjects: 'Impossible de créer des projets',
      projectUpdated: 'Projet mis à jour',
      projectCouldNotBeUpdated: `Le projet n'a pas pu être mis à jour`,
      couldNotFetchAssets: 'Impossible de récupérer les éléments',
      couldNotFetchCafmAssets: 'Impossible de récupérer les actifs Cafm',
      couldNotFetchUsers: 'Impossible de récupérer les utilisateurs',
      updatedUserSuccessfully: 'Utilisateur mis à jour avec succès',
      deletedUserSuccessfully: '',
      couldNotDeleteUser: '',
      couldNotUpdateUser: `Impossible de mettre à jour l'utilisateur`,
      projectsStatusesWereUpdated: 'Les statuts des projets ont été mis à jour',
      couldNotUpdateProjectsStatuses:
        'Impossible de mettre à jour les statuts des projets',
      problemGettingBusinessUnits: `Problème d'obtention des unités commerciales`,
      problemGettingUserData: `Problème d'obtention des données utilisateur`,
      problemGettingFlightData: `Problème d'obtention des données de vol`,
      couldNotCreateNewSubmission:
        'Impossible de créer une nouvelle soumission',
      couldNotFetchArchiveData: `Impossible de récupérer les données d'archive`,
      couldNotSendProjectsToArchive: `Impossible d'envoyer les projets à archiver`,
      couldNotFetchProjectChanges:
        'Impossible de récupérer les modifications du projet',
      couldNotFetchCurrencyData:
        'Impossible de récupérer les données de devise',
      successfullyUpdatedCurrencyRates: 'Taux de change mis à jour avec succès',
      couldNotUpdateCurrencyData:
        'Impossible de mettre à jour les données de devise',
      problemGettingUpdatedProjects:
        'Problème lors de la mise à jour des projets',
      couldNotMergeProjects: 'Impossible de fusionner les projets',
      couldNotFetchSustainFactors:
        'Impossible de récupérer les facteurs de maintien',
      successfullyUpdatedSustainFactors:
        'Facteurs de maintien mis à jour avec succès',
      successfullyUpdatedProjects: 'Les projets ont été mis à jour avec succès',
      couldNotUpdateProjects: 'Impossible de mettre à jour les projets',
      cannotEditApprovedOrPlannedProjects: `Certains projets ont été supprimés de la modification en masse car ils ont un ID d'outil M et ont été approuvés ou planifiés`,
      problemToAddArchived:
        'Certains des projets sélectionnés ne peuvent pas être archivés car ils ont un identifiant M-Tool',
      problemPushToEtr: 'Erreur lors de la poussée vers etr',
      successPushToEtr:
        'Les articles seront synchronisés avec ETR dans quelques minutes',
      projectsUnArchived: `Les projets ont été déplacés de l'archive avec succès`,
      projectsUnArchivedError: `impossible de déplacer les projets de l'archive`,
    },
    validationMessages: {
      projectNameIsRequired: 'Le nom du projet est requis',
      buIsRequired: 'BU est requis',
      additionalInformationIsRequired:
        'Des informations supplémentaires sont requises',
      benefitsAndRiskIsRequired: 'Avantages et risques est requis',
      priorityIsRequired: 'La priorité est requise',
      solutionPurposeIsRequired: `L'objectif de la solution est requis`,
      solutionTypeIsRequired: 'Le type de solution est requis',
      completionFYIsRequired: `La fin de l'exercice est requise`,
      sourceChannelIsRequired: 'Le canal source est requis',
      programmeIsRequired: 'Le programme est requis',
      startFYIsRequired: `L'exercice de début est requis`,
      landValueMustBeANumber:
        'La valeur concernant le terrain doit être renseignée sous format de nombre',
      landValueIsRequired: 'La valeur du terrain est requise',
      propertyInvestmentMustbeANumber: `L'investissement immobilier doit être un sous format  "nombre"`,
      propertyInvestmentIsRequired: 'Un investissement immobilier est requis',
      retailInvestmentMustBeANumber: `L'investissement Retail doit être sous format de "nombre"`,
      retailInvestmentIsRequired: 'Un investissement de détail est requis',
      retailCostMustbeANumber: 'Le coût de vente doit être un nombre',
      retailCostIsRequired: 'Le coût de détail est requis',
      totalElectricityMustBeANumber: `L'électricité achetée doit être un nombre`,
      totalElectricityIsRequired: `L'électricité achetée est requise`,
      gasMustBeANumber: 'Le gaz doit être un nombre',
      gasIsRequired: 'Le gaz est nécessaire',
      biofuelsMustBeANumber: 'Les biocarburants doivent être un nombre',
      biofuelsIsrequired: 'Les biocarburants sont nécessaires',
      districtHeatMustBeANumber: 'Le chauffage urbain doit être un nombre',
      districtHeatIsRequired: 'Le chauffage urbain est requis',
      districtCoolingMustBeANumber:
        'Le refroidissement urbain doit être un nombre',
      districtCoolingIsRequired: 'Le refroidissement urbain est requis',
      generatedkWhMustBeANumber: 'Les kWh générés doivent être un nombre',
      generatedkWhIsRequired: 'Le kWh généré est requis',
      waterReductionMustBeANumber: `L'eau doit être un nombre`,
      waterReductionIsRequired: `L'eau est nécessaire`,
      wasteReductionMustBeANumber:
        'Les déchets à enfouir doivent être un nombre',
      wasteReductionIsRequired:
        'La mise en décharge des déchets est obligatoire',
      yearlyOperationalCostMustBeANumber:
        'Le coût opérationnel annuel doit être un nombre',
      yearlyOperationalCostIsRequired: 'Le coût opérationnel annuel est requis',
      yearlySavingsMustBeANumber:
        'Les économies annuelles doivent être un nombre',
      yearlySavingsCostIsRequired: 'Le coût des économies annuelles est requis',
      yearlyIncomeMustbeANumber: 'Le revenu annuel doit être un nombre',
      yearlyIncomeCostIsRequired: 'Le coût du revenu annuel est requis',
      nameIsRequired: 'Le nom est requis',
      mustBeAValidEmail: 'Merci de renseigner un email valide',
      emailIsRequired: `L'e-mail est requis`,
      userMustHaveARole: `L'utilisateur doit avoir un rôle`,
      userMustHaveAtLeastOneBusinessUnit: `L'utilisateur doit avoir au moins une unité commerciale`,
      userMustHaveAtLeastOneCountry: `L'utilisateur doit avoir au moins un pays`,
      userMustBelongToAtLeastOneCluster: `L'utilisateur doit appartenir à au moins un cluster`,
      propertyInvestmentShouldBeMoreThanLandCost: `L'investissement immobilier (bâtiment + terrain) doit être supérieur ou égal au terrain.`,
      riskAvoidanceRequired: `L'évitement des risques est nécessaire`,
      validationError: 'La validation a échoué',
      shouldBeDateFormatProjectStart:
        'La date de début du projet doit être au format AAAA/MM/JJ',
      shouldBeDateFormatProjectEnd:
        'La date de fin du projet doit être au format AAAA/MM/JJ',
    },
    solutionPuposes: {
      costsavings: 'Économies de coûts',
      businessContinuity: `Continuité de l'activité`,
      compliance: 'Conformité',
      lifeCycle: 'Cycle de la vie',
      sustainability: 'Développement durable',
    },
    solutionTypes: {
      bmsUpgrade: 'Mise à niveau GTB',
      commercialRepairs: 'Réparations commerciales',
      energyEfficiency: 'Efficacité énergétique',
      led: 'LED',
      facadeRepairs: 'Réfection de façade',
      fuelCell: 'Pile à combustible',
      generators: 'Générateurs',
      hvac: 'CVC',
      lightingNonLED: 'Foudre (non LED)',
      parkingRepairs: 'Réparations parking',
      publicInfrastructureIntervention:
        'Intervention sur les infrastructures publiques',
      photovoltaicPanels: 'Panneaux photovoltaïques',
      restrooms: 'TOILETTES',
      rhc: 'RHC',
      roofRepairs: 'Réparations de toiture',
      structuralUpgradesAndRepairs:
        'Mises à niveau et réparations structurelles',
      equipmentReplacementOrUpgrade: `Remplacement ou mise à niveau d'équipement`,
      tradeDressReplacement: 'Remplacement de la robe commerciale',
      wasteOther: 'Déchets autres',
      waterRelatedSystems: `Systèmes liés à l'eau`,
      ecopilot: 'Écopilote',
      flooringRepairs: 'Réparations de revêtements de sol',
      safetyAndSecurity: 'Sûreté et sécurité',
      wasteWaterManagement: 'Gestion des eaux usées',
      evChargers: 'Bornes de recharges Véhicules électriques',
      legalOrContractual: 'Légal ou contractuel',
      wasteBaler: 'Presse à déchets',
      poweroptimiserEPower: 'Optimiseur de puissance (E-power)',
      energyEnvelopeDoors: 'Portes enveloppe énergétique',
      energyEnvelopeRoof: 'Toiture à enveloppe énergétique',
      metering: 'Mesure',
      energyEnvelopeFacade: 'Façade enveloppe énergétique',
      adaptiveScheduling: 'Planification adaptative et optimisation',
      'Commercial use': 'Usage commercial',
      'Other Food solution': 'Autre solution alimentaire',
    },
    projectPriorities: {
      critical: '1 - Critical',
      necessary: '2 - Necessary',
      recommended: '3 - Recommended',
    },
    programmes: {
      ecopilot: 'Écopilote',
      electricVehicles: 'Véhicules électriques',
      led: 'LED',
      metering: 'Mesure',
      powerOptimizer: 'Optimiseur de puissance (E-Power)',
      wasteBalers: 'Presses à déchets',
      eVChargers: 'Bornes de recharges Véhicules électriques',
      buildingManagementSystems: 'Systèmes de gestion des bâtiments [LEGACY]',
      electricalSystems: 'Systèmes électriques [LEGACY]',
      wasteHandling: 'Équipement de traitement des déchets [LEGACY]',
    },
    statuses: {
      UNQUALIFIED: 'Modifier',
      QUALIFIED: 'Proposé',
      RETURNED: 'Revenu',
      DRAFT: 'Brouillon',
      NOT_STARTED: 'Pas commencé',
      RUNNING: `En cours d'exécution`,
      DELIVERED: 'Complété',
      CLOSED: 'Closed',
      CANCELLED: 'Annulé',
      ON_HOLD: 'En attente',
    },
    buTypes: {
      ikeaStore: 'Magasin IKEA',
      ikeaSmallStoreS: 'Petit magasin IKEA S',
      ikeaSmallStoreXS: 'Petit magasin IKEA XS',
      ikeaShop: 'Boutique IKEA',
      ikeaPlanAndOrderPoint: 'iKEA Plan and Order Point',
      ikeaMiniPlanAndOrderPoint: 'IKEA Mini Plan and Order Point',
      ikeaPickUpAndOrderPoint: 'Point de ramassage et de commande IKEA',
      ikeaPickUpPointBranded: 'Point de retrait IKEA (de marque)',
      ikeaPickUpPointUnbranded: 'Point de retrait IKEA (sans marque)',
      ikeaPopUp: 'Pop-up IKEA',
      ingkaCentresShopgMall: 'Centres Ingka - Shopg Mall',
      ingkaCentresRetailPark: 'Centres Ingka - Retail Park',
      ingkaCentresOutletCentre: 'Centres Ingka - Outlet Center',
      customerSupportCentreCSC: `Centre d'assistance à la clientèle (CSC)`,
      distributionCentreDC: 'Centre de distribution (DC)',
      customerDistributionCentreCDC: 'Centre de distribution client (CDC)',
      centralParcelUnitCPU: 'Central Parcel Unit (CPU)',
      serviceOffice: 'Bureau des services',
      externalMerchandisePickUpUnitEMPU:
        'Unité Externe de Collecte de Marchandises (EMPU)',
      externalWarehouse: 'Entrepôt externe',
      landbank: 'Landbank',
      explorationCase: `Cas d'exploration`,
      other: 'Autre',
    },
    plImpact: {
      positive: 'Positif',
      negative: 'Négatif',
    },
    roles: {
      Admin: 'Administrateur',
      FM: 'MF',
      OA: 'OA',
    },
    status: {
      draft: {
        description: `Le projet est encore à l'état d'ébauche`,
      },
      proposed: {
        description: `Le projet est proposé par le créateur du projet au responsable des opérations du cluster pour la décision d'inclure ou non le projet dans la soumission`,
      },
      returned: {
        description:
          'Le projet est renvoyé au créateur du projet pour révision en fonction des commentaires',
      },
      submitted: {
        description: `Le projet est soumis pour être inclus dans le plan d'affaires du pays  y compris le portefeuille  les plans d'affaires du Centre`,
      },
      planned: {
        description:
          'Le projet figure actuellement dans les plans financiers  mais peut nécessiter des approbations supplémentaires en fonction du coût total du projet',
      },
      approved: {
        description:
          'Le projet a reçu des approbations supplémentaires applicables (IR, BC, etc.) et peut maintenant être exécuté',
      },
      cancelled: {
        description: 'Le projet est annulé',
      },
      postponed: {
        description: 'Le projet est soit reporté soit mis en attente',
      },
      running: {
        description: 'Projet en cours ou en mode pré-étude (études)',
      },
      completed: {
        description: 'Le projet est terminé',
      },
    },
    measurements: {
      kgCo2Ton: 'kg CO2e/tonne',
      kgCo2M3: 'kgCO2e/m3',
      kgCo2Kwh: 'kg CO2e/kWh',
    },
    tooltips: {
      reltp: 'Real Estate Long-Term Planning 2.0 Digital Product',
      saveColumns:
        'Enregistrer la sélection de colonnes en fonction de votre vue',
      reason: `Raison du retour d'un projet`,
      projects: 'Typiquement des projets SISAN',
      bulkUpdate: 'Mettre à jour/enregistrer les modifications',
      businessUnit: 'Les unités commerciales sont peuplées de CBD',
      createDraft: 'Créer et enregistrer un projet en tant que brouillon',
      updateProject: 'Mettre à jour/enregistrer les détails du projet',
      changeStatus: 'Modifier le statut du projet',
      mergeByReferenceID:
        'Cliquez ici si le(s) projet(s) doit/doivent être fusionné(s) avec un autre projet',
      removeFromSubmission: `Le projet est renvoyé dans la file d'attente sur l'écran de soumission lui-même`,
      sendToArchive: 'Le projet est archivé',
      fillTheRestAndPropose:
        'Remplissez les informations restantes sur le projet et proposez-le comme candidat potentiel pour soumission',
      createDraftProject:
        'Créer et enregistrer un projet en tant que brouillon',
      fiscalYear:
        'par exemple. FY 24 est du 1er septembre 2023 au 31 août 2024',
      returnMessage: `Raison du retour d'un projet`,
      projectResources: 'Ressources nécessaires à la réalisation du projet',
      updateAndPropose:
        'Mettre à jour / enregistrer les modifications et proposer comme candidat potentiel pour la soumission',
      updateAndApprove:
        'Mettre à jour / enregistrer la sélection et approuver le projet',
      requestChanges: `Supprimer le projet de l'écran de soumission et demander au créateur du projet d'apporter des modifications au projet`,
      pushToEtr: 'Pousser le(s) projet(s) sélectionné(s) vers ETR',
      etrSync: 'La soumission a été synchronisée avec ETR',
      notEtrSync: `La soumission n'a pas été synchronisée avec ETR`,
      mergeProjects:
        'Fusionner le projet relie uniquement un ou plusieurs projets à un autre via un ID de référence  sans fusionner les données réelles du projet',
      additionalApproval:
        'Les projets de portefeuille nécessitent des approbations supplémentaires qui peuvent être sélectionnées parmi les options ci-dessous',
      totalProjectInvestmentCostDescription: `Ceci est basé sur les données de coût de remplacement de CAFM et n'est qu'indicatif`,
      annualCostImpactNetEUR: `Ne comprend pas l'amortissement`,
      benefitsAndRisk: `Généré automatiquement en fonction d'autres champs`,
      annualPAndLImpact: `Impact P&L annuel (inclut l'amortissement)`,
      annualCostImpactNet: `Impact sur les coûts annuels (net)  mais n'inclut pas l'amortissement`,
      referenceID:
        'ID de référence de projet unique généré par le système dans RELTP 2.0',
      locationBasedCO2:
        'Calculé sur la base des facteurs définis dans RELTP 2.0 par le super utilisateur Sustain',
      ingkaClimateFootprintCalculated: `Calculé par l'outil Sustain`,
      payback: `Calculé en divisant l'investissement total du projet par l'impact annuel net sur les coûts`,
      localUniqueId: '',
      projectName: 'Nom du projet créé',
      additionalInformation: 'Informations complémentaires sur le projet',
      priority: 'Priorité du projet',
      SISANDimensionSolutionPurpose:
        'Objectif de la solution SISAN pour le projet',
      solutionType: 'Type de solution pour le projet',
      sourceChannel: 'Canal source du projet',
      removeAsset: `Supprimer l'actif du projet`,
      programmeStatus: `Sélectionnez si le programme doit s'appliquer à ce projet`,
      replaceAssets: 'Remplacer les éléments sélectionnés',
      landCost: 'Coût du terrain pour le projet',
      programmeName: 'Sélectionnez le nom du programme',
      assetQuantity: `Veuillez spécifier la quantité d'éléments nouvellement ajoutés`,
      propertyInvestmentBuilding: 'Investissement immobilier de projet',
      retailInvestment: `Projet d'investissement commercial`,
      retailCost: 'Coût de détail du projet',
      'recurringYearlyOperationalCost:':
        'Coût opérationnel annuel récurrent du projet',
      recurringYearlySavings:
        'Des économies annuelles récurrentes pour les projets',
      asset: `Veuillez spécifier le groupe d'éléments`,
      depreciationCalculated: 'Amortissement calculé pour le projet',
      addAsset: 'Ajouter un élément au projet',
      potentialYearlyIncome: 'Revenu annuel potentiel pour le projet',
      addNewAsset: 'Ajouter un nouvel actif',
      replaceAsset: `Remplacer l'actif existant de la liste`,
      riskAvoidance: 'Veuillez mettre Évitement des risques pour le projet',
      totalElectricity: 'Électricité totale pour le projet',
      naturalGas: 'Gaz naturel pour le projet',
      bioFuel: 'Des biocarburants pour le projet',
      districtHeat: 'Chauffage urbain pour le projet',
      districtCooling: 'Refroidissement urbain pour le projet',
      electricityGenerated: 'Électricité produite pour le projet',
      waterReduction: `Réduction d'eau pour le projet`,
      wasteReduction: 'Réduction des déchets pour le projet',
      createAndPropose:
        'créer un projet et le proposer comme candidat possible pour soumission',
      discard: 'Ignorer les modifications et fermer le modal',
      openNotifications: 'Ouvrir le menu des notifications',
      changeLanguage: `Changer la langue de l'application`,
      update: 'Mettre à jour / enregistrer le projet',
      createProject: 'Créer un projet',
      edit: 'Modifier plusieurs projets',
      delete: 'Supprimer les projets sélectionnés',
      copy: 'Copie',
      revertFromArchive: `Rétablir les projets de l'archive`,
      BulkCreateProject: 'Créer plusieurs projets à la fois',
      countrySelectArchive:
        'Sélectionnez un pays pour afficher le projet archivé de ce pays',
      createProjectsFromCafmAssets:
        'Créer un projet à partir des ressources cafm',
      fySelectFlight: `Sélectionnez l'année fiscale pour voir les soumissions de cette année`,
      countrySelectFlight:
        'Sélectionnez un pays pour voir les soumissions de ce pays',
      makeSubmission: 'Créer une soumission',
      addToSubmission: 'Ajouter des projets à la soumission actuelle',
      submissionName: 'Nom de la soumission nouvellement créée',
      archiveTab: 'Onglet pour afficher les projets archivés',
      submissionTab: 'Onglet pour voir les soumissions',
      projectsTab: 'Onglet pour contrôler les projets',
      projectsPageBUSelect: 'Sélectionnez BU pour voir ses projets',
      filterAll: 'Cliquez pour ouvrir le modal Filtres',
      filterRetail: 'Cliquez pour filtrer les projets par portefeuille Retail',
      filterRetailCountry:
        'Cliquez pour filtrer les projets par pays de vente RETAIL',
      filterCentre: 'Cliquez pour filtrer les projets par INGKA Centre',
      totalInvestmentByType: `Montant total de l'investissement par type de projet`,
      actionCategory: `Veuillez sélectionner une catégorie d'action`,
      BulkCreateFromProject:
        'Créer de nouveaux projets à partir de celui sélectionné',
      etrPriority: 'Priorité donnée par ETR',
      bulkExistingProject: 'Ce projet existe déjà et est en mode édition',
      bulkExistingApprovedProject:
        'Les projets approuvés ne peuvent pas être modifiés sur cet écran',
      unitType: '',
      resetColumns: '',
    },
    approval: {
      irApproved: 'Approuvé IR',
      businessCaseApproved: 'Analyse de rentabilisation approuvée',
    },
    notApplicable: `Sans objet / Approbation de l'analyse de rentabilisation non requise`,
    privacy: {
      title: 'Déclaration de confidentialité',
      header:
        'Lorsque vous utilisez RELTP 2.0, le responsable du traitement des données de la société Ingka Group (tel que défini ci-dessous) collecte certaines données personnelles vous concernant.',
      personalDataBold: 'Les données personnelles collectées sont :',
      personalData:
        'ID de messagerie professionnelle, prénom, deuxième prénom et nom de famille',
      purposeBold: 'La collecte de ces données a pour finalité :',
      purpose: `S'assurer de la responsabilisation des utilisateurs et de l'historique des activités. Dans RELTP2.0, nous enregistrons le nom et l'adresse e-mail des collègues, car nous avons besoin de savoir qui a créé des projets et l'historique des actions effectuées sur un projet.`,
      legalBold: 'Le fondement juridique du traitement est :',
      legal: `L'intérêt légitime du responsable du traitement à fournir les outils et applications nécessaires à son personnel.`,
      dataBold: 'Les données seront stockées :',
      data: `Les données seront conservées jusqu'à la date de sortie des employés d'IKEA`,
      controllerBold:
        'Le responsable du traitement pour ce traitement de données personnelles est :',
      controller: 'IKEA limitée',
      footer: `Vos données personnelles peuvent être partagées avec d'autres sociétés du groupe Ingka ainsi qu'avec des fournisseurs de services du groupe Ingka aux fins de fournir le RELTP 2.0.`,
      rights:
        'Vous disposez de certains droits par rapport à vos données personnelles. Pour en savoir plus sur ces droits. Veuillez visiter',
    },
    actionCategories: {
      water: 'Eau',
      energy: 'Énergie',
      waste: 'Déchets',
      na: 'N / A',
    },
    projectETRPriorities: {
      A: 'Haute',
      B: 'Moyen',
      C: 'Bas',
    },
  },
  pt: {
    sustainFactors: {
      updateSustainRates: 'Atualizar taxas de sustentação',
      sustainFactorsPage: 'Página de Fatores de Sustentação',
      properties: {
        countryName: 'Nome do país',
        electricityPurchasedMarketBased: '',
        electricityChange: 'Eletricidade Comprada',
        districtHeating: 'Aquecimento urbano',
        gas: 'Gás',
        districtCooling: 'Resfriamento Distrital',
        bioFuel: 'Biocombustível',
        electricityGenerated: 'Eletricidade Gerada',
        water: 'Água',
        waste: 'Lixo para aterro',
      },
    },
    common: {
      id: 'EU IRIA',
      reltp: 'RELTP EN 2.0',
      saveColumns: 'SALVAR COLUNAS',
      returnedNotification: 'retornou!',
      requiredField: 'Campo obrigatório',
      actions: 'Ações',
      reason: 'Razão',
      projects: 'Projetos',
      confirm: 'confirme',
      quantity: 'Quantidade',
      fy: 'Ano fiscal',
      country: 'País',
      total: 'Total',
      email: 'E-mail',
      role: 'Função',
      bulkUpdate: 'Atualizar',
      businessUnit: 'Unidade de negócio',
      countryCode: 'Código do país',
      createDraft: 'Criar rascunho',
      changeStatus: 'Alterar status',
      mergeByReferenceID: 'Mesclar por ID de referência',
      removeFromSubmission: 'Remover do envio',
      sendToArchive: 'Enviar para arquivo',
      fillTheRestAndPropose: 'Preencha o resto e proponha',
      createDraftProject: 'Criar projeto de rascunho',
      fiscalYear: 'Ano fiscal',
      view: 'Visão',
      returnMessage: 'Mensagem de retorno',
      projectResources: 'Recursos do projeto',
      updateAndPropose: 'Atualizar e propor',
      updateAndApprove: 'Atualizar e aprovar',
      viewProject: 'Ver projeto',
      updateProject: 'Atualizar o projeto',
      update: 'Atualizar',
      hours: 'Horas',
      name: 'Nome',
      delete: 'Excluir',
      archive: 'Arquivo',
      discard: 'Descartar',
      cancel: 'Cancelar',
      warning: 'Aviso',
      deleteTheseProjects: 'Tem certeza de que deseja excluir esses projetos?',
      archiveTheseProjects:
        'Tem certeza de que deseja arquivar esses projetos?',
      bulkEdit: 'Edição em massa',
      loadingMsg: {
        checkingYourPermissions: 'Verificando suas permissões',
      },
      totalEUR: 'Total em euros',
      areYouSure: 'Tem certeza?',
      discardConfirmationMessage:
        'Você fez algumas alterações, deseja descartá-las e fechar o modal?',
      revertFromArchive: 'Reverter do arquivo',
      bulk: 'Volume',
      close: 'Perto',
      resetColumns: '',
    },
    appBar: {
      openSettings: 'Abrir configurações',
      mobileMenu: {
        accountOfCurrentUser: 'conta do usuário atual',
      },
      notificationMenu: {
        noNotifications: 'Nenhuma notificação',
        new: 'novo',
        returnedProjects: 'Projetos devolvidos',
        showOldNotifications: 'Mostrar notificações antigas',
        plannedProjects: 'Projetos planejados',
      },
      navigation: {
        submissiontTab: 'Submission',
        archiveTab: 'Arquivo',
        projectsTab: 'Projetos',
      },
      countrySelect: {
        chooseCountry: 'Escolha o país',
      },
    },
    login: {
      loginMessages: 'Fazendo login',
    },
    projects: {
      manageProjects: 'Gerenciar projetos',
      createProject: 'Criar projeto',
      bulkCreateProject: 'Criação de projetos em massa',
      replaceCafmAssets: 'Substituir Ativos CAFM',
      returned: 'Retornou',
      totalProjects: 'Projetos totais',
      projectsAvailableForUser: 'Todos os projetos disponíveis para o usuário',
      asset: 'De ativos',
      archiveProject: 'Arquivar projeto',
      changeProjectStatus: 'Alterar status do projeto',
      newStatus: 'Novo status',
      assets: 'Ativos',
      requestChanges: 'Solicitar alterações',
      pushToEtr: 'Empurre para ETR',
      etrSync: 'Sincronizado com ETR',
      notEtrSync: 'Não sincronizado com ETR',
      notSyncedWithEtrMessage:
        'O ETR tem uma versão diferente deste projeto do que o RELTP. Por favor, alinhe-se com o usuário RE para enviar as últimas alterações do RELTP para o ETR, antes de aprovar este projeto',
      mergeProjects: 'Mesclar projetos',
      additionalApproval: 'Aprovações Adicionais',
      properties: {
        totalProjectInvestmentCostDescription:
          'O investimento total do projeto deve ser de pelo menos',
        projectsSelected: 'Projetos selecionados',
        additionalApprovalBody:
          'O projeto está agora em um estado Planejado. Você garantiu aprovações adicionais?',
        additionalApprovalWarningSwitch:
          'Você está prestes a mudar o status do projeto para Aprovado',
        additionalApprovalRequired: 'Aprovação adicional necessária',
        totalInvestment: 'Investimento total',
        districtHeatNetKwh: 'Kwh Líquido de Calor Distrital',
        depreciationAccount: 'Conta de depreciação',
        cpmFm: 'CPM FM',
        annualCostImpactNetEUR: 'Impacto de custo anual líquido EUR',
        totalInvestmentEUR: 'Investimento total EUR',
        investmentAmount: 'Valor do investimento',
        status: 'Status',
        bioFuelsNetKwh: 'Biocombustíveis Kwh Líquido',
        projectInfo: 'Informações do projeto',
        retailCost: 'Retail Cost',
        benefitsAndRisk: 'Benefícios e riscos',
        riskAvoidance: 'Prevenção de riscos',
        riskAvoidancePlaceholder:
          'Qual seria o risco de não fazer este projeto?',
        depreciation: 'Depreciação',
        paybackYears: 'Retorno (Anos)',
        annualPAndLImpact: 'Impacto anual de P&L',
        recurringYearlySavings: 'Economias anuais recorrentes',
        operationalCost: 'Operational Cost',
        totalInvestments: 'Total Investments',
        land: 'Land',
        benefitsAndRisks: 'Benefícios e riscos',
        additionalInformation: 'Informação adicional',
        projectName: 'Nome do Projeto',
        businessUnitFullName: 'Nome do local',
        projectStatus: 'Status do projeto',
        totalProjectInvestmentEUR: 'Investimento total do projeto EUR',
        annualCostImpactNet: 'Impacto de Custo AnualNet',
        biofuelsNetKwh: 'Biocombustíveis NetKwh',
        co2eNet: 'Co2e Líquido',
        etrprojectID: 'Etr ID do projeto',
        etrSolutionID: 'Etr ID da solução',
        etrUnitID: 'Etr ID da unidade',
        unifierID: 'ID do unificador',
        clusterFMSpecialist: 'Especialista em FM de Cluster',
        districtFM: 'Distrito FM',
        responsiblLead: 'Responsável (Líder)',
        unitFM: 'Unidade FM',
        cpm: 'CPM',
        assetManagement: 'Gestão de ativos',
        externalPM: 'PM externo',
        referenceID: 'referência ID',
        projectID: 'Código do projeto',
        etrID: 'ID ETR',
        projectAssets: 'Ativos do projeto',
        bu: 'UN',
        landCost: 'Custo do terreno',
        solutionPurpose: 'Objetivo da solução',
        solutionType: 'Tipo de solução',
        startDate: 'Data de início',
        completionDate: 'Data de conclusão',
        landCG1: 'Land (CG1)',
        landCG1EUR: 'Land (CG1) EUR',
        propertyInvestmentCG111: 'Property Investment (CG1-11)',
        propertyInvestmentCG111EUR: 'Property Investment (CG1-11) EUR',
        retailCostCG1516: 'Retail Cost (CG15-16)',
        retailCostCG1516EUR: 'Retail Cost (CG15-16) EUR',
        accountable: 'Responsável',
        priority: 'Prioridade',
        annualCostImpact: 'Impacto de custo anual',
        currency: 'Moeda',
        engineer: 'Engenheiro',
        portfolio: 'Portfólio',
        potentialYearlyIncome: 'Renda Anual Potencial',
        projectStartFiscalYear: 'FY de Início do Projeto',
        projectCompletionFiscalYear: 'FY de Conclusão do Projeto',
        recurringYearlyOperationalCost: 'Custo Operacional Anual Recorrente',
        retailInvestmentCG1214: 'Retai Investment (CG12-14)',
        retailInvestmentCG1214EUR: 'Retai Investment (CG12-14) EUR',
        unitType: 'Tipo de unidade',
        updatedAt: 'Atualizado em',
        co2eSociety: 'Sociedade Co2e',
        createdBy: 'Criado por',
        propertyInvestment: 'Investimento imobiliário',
        totalElectricity: 'Eletricidade Comprada',
        retailInvestment: 'Investimento de varejo',
        sustainID: 'Sustentar ID',
        additionalInformationProject:
          'Informações Adicionais (Antecedentes do Projeto)',
        mergedWithProject: 'Combinado com o projeto',
        programmeName: 'Nome do programa',
        programmeStatus: 'Programa S/N',
        projectCompletionFY: 'Conclusão do projeto FY',
        projectEndFY: 'Fim do projeto FY',
        projectStartFY: 'Início do projeto FY',
        SISANDimensionSolutionPurpose: 'Dimensão SISAN (Propósito da Solução)',
        totalProjectInvestment: 'Investimento total do projeto',
        LandCG01: 'Land (CG01)',
        propertyInvestmentBuilding:
          'Property Investment (edificio + terreno) (CG01-11)',
        bioFuel: 'Biocombustível',
        districtCooling: 'Resfriamento Distrital',
        districHeat: 'Aquecimento Distrital',
        naturalGas: 'Gás natural',
        electricityGenerated: 'Eletricidade gerada',
        locationBasedCO2:
          'CO2 com base na localização (com base nos fatores de emissão médios do país)',
        ingkaClimateFootprintCalculated:
          'Pegada climática da Ingka (fatores de emissão reais do local com base no mercado)',
        wasteReduction: 'Lixo para aterro',
        waterReduction: 'Água',
        netkWh: 'kWh líquido',
        pnlImpact: 'Impacto PnL',
        depreciationAmount: 'Valor de depreciação',
        depreciationEur: 'Depreciação Eur',
        districtCoolingNetKwh: 'Kwh líquido de resfriamento distrital',
        districtFm: 'Distrito Fm',
        etrProjectId: 'Etr ProjectId',
        etrSolutionId: 'Etr SolutionId',
        etrUnitId: 'Etr UnitId',
        externalContractorsNeeded: 'Empreiteiros Externos Necessários',
        gasNetKwh: 'Gás líquido Kwh',
        generatedNetKwh: 'Kwh Líquido Gerado',
        impactYear1: 'Ano de Impacto 1',
        impactYear1Eur: 'impacto Ano1Eur',
        legalUnit: 'Unidade Jurídica',
        mtoolId: 'ID da ferramenta',
        co2e: 'Co2e',
        operationalCostEUR: 'Operational Cost EUR',
        plImpactAccount: 'Conta de Impacto Pl',
        plImpactAmountPerAccount: 'Valor do impacto Pl por conta',
        potentialYearlyIncomeEUR: 'Renda Anual Potencial EUR',
        realEstateDevelopment: 'Real Estate Development',
        recurringYearlyOperationalCostEUR:
          'Custo Operacional Anual Recorrente EUR',
        recurringYearlySavingsEUR: 'Economias anuais recorrentes EUR',
        payback: 'Retorno',
        referenceId: 'Referência ID',
        sustainId: 'ID de sustentação',
        totalElectricityNetKwh: 'Kwh Líquido Adquirido de Eletricidade',
        unifierId: 'ID do unificador',
        unitCategory: 'Categoria da unidade',
        unitFm: 'Unidade Fm',
        wasteReductionT: 'Redução de Resíduos T',
        waterReductionM3: 'Redução de Água M3',
        pnLImpact: 'Impacto PnL',
        projectMergeWithProjectReferenceId:
          'Projeto mesclado com (Digite o ID de referência do projeto)',
        localUniqueId: '',
        changeProjectMessage:
          'Você está prestes a alterar o ano inicial e final do projeto, que já foi adicionado ao último envio (o ID do M-Tool é criado e o status do projeto é aprovado). Por favor, escolha entre as próximas etapas possíveis abaixo',
        projectEndDate: 'Data de término do projeto',
        projectStartDate: 'Data de início do projeto',
        actionCategory: 'Categoria de ação',
        budgeting: 'Orçamento (somente na Rússia)',
        subcategory: 'Subcategoria (somente na Rússia)',
        etrPriority: 'Prioridade ETR',
      },
      hintMessage: {
        chooseABU: 'Escolha uma BU',
        chooseBUs: 'Escolha BUs',
      },
      create: {
        projectInvestment: 'Project Investment',
        opexImpact: 'Impacto OPEX',
        energyInformation: 'Informações sobre energia',
        createAndPropose: 'Criar e propor',
        riskAvoidance: 'Prevenção de riscos',
        descriptionForEnergyInformation:
          'Insira as alterações anuais que o projeto gera com reduções como valores negativos',
        generalForm: {
          startFyIsBiggerErrorMessage: 'O início FY é maior que o final FY',
          hintMessage: {
            additionalProjectInformationErrorMessage:
              '# de unidades sendo substituídas, peças específicas sendo substituídas ou nomes de marcas relacionados a substituições, etc.',
          },
        },
        opexForm: {
          positivePAndLImpact: 'Impacto positivo de P&L',
          negativePAndLImpact: 'Impacto negativo de P&L',
          savingAsNegative:
            'IMPORTANTE: Insira a poupança como número negativo',
          depreciationCalculated: 'Depreciação - CALCULADA',
          annualCostImpactCalculation:
            'Líquido de Impacto de Custo Anual - CALCULADO',
          paybackYearsCalculated: 'Payback (Anos) - CALCULADO',
          paybackYears: 'Retorno (Anos)',
          annualPAndLImpactCalculated: 'Impacto Anual de P&L - CALCULADO',
          annualPAndLImpact: 'Impacto anual de P&L',
        },
      },
      userModal: {
        userBusinessUnits: 'Unidades de negócios do usuário',
        userClusters: 'Grupos de usuários',
        userCountry: 'País do usuário',
      },
      createProjectsFromCafmAssets: 'Criar projetos a partir de ativos CAFM',
    },
    bulkCreate: {
      createProjects: 'Criar projetos',
      editProjects: 'Editar projetos',
      table: {
        removeRow: 'Remover linha',
        copyRow: 'Copiar linha',
        addNewRow: 'Adicionar nova linha',
      },
      investmentModal: {
        projectInvestments: 'Investimentos do projeto',
        updateInvestments: 'Atualizar investimentos',
      },
      createDraftProjects: 'Criar projeto(s) de rascunho',
    },
    flight: {
      makeSubmission: 'Fazer envio',
      retailPortfolio: 'Retail Portfolio',
      retailCountryUnit: 'Retail Country/Unit',
      centres: 'INGKA Centres',
      newInfo: 'Novas informações',
      projectsQueue: 'Fila de projetos',
      boarded: 'Embarcou',
      submitted: 'Submetido',
      loadingProjects: 'Carregando projetos',
      noProjectsAvailable: 'Nenhum projeto disponível',
      addToSubmission: 'Adicionar ao envio',
      noSubmissionsForAGivenCountry: 'Nenhum envio para um determinado país',
      submission: {
        flightSubmissionTableNewInfo:
          'Projetos que precisam ser revisados ​​porque os dados foram atualizados após o envio anterior',
        flightSubmissionTableBoarded: 'Projetos incluídos na submissão atual',
        flightSubmissionTableQueue:
          'Revise e escolha os projetos que serão incluídos no Envio atual ou solicite alterações ao Criador do projeto',
        flightSubmissionTableReturned: 'Projetos que foram solicitados a mudar',
      },
      submissionHeader: {
        submissionFinancialCard: {
          exportReport: 'Exportar relatório',
        },
      },
      createSubmissionModal: {
        createSubmission: 'Criar envio',
        submissionName: 'Nome do envio',
        sendToETR: 'Enviar para ETR',
      },
      newInfoModal: {
        info: 'Informações',
        projectDataWasUpdated: 'Os dados do projeto foram atualizados',
        dataUpdateTable: {
          loadingMessage: 'Carregando alterações',
          noPreviousValue: 'Sem valor anterior',
        },
      },
      revertProjectModal: {
        revertProjects: 'Reverter projetos',
        revertToDraft: 'Reverter para rascunho',
        projectsRevertedToDraftStatus:
          'Projetos que serão revertidos para o status Rascunho',
        bulkCommentForRevertedProjects:
          'Comentário em massa para projetos revertidos',
      },
      table: {
        tootTips: {
          projectDataWasChangedClickToViewDetails:
            'Os dados do projeto foram alterados. Clique para ver detalhes.',
          boardedProject: 'Projeto embarcado',
        },
      },
    },
    user: {
      properties: {
        cluster: 'Conjunto',
        userName: 'Nome de usuário',
      },
    },
    admin: {
      adminPage: 'Página de administrador',
      updateUser: 'Atualizar usuário',
      addUser: 'Adicionar usuário',
    },
    currency: {
      currencyPage: 'Página de moeda',
      updateCurrencyRates: 'Atualizar taxas de câmbio',
      currencyTable: {
        currencyCode: 'Código da moeda',
        currencyRate: 'Taxa de câmbio',
      },
    },
    filter: {
      allFilters: 'Todos os filtros',
      projectsFilters: 'Filtros de projetos',
      clearFilters: 'Limpar filtros',
    },
    assets: {
      addNewAsset: 'Adicionar novo recurso',
      addAsset: 'Adicionar recurso',
      manufacturerModelYear: 'Fabricante, modelo, ano etc...',
      properties: {
        assetDescription: 'Descrição do ativo',
        endDate: 'Data final',
        replacementCost: 'Custo de reposição',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        organization: 'Organização',
        unitId: 'ID da unidade',
        assetGroup: 'Grupo de recursos',
        replaceAssetsDescription:
          'Os ativos são organizados de acordo com a data final do ativo no CAFM. Por favor, escolha os ativos que você gostaria de substituir em sua BU. Você também pode pesquisar os ativos com base na descrição do ativo.',
      },
      replaceAsset: {
        cafmAssetsErrorMsg: 'Não há ativos CAFM para BU selecionada',
        replaceAssets: 'Substituir ativos',
      },
    },
    snackbarMessages: {
      sustainFactorsUpdated:
        'Os fatores de sustentação foram atualizados com sucesso',
      sustainFactorsUpdateError:
        'Não foi possível atualizar os fatores de sustentação',
      fetchProjectError: 'Problema para conseguir projetos',
      projectCreated: 'Projeto criado',
      couldNotCreateProject: 'Não foi possível criar o projeto',
      projectsSuccessfullyCreated: 'Projetos criados com sucesso',
      couldNotCreateProjects: 'Não foi possível criar projetos',
      projectUpdated: 'Projeto atualizado',
      projectCouldNotBeUpdated: 'O projeto não pôde ser atualizado',
      couldNotFetchAssets: 'Não foi possível buscar recursos',
      couldNotFetchCafmAssets: 'Não foi possível buscar os ativos do Cafm',
      couldNotFetchUsers: 'Não foi possível buscar usuários',
      updatedUserSuccessfully: 'Usuário atualizado com sucesso',
      deletedUserSuccessfully: '',
      couldNotDeleteUser: '',
      couldNotUpdateUser: 'Não foi possível atualizar o usuário',
      projectsStatusesWereUpdated: 'Os status dos projetos foram atualizados',
      couldNotUpdateProjectsStatuses:
        'Não foi possível atualizar os status dos projetos',
      problemGettingBusinessUnits: 'Problema ao obter unidades de negócios',
      problemGettingUserData: 'Problema ao obter dados do usuário',
      problemGettingFlightData: 'Problema ao obter dados de voo',
      couldNotCreateNewSubmission: 'Não foi possível criar um novo envio',
      couldNotFetchArchiveData: 'Não foi possível buscar os dados do arquivo',
      couldNotSendProjectsToArchive:
        'Não foi possível enviar projetos para arquivar',
      couldNotFetchProjectChanges:
        'Não foi possível buscar as alterações do projeto',
      couldNotFetchCurrencyData: 'Não foi possível buscar dados de moeda',
      successfullyUpdatedCurrencyRates:
        'Taxas de câmbio atualizadas com sucesso',
      couldNotUpdateCurrencyData:
        'Não foi possível atualizar os dados de moeda',
      problemGettingUpdatedProjects: 'Problema ao obter projetos atualizados',
      couldNotMergeProjects: 'Não foi possível mesclar projetos',
      couldNotFetchSustainFactors:
        'Não foi possível buscar fatores de sustentação',
      successfullyUpdatedSustainFactors:
        'Fatores de sustentação atualizados com sucesso',
      successfullyUpdatedProjects: 'Os projetos foram atualizados com sucesso',
      couldNotUpdateProjects: 'Não foi possível atualizar os projetos',
      cannotEditApprovedOrPlannedProjects:
        'Alguns projetos foram removidos da edição em massa porque têm M Tool-id e foram aprovados ou planejados',
      problemToAddArchived:
        'Alguns dos projetos selecionados não podem ser arquivados, pois possuem M-Tool Id',
      problemPushToEtr: 'Erro ao enviar para etr',
      successPushToEtr:
        'Os itens serão sincronizados com o ETR em alguns minutos',
      projectsUnArchived: 'Os projetos foram movidos do arquivo com sucesso',
      projectsUnArchivedError: 'não foi possível mover projetos do arquivo',
    },
    validationMessages: {
      projectNameIsRequired: 'O nome do projeto é obrigatório',
      buIsRequired: 'BU é obrigatório',
      additionalInformationIsRequired: 'Informações adicionais são necessárias',
      benefitsAndRiskIsRequired: 'Benefícios e risco é obrigatório',
      priorityIsRequired: 'A prioridade é obrigatória',
      solutionPurposeIsRequired: 'A finalidade da solução é obrigatória',
      solutionTypeIsRequired: 'O tipo de solução é obrigatório',
      completionFYIsRequired: 'Conclusão FY é necessária',
      sourceChannelIsRequired: 'O canal de origem é obrigatório',
      programmeIsRequired: 'O programa é obrigatório',
      startFYIsRequired: 'Iniciar FY é obrigatório',
      landValueMustBeANumber: 'O valor do terreno deve ser um número',
      landValueIsRequired: 'O valor do terreno é obrigatório',
      propertyInvestmentMustbeANumber:
        'O investimento imobiliário deve ser um número',
      propertyInvestmentIsRequired: 'O Investimento Imobiliário é obrigatório',
      retailInvestmentMustBeANumber:
        'O investimento de varejo deve ser um número',
      retailInvestmentIsRequired: 'O investimento de varejo é necessário',
      retailCostMustbeANumber: 'O custo de varejo deve ser um número',
      retailCostIsRequired: 'O custo de varejo é obrigatório',
      totalElectricityMustBeANumber:
        'A eletricidade comprada deve ser um número',
      totalElectricityIsRequired: 'A eletricidade comprada é necessária',
      gasMustBeANumber: 'O gás deve ser um número',
      gasIsRequired: 'O gás é necessário',
      biofuelsMustBeANumber: 'Os biocombustíveis devem ser um número',
      biofuelsIsrequired: 'Os biocombustíveis são necessários',
      districtHeatMustBeANumber: 'Distrito Heat deve ser um número',
      districtHeatIsRequired: 'O calor distrital é necessário',
      districtCoolingMustBeANumber:
        'O resfriamento distrital deve ser um número',
      districtCoolingIsRequired: 'O resfriamento distrital é necessário',
      generatedkWhMustBeANumber: 'O kWh gerado deve ser um número',
      generatedkWhIsRequired: 'O kWh gerado é obrigatório',
      waterReductionMustBeANumber: 'A água deve ser um número',
      waterReductionIsRequired: 'A água é necessária',
      wasteReductionMustBeANumber:
        'Os resíduos para aterro devem ser um número',
      wasteReductionIsRequired: 'O lixo para aterro é obrigatório',
      yearlyOperationalCostMustBeANumber:
        'O Custo Operacional Anual deve ser um número',
      yearlyOperationalCostIsRequired:
        'O Custo Operacional Anual é obrigatório',
      yearlySavingsMustBeANumber: 'A economia anual deve ser um número',
      yearlySavingsCostIsRequired: 'O custo de economia anual é obrigatório',
      yearlyIncomeMustbeANumber: 'A renda anual deve ser um número',
      yearlyIncomeCostIsRequired: 'O Custo de Renda Anual é obrigatório',
      nameIsRequired: 'O nome é obrigatório',
      mustBeAValidEmail: 'Deve ser um e-mail válido',
      emailIsRequired: 'O e-mail é obrigatório',
      userMustHaveARole: 'O usuário deve ter uma função',
      userMustHaveAtLeastOneBusinessUnit:
        'O usuário deve ter pelo menos uma unidade de negócios',
      userMustHaveAtLeastOneCountry: 'O usuário deve ter pelo menos um país',
      userMustBelongToAtLeastOneCluster:
        'O usuário deve pertencer a pelo menos um cluster',
      propertyInvestmentShouldBeMoreThanLandCost:
        'O Investimento Imobiliário (Edifício + Terreno) deve ser maior ou igual ao Terreno.',
      riskAvoidanceRequired: 'É necessário evitar riscos',
      validationError: 'A validação falhou',
      shouldBeDateFormatProjectStart:
        'A data de início do projeto deve estar no formato AAAA/MM/DD',
      shouldBeDateFormatProjectEnd:
        'A data de término do projeto deve estar no formato AAAA/MM/DD',
    },
    solutionPuposes: {
      costsavings: 'Cost savings',
      businessContinuity: 'Business continuity',
      compliance: 'Compliance',
      lifeCycle: 'Life cycle',
      sustainability: 'Sustainability',
    },
    solutionTypes: {
      bmsUpgrade: 'BMS upgrade',
      commercialRepairs: 'Commercial repairs',
      energyEfficiency: 'Energy efficiency',
      led: 'conduziu',
      facadeRepairs: 'Facade repairs',
      fuelCell: 'Fuel cell',
      generators: 'Generators',
      hvac: 'HVAC',
      lightingNonLED: 'Lightning (non LED)',
      parkingRepairs: 'Parking repairs',
      publicInfrastructureIntervention: 'Public infrastructure intervention',
      photovoltaicPanels: 'Photovoltaic panels',
      restrooms: 'Restrooms',
      rhc: 'RHC',
      roofRepairs: 'Roof repairs',
      structuralUpgradesAndRepairs: 'Structural upgrades and repairs',
      equipmentReplacementOrUpgrade: 'Equipment replacement or upgrade',
      tradeDressReplacement: 'Trade dress replacement',
      wasteOther: 'Waste other',
      waterRelatedSystems: 'Water related systems',
      ecopilot: 'Ecopilot',
      flooringRepairs: 'Flooring repairs',
      safetyAndSecurity: 'Safety and security',
      wasteWaterManagement: 'Waste water management',
      evChargers: 'EV chargers',
      legalOrContractual: 'Legal or contractual',
      wasteBaler: 'Waste baler',
      poweroptimiserEPower: 'Power optimiser (E-power)',
      energyEnvelopeDoors: 'Energy envelope doors',
      energyEnvelopeRoof: 'Energy envelope roof',
      metering: 'Metering',
      energyEnvelopeFacade: 'Fachada do envelope de energia',
      adaptiveScheduling: 'Agendamento e otimização adaptáveis',
      'Commercial use': 'Uso comercial',
      'Other Food solution': 'Outra solução alimentar',
    },
    projectPriorities: {
      critical: '1 - Critical',
      necessary: '2 - Necessary',
      recommended: '3 - Recommended',
    },
    programmes: {
      ecopilot: 'Ecopilot',
      electricVehicles: 'Electric vehicles',
      led: 'LED',
      metering: 'Metering',
      powerOptimizer: 'Power optimizer (E-Power)',
      wasteBalers: 'Waste balers',
      eVChargers: 'EV chargers',
      buildingManagementSystems: 'Sistemas de gestão de edifícios [LEGACY]',
      electricalSystems: 'Sistemas elétricos [LEGACY]',
      wasteHandling: 'Equipamento de Manuseio de Resíduos [LEGACY]',
    },
    statuses: {
      UNQUALIFIED: 'Edit',
      QUALIFIED: 'Proposed',
      RETURNED: 'Returned',
      DRAFT: 'Draft',
      NOT_STARTED: 'Not started',
      RUNNING: 'Running',
      DELIVERED: 'Delivered',
      CLOSED: 'Closed',
      CANCELLED: 'Cancelled',
      ON_HOLD: 'On hold',
    },
    buTypes: {
      ikeaStore: 'IKEA Store',
      ikeaSmallStoreS: 'IKEA Small Store S',
      ikeaSmallStoreXS: 'IKEA Small Store XS',
      ikeaSmallStoreLadaS: 'IKEA Small Store (S) Lada',
      ikeaSmallStoreLadaM: 'IKEA Small Store (M) Lada',
      ikeaShop: 'IKEA Shop',
      ikeaPlanAndOrderPoint: 'IKEA Plan and Order Point',
      ikeaMiniPlanAndOrderPoint: 'IKEA Mini Plan and Order Point',
      ikeaPickUpAndOrderPoint: 'IKEA Pick up and Order Point',
      ikeaPickUpPointBranded: 'IKEA Pick up Point (branded)',
      ikeaPickUpPointUnbranded: 'IKEA Pick up Point (unbranded)',
      ikeaPopUp: 'IKEA Pop-up',
      ingkaCentresShopgMall: 'Ingka Centres - Shopg Mall',
      ingkaCentresRetailPark: 'Ingka Centres - Retail Park',
      ingkaCentresOutletCentre: 'Ingka Centres - Outlet Centre',
      customerSupportCentreCSC: 'Customer Support Centre (CSC)',
      distributionCentreDC: 'Distribution Centre (DC)',
      customerDistributionCentreCDC: 'Customer Distribution Centre (CDC)',
      centralParcelUnitCPU: 'Central Parcel Unit (CPU)',
      serviceOffice: 'Service Office',
      externalMerchandisePickUpUnitEMPU:
        'External Merchandise Pick-up Unit (EMPU)',
      externalWarehouse: 'External Warehouse',
      landbank: 'Landbank',
      explorationCase: 'Exploration Case',
      other: 'Other',
    },
    plImpact: {
      positive: 'Positive',
      negative: 'Negative',
    },
    roles: {
      Admin: 'Admin',
      FM: 'FM',
      OA: 'OA',
    },
    status: {
      draft: {
        description: 'Projeto ainda está em fase de rascunho',
      },
      proposed: {
        description:
          'O projeto é proposto pelo criador do projeto ao Líder de Operações do Cluster para a decisão de incluir ou não o projeto na submissão',
      },
      returned: {
        description:
          'O projeto é devolvido ao criador do projeto para revisão com base no feedback',
      },
      submitted: {
        description:
          'O projeto é submetido para ser incluído no plano de negócios do país, incluindo portfólio, planos de negócios do Centro',
      },
      planned: {
        description:
          'O projeto está nos planos financeiros agora, mas pode precisar de aprovações adicionais com base no custo total do projeto',
      },
      approved: {
        description:
          'O projeto recebeu aprovações adicionais aplicáveis ​​(IR, BC, etc.) e agora pode ser executado',
      },
      cancelled: {
        description: 'Projeto é cancelado',
      },
      postponed: {
        description: 'Projeto é adiado ou suspenso',
      },
      running: {
        description:
          'O projeto está em andamento ou em modo pré-estudo (estudos)',
      },
      completed: {
        description: 'Projeto está concluído',
      },
    },
    measurements: {
      kgCo2Ton: 'kg CO2e/ton',
      kgCo2M3: 'kg CO2e/m3',
      kgCo2Kwh: 'kg CO2e/kWh',
    },
    tooltips: {
      reltp: 'Real Estate Long-Term Planning 2.0 Digital Product',
      saveColumns:
        'Salve a seleção de coluna para se adequar à sua visualização',
      reason: 'Motivo da devolução de um projeto',
      projects: 'Normalmente projetos do SISAN',
      bulkUpdate: 'Atualizar/salvar alterações',
      businessUnit: 'As Unidades de Negócios são preenchidas a partir do CBD',
      createDraft: 'Criar e salvar projeto como rascunho',
      updateProject: 'Atualizar/salvar detalhes do projeto',
      changeStatus: 'Alterar o status do projeto',
      mergeByReferenceID:
        'Clique aqui se o(s) projeto(s) deve(m) ser mesclado(s) com outro projeto',
      removeFromSubmission:
        'O projeto é enviado de volta à fila na própria tela de envio',
      sendToArchive: 'O projeto está arquivado',
      fillTheRestAndPropose:
        'Preencha as informações restantes do projeto e proponha como possível candidato para submissão',
      createDraftProject: 'Criar e salvar projeto como rascunho',
      fiscalYear:
        'por exemplo. O ano fiscal 24 é de 1º de setembro de 2023 a 31 de agosto de 2024',
      returnMessage: 'Motivo da devolução de um projeto',
      projectResources: 'Recursos necessários para executar o projeto',
      updateAndPropose:
        'Atualizar/salvar alterações e propor como possível candidato para submissão',
      updateAndApprove: 'Atualizar/salvar seleção e aprovar o projeto',
      requestChanges:
        'Remova o projeto da tela de envio e solicite que o criador do projeto faça alterações no projeto',
      pushToEtr: 'Enviar projeto(s) selecionado(s) para ETR',
      etrSync: 'O envio foi sincronizado com o ETR',
      notEtrSync: 'O envio não foi sincronizado com o ETR',
      mergeProjects:
        'Mesclar projeto apenas vincula um ou vários projetos a outro por meio de ID de referência, sem mesclar os dados reais do projeto',
      additionalApproval:
        'Os projetos do portfólio precisam de aprovações adicionais, que podem ser selecionadas entre as opções abaixo',
      totalProjectInvestmentCostDescription:
        'Isso é baseado em dados de custo de reposição CAFM e é apenas indicativo',
      annualCostImpactNetEUR: 'Não inclui depreciação',
      benefitsAndRisk: 'Gerado automaticamente com base em outros campos',
      annualPAndLImpact: 'Impacto anual no P&L (inclui depreciação)',
      annualCostImpactNet:
        'Impacto de custo anual (líquido), mas não inclui depreciação',
      referenceID:
        'ID de referência de projeto exclusivo gerado pelo sistema no RELTP 2.0',
      locationBasedCO2:
        'Calculado com base em fatores definidos no RELTP 2.0 pelo superusuário Sustain',
      ingkaClimateFootprintCalculated: 'Calculado pela ferramenta Sustain',
      payback:
        'Calculado dividindo o investimento total do projeto pelo impacto de custo anual líquido',
      localUniqueId: '',
      projectName: 'Nome do projeto criado',
      additionalInformation: 'Informações adicionais sobre o projeto',
      priority: 'Project priority',
      SISANDimensionSolutionPurpose:
        'Propósito da solução SISAN para o projeto',
      solutionType: 'Tipo de solução para o projeto',
      sourceChannel: 'Canal de origem para o projeto',
      removeAsset: 'Remover ativo do projeto',
      programmeStatus:
        'Selecione se o programa deve ser aplicado a este projeto',
      replaceAssets: 'Substituir recursos selecionados',
      landCost: 'Custo da terra para o projeto',
      programmeName: 'Selecione o nome do programa',
      assetQuantity: 'Especifique a quantidade do recurso recém-adicionado',
      propertyInvestmentBuilding: 'Project property investment',
      retailInvestment: 'Project retail investment',
      retailCost: 'Project retail cost',
      'recurringYearlyOperationalCost:':
        'Custo operacional anual recorrente para o projeto',
      recurringYearlySavings: 'Economias anuais recorrentes para os projetos',
      asset: 'Especifique o grupo de recursos',
      depreciationCalculated: 'Depreciação calculada para o projeto',
      addAsset: 'Adicionar recurso ao projeto',
      potentialYearlyIncome: 'Renda anual potencial para o projeto',
      addNewAsset: 'Adicionar novo recurso',
      replaceAsset: 'Substituir o ativo existente da lista',
      riskAvoidance: 'Por favor',
      totalElectricity: 'Eletricidade total para o projeto',
      naturalGas: 'Gás natural para o projeto',
      bioFuel: 'Biocombustíveis para o projeto',
      districtHeat: 'Calor distrital para o projeto',
      districtCooling: 'Arrefecimento distrital para o projeto',
      electricityGenerated: 'Eletricidade gerada para o projeto',
      waterReduction: 'Redução de água para o projeto',
      wasteReduction: 'Redução de resíduos para o projeto',
      createAndPropose:
        'criar projeto e propor como possível candidato para submissão',
      discard: 'Descartar alterações e fechar modal',
      openNotifications: 'Abrir menu de notificações',
      changeLanguage: 'Alterar idioma do aplicativo',
      update: 'Atualizar/salvar projeto',
      createProject: 'Criar projeto',
      edit: 'Editar vários projetos',
      delete: 'Excluir projetos selecionados',
      copy: 'cópia de',
      revertFromArchive: 'Reverter projetos do arquivo',
      BulkCreateProject: 'Crie vários projetos de uma só vez',
      countrySelectArchive:
        'Selecione o país para visualizar o projeto arquivado desse país',
      createProjectsFromCafmAssets: 'Criar projeto a partir de ativos cafm',
      fySelectFlight: 'Selecione o ano fiscal para ver os envios desse ano',
      countrySelectFlight: 'Selecione o país para ver os envios desse país',
      makeSubmission: 'Criar envio',
      addToSubmission: 'Adicionar projetos ao envio atual',
      submissionName: 'Nome para o envio recém-criado',
      archiveTab: 'Guia para visualizar projetos arquivados',
      submissionTab: 'Aba para visualizar os envios',
      projectsTab: 'Aba para controlar projetos',
      projectsPageBUSelect: 'Selecione bu para ver seus projetos',
      filterAll: 'Clique para abrir o modal Filtros',
      filterRetail: 'Clique para filtrar projetos por portfólio de varejo',
      filterRetailCountry: 'Clique para filtrar projetos por país de varejo',
      filterCentre: 'Clique para filtrar projetos por Centro',
      totalInvestmentByType: 'Valor total do investimento por tipo de projeto',
      actionCategory: 'Selecione a categoria de ação',
      BulkCreateFromProject: 'Criar novos projetos a partir de um selecionado',
      etrPriority: 'Prioridade dada pelo ETR',
      bulkExistingProject: 'Este projeto já existe e está em modo de edição',
      bulkExistingApprovedProject:
        'Projetos aprovados não podem ser editados nesta tela',
      unitType: '',
      resetColumns: '',
    },
    approval: {
      irApproved: 'Aprovado pelo RI',
      businessCaseApproved: 'Caso de Negócios Aprovado',
    },
    notApplicable:
      'Não aplicável / Aprovação do caso de negócios não é necessária',
    privacy: {
      title: 'Declaração de privacidade',
      header:
        'Quando você usa o RELTP 2.0, o Controlador de Dados da empresa do Grupo Ingka (conforme definido abaixo) coletará certos dados pessoais sobre você.',
      personalDataBold: 'Os dados pessoais recolhidos são:',
      personalData: 'ID de e-mail de trabalho, nome, nome do meio e sobrenome',
      purposeBold: 'O objetivo da coleta desses dados é:',
      purpose:
        'Para garantir a responsabilidade do usuário e histórico de atividades. No RELTP2.0, salvamos o nome dos colegas de trabalho e o ID de e-mail, pois precisamos saber quem criou os projetos e o histórico das ações realizadas em um projeto.',
      legalBold: 'O fundamento legal para o processamento é:',
      legal:
        'O interesse legítimo do Controlador de Dados em fornecer as ferramentas e aplicativos necessários para sua força de trabalho.',
      dataBold: 'Os dados serão armazenados:',
      data: 'Os dados serão armazenados até a data de saída dos funcionários da IKEA',
      controllerBold:
        'O controlador de dados para este processamento de dados pessoais é:',
      controller: 'IKEA Limited',
      footer:
        'Seus dados pessoais podem ser compartilhados com outras empresas do Grupo Ingka, bem como prestadores de serviços do Grupo Ingka para fins de fornecimento do RELTP 2.0.',
      rights:
        'Você tem certos direitos em relação ao seu pessoal. Para saber mais sobre esses direitos. Por favor visite',
    },
    actionCategories: {
      water: 'Água',
      energy: 'Energia',
      waste: 'Desperdício',
      na: 'N / D',
    },
    projectETRPriorities: {
      A: 'Alto',
      B: 'Médio',
      C: 'Baixo',
    },
  },
  es: {
    sustainFactors: {
      updateSustainRates: 'Actualizar tasas de sostenibilidad',
      sustainFactorsPage: 'Página de factores de sostenibilidad',
      properties: {
        countryName: 'Nombre del país',
        electricityPurchasedMarketBased: '',
        electricityChange: 'Electricidad comprada',
        districtHeating: 'Calefacción urbana',
        gas: 'Gas',
        districtCooling: 'Enfriamiento urbano',
        bioFuel: 'biocombustible',
        electricityGenerated: 'Electricidad generada',
        water: 'Agua',
        waste: 'Residuos a vertedero',
      },
    },
    common: {
      id: 'IDENTIFICACIÓN',
      reltp: 'RELTP EN 2.0',
      saveColumns: 'GUARDAR COLUMNAS',
      returnedNotification: '¡Devuelto!',
      requiredField: 'Campo requerido',
      actions: 'Acción requerida',
      reason: 'Razón',
      projects: 'Proyectos',
      confirm: 'Confirmar',
      quantity: 'Cantidad',
      fy: 'Año Fiscal',
      country: 'País',
      total: 'Total',
      email: 'Correo electrónico',
      role: 'Role',
      bulkUpdate: 'Actualizar',
      businessUnit: 'Unidad de negocio',
      countryCode: 'Código de país',
      createDraft: 'Crear borrador',
      changeStatus: 'Cambiar Estado',
      mergeByReferenceID: 'Unificar por ID de referencia',
      removeFromSubmission: 'Eliminar el registro',
      sendToArchive: 'Enviar archivo',
      fillTheRestAndPropose: 'Rellena el resto y sugiere',
      createDraftProject: 'Crear borrador de proyecto',
      fiscalYear: 'Año Fiscal',
      view: 'Vista',
      returnMessage: 'Mensaje de vuelta',
      projectResources: 'Recursos de proyecto',
      updateAndPropose: 'Actualizar y proponer',
      updateAndApprove: 'Actualizar y aprobar',
      viewProject: 'Ver información del proyecto',
      updateProject: 'Actualizar el proyecto',
      update: 'Actualizar',
      hours: 'Horas',
      name: 'Nombre',
      delete: 'Borrar',
      archive: 'Archivo',
      discard: 'Desechar',
      cancel: 'Cancelar',
      warning: 'Advertencia',
      deleteTheseProjects:
        '¿Está seguro de que deseas eliminar estos proyectos?',
      archiveTheseProjects: '¿Seguro que quieres archivar estos proyectos?',
      bulkEdit: 'Información masiva',
      loadingMsg: {
        checkingYourPermissions: 'Verificando tus permisos',
      },
      totalEUR: 'Total en EUR',
      areYouSure: '¿Estás seguro?',
      discardConfirmationMessage:
        'Ha realizado algunos cambios, ¿quiere descartarlos y cerrar la aplicación?',
      revertFromArchive: 'Revertir el archivo',
      bulk: 'A granel',
      close: 'Cerca',
      resetColumns: '',
    },
    appBar: {
      openSettings: 'Configuración abierta',
      mobileMenu: {
        accountOfCurrentUser: 'Cuenta de usuario actual',
      },
      notificationMenu: {
        noNotifications: 'Sin Notificaciones',
        new: 'Nuevo estado',
        returnedProjects: 'Proyectos devueltos',
        showOldNotifications: 'Mostrar notificaciones antiguas',
        plannedProjects: 'Proyectos planeados',
      },
      navigation: {
        submissiontTab: 'Submission',
        archiveTab: 'Archivo',
        projectsTab: 'Proyectos',
      },
      countrySelect: {
        chooseCountry: 'Elige el país',
      },
    },
    login: {
      loginMessages: 'Registrándote',
    },
    projects: {
      manageProjects: 'Administrar proyectos',
      createProject: 'Crear proyecto',
      bulkCreateProject: 'Crear proyectos masivos',
      replaceCafmAssets: 'Reemplazar el equipo  CAFM',
      returned: 'Devuelto',
      totalProjects: 'Proyectos totales',
      projectsAvailableForUser:
        'Todos los proyectos disponibles para el usuario',
      asset: 'Inmovilizado',
      archiveProject: 'Achivo del proyecto',
      changeProjectStatus: 'Cambiar el estado del proyecto',
      newStatus: 'Nuevo estado',
      assets: 'Inmovilizado',
      requestChanges: 'Solicitar cambios',
      pushToEtr: 'Mover a ETR',
      etrSync: 'Sincronizado con ETR',
      notEtrSync: 'No sincronizado con ETR',
      notSyncedWithEtrMessage:
        'ETR tiene una versión diferente de este proyecto a la que tiene RELTP. Por favor, coordine con el usuario de RE para enviar los últimos cambios de RELTP a ETR, antes de aprobar este proyecto',
      mergeProjects: 'Unificar información de proyectos',
      additionalApproval: 'Aprobaciones adicionales',
      properties: {
        totalProjectInvestmentCostDescription:
          'La inversión total del proyecto debe ser al menos',
        projectsSelected: 'Proyectos seleccionados',
        additionalApprovalBody:
          'El proyecto se encuentra ahora en un estado Planificado. ¿Ha obtenido aprobaciones adicionales?',
        additionalApprovalWarningSwitch:
          'Estás a punto de cambiar el estado del proyecto a Aprobado',
        additionalApprovalRequired: 'Se requiere aprobación adicional',
        totalInvestment: 'Inversión total',
        districtHeatNetKwh: 'Calor de distrito Kwh neto',
        depreciationAccount: 'Cuenta de depreciación',
        cpmFm: 'CPM FM',
        annualCostImpactNetEUR: 'Coste neto anual en EUR',
        totalInvestmentEUR: 'Inversión Total en EUR',
        investmentAmount: 'Importe de la inversión',
        status: 'Status',
        bioFuelsNetKwh: 'Biocombustibles Kwh netos',
        projectInfo: 'Información del proyecto',
        retailCost: 'Retail Cost',
        benefitsAndRisk: 'Beneficios y riesgos',
        riskAvoidance: 'Mitigar los riesgos',
        riskAvoidancePlaceholder:
          '¿Cuál sería el riesgo de no hacer este proyecto?',
        depreciation: 'Depreciación',
        paybackYears: 'Payback (Años) - CALCULADO',
        annualPAndLImpact: 'Impacto anual en la P&L',
        recurringYearlySavings: 'Ahorros Anuales Recurrentes',
        operationalCost: 'Operational Cost',
        totalInvestments: 'Total Investments',
        land: 'Land',
        benefitsAndRisks: 'Beneficios y riesgos',
        additionalInformation: 'Información Adicional',
        projectName: 'Nombre del proyecto',
        businessUnitFullName: 'Nombre del lugar',
        projectStatus: 'Estado del proyecto',
        totalProjectInvestmentEUR: 'Inversión total del proyecto EUR',
        annualCostImpactNet: 'Impacto del coste neto anual',
        biofuelsNetKwh: 'Biocombustibles Neto en Kwh',
        co2eNet: 'Co2e neto',
        etrprojectID: 'Código del proyecto en ETR',
        etrSolutionID: 'Código de la solución en ETR',
        etrUnitID: 'Código de la unidad en ETR',
        unifierID: 'Código de Unifier',
        clusterFMSpecialist: 'Especialista FM Clúster',
        districtFM: 'District FM',
        responsiblLead: 'Responsable (Líder)',
        unitFM: 'Site FM unit',
        cpm: 'CPM',
        assetManagement: 'Asset Management',
        externalPM: 'Externo PM',
        referenceID: 'Código de referencia',
        projectID: 'Código de Projecto',
        etrID: 'Código del ETR',
        projectAssets: 'Equipos del proyecto',
        bu: 'BU',
        landCost: 'Inversión del terreno',
        solutionPurpose: 'Propuesta de solución',
        solutionType: 'Tipo de solución',
        startDate: 'Fecha de inicio',
        completionDate: 'Fecha de Finalización',
        landCG1: 'Land (CG1)',
        landCG1EUR: 'Land (CG1) EUR',
        propertyInvestmentCG111: 'Property Investment (CG1-11)',
        propertyInvestmentCG111EUR: 'Property Investment (CG1-11) EUR',
        retailCostCG1516: 'Retail Cost (CG15-16)',
        retailCostCG1516EUR: 'Retail Cost (CG15-16) EUR',
        accountable: 'Ejecutor',
        priority: 'Prioridad',
        annualCostImpact: 'Impacto coste anual',
        currency: 'Moneda',
        engineer: 'Ingeniero',
        portfolio: 'Portfolio',
        potentialYearlyIncome: 'Ingreso potencial anual',
        projectStartFiscalYear: 'FY inicio del proyecto',
        projectCompletionFiscalYear: 'FY finalización del proyecto',
        recurringYearlyOperationalCost: 'Coste operativo anual recurrente',
        retailInvestmentCG1214: 'Retai Investment (CG12-14)',
        retailInvestmentCG1214EUR: 'Retai Investment (CG12-14) EUR',
        unitType: 'Tipo de unidad',
        updatedAt: 'Actualizado en',
        co2eSociety: 'Sociedad Co2e',
        createdBy: 'Creado por',
        propertyInvestment: 'Property Investment',
        totalElectricity: 'Electricidad comprada',
        retailInvestment: 'Retail Investment',
        sustainID: 'Código de mantenimiento',
        additionalInformationProject:
          'Información adicional (antecedentes del proyecto)',
        mergedWithProject: 'Unificar al proyecto',
        programmeName: 'Nombre del programa',
        programmeStatus: 'Programa S/N',
        projectCompletionFY: 'Finalización del proyecto FY',
        projectEndFY: 'Fin del proyecto FY',
        projectStartFY: 'Inicio del proyecto FY',
        SISANDimensionSolutionPurpose:
          'SISAN Dimensión (Propuesta de la Solución)',
        totalProjectInvestment: 'Inversión total del proyecto',
        LandCG01: 'Land (CG01)',
        propertyInvestmentBuilding:
          'Property Investment (edificio + terreno) (CG01-11)',
        bioFuel: 'Biocombustible',
        districtCooling: 'Refrigeración urbana',
        districHeat: 'Calefacción urbana',
        naturalGas: 'Gas natural',
        electricityGenerated: 'Electricidad generada',
        locationBasedCO2:
          'CO2 basado en la ubicación (basado en factores de emisión promedio del país)',
        ingkaClimateFootprintCalculated:
          'Huella climática de Ingka (factores de emisión reales del sitio basados ​​en el mercado)',
        wasteReduction: 'Residuos al vertedero',
        waterReduction: 'Agua',
        netkWh: 'kWh netos',
        pnlImpact: 'Impacto en la P&L',
        depreciationAmount: 'Importe de depreciación',
        depreciationEur: 'Depreciación EUR',
        districtCoolingNetKwh: 'Kwh neto de refrigeración urbana',
        districtFm: 'District FM',
        etrProjectId: 'código de proyecto en ETR',
        etrSolutionId: 'Código de solución en ETR',
        etrUnitId: 'Código de Unidad en ETR',
        externalContractorsNeeded: 'Se necesitan contratistas externos',
        gasNetKwh: 'Kwh neto de gas',
        generatedNetKwh: 'Kwh netos generados',
        impactYear1: 'Impacto Año 1',
        impactYear1Eur: 'impacto Año 1 EUR',
        legalUnit: 'Compañía Legal',
        mtoolId: 'Código de M-Tool',
        co2e: 'co2e',
        operationalCostEUR: 'Operational Cost EUR',
        plImpactAccount: 'Cuenta de Impacto en la P&L',
        plImpactAmountPerAccount: 'Importe del coste de la P&l por cuenta',
        potentialYearlyIncomeEUR: 'Ingreso potencial anual EUR',
        realEstateDevelopment: 'Real Estate Development',
        recurringYearlyOperationalCostEUR:
          'Coste anual operativo recurrente EUR',
        recurringYearlySavingsEUR: 'Ahorro anual recurrente EUR',
        payback: 'Payback',
        referenceId: 'Código de referencia',
        sustainId: 'Código de sostenibilidad',
        totalElectricityNetKwh: 'Electricidad comprada Neta Kwh',
        unifierId: 'Código de Unifier',
        unitCategory: 'Categoría de unidad',
        unitFm: 'Site FM',
        wasteReductionT: 'Reducción de residuos',
        waterReductionM3: 'Reducción de agua M3',
        pnLImpact: 'Impacto en la P&L',
        projectMergeWithProjectReferenceId:
          'Proyecto unificado con (Registrar el Código de referencia del proyecto)',
        localUniqueId: '',
        changeProjectMessage:
          'Está a punto de cambiar el año de inicio y finalización del proyecto, que ya se agregó anteriormente (se crea el código de M-Tool y se aprueba el estado del proyecto). Elija entre los siguientes pasos posibles a continuación',
        projectEndDate: 'Fecha de finalización del proyecto',
        projectStartDate: 'fecha de inicio del proyecto',
        actionCategory: 'Categoría de acción',
        budgeting: 'Presupuesto (solo Rusia)',
        subcategory: 'Subcategoría (solo Rusia)',
        etrPriority: 'Prioridad ETR',
      },
      hintMessage: {
        chooseABU: 'Elije una BU',
        chooseBUs: 'Elije BUs',
      },
      create: {
        projectInvestment: 'Project Investment',
        opexImpact: 'Impacto del OPEX',
        energyInformation: 'Información de energía',
        createAndPropose: 'Crear y Proponer',
        riskAvoidance: 'Mitigar los riesgos',
        descriptionForEnergyInformation:
          'Ingrese los cambios anuales que genera el proyecto con reducciones en valores negativos',
        generalForm: {
          startFyIsBiggerErrorMessage: 'El FY inicial es mayor que el FY final',
          hintMessage: {
            additionalProjectInformationErrorMessage:
              '# de unidades que se reemplazan, piezas específicas que se reemplazan o marcas relacionadas con los cambios, etc.',
          },
        },
        opexForm: {
          positivePAndLImpact: 'Impacto positivo en la P&L',
          negativePAndLImpact: 'Impacto negativo en la P&L',
          savingAsNegative:
            'IMPORTANTE: Registre los ahorros con número negativo',
          depreciationCalculated: 'Depreciación - CALCULADA',
          annualCostImpactCalculation:
            'Impacto del Coste Neto Anual - CALCULADO',
          paybackYearsCalculated: 'Payback (Años) - CALCULADO',
          paybackYears: 'Payback (Años)',
          annualPAndLImpactCalculated: 'Impacto anual en la P&L - CALCULADO',
          annualPAndLImpact: 'Impacto anual en la P&L',
        },
      },
      userModal: {
        userBusinessUnits: 'Unidades de negocio del usuario',
        userClusters: 'Usuarios del Cluster',
        userCountry: 'Usuarios del País',
      },
      createProjectsFromCafmAssets: 'Crear proyectos a partir de activos CAFM',
    },
    bulkCreate: {
      createProjects: 'Crear proyectos',
      editProjects: 'Editar proyectos',
      table: {
        removeRow: 'Quitar fila',
        copyRow: 'Copiar fila',
        addNewRow: 'Insertar nueva fila',
      },
      investmentModal: {
        projectInvestments: 'Project Investments',
        updateInvestments: 'Actualizar Inversiones',
      },
      createDraftProjects: 'Crear borrador de proyecto(s)',
    },
    flight: {
      makeSubmission: 'Hacer la Submission',
      retailPortfolio: 'Retail Portfolio',
      retailCountryUnit: 'Retail Country/Unit',
      centres: 'INGKA Centres',
      newInfo: 'Nueva información',
      projectsQueue: 'Lista de proyectos',
      boarded: 'Establecido',
      submitted: 'Añadido a la submission',
      loadingProjects: 'Cargando información de proyectos',
      noProjectsAvailable: 'No hay proyectos disponibles',
      addToSubmission: 'Añadir a  la Submission',
      noSubmissionsForAGivenCountry: 'No Submission en un país determinado',
      submission: {
        flightSubmissionTableNewInfo:
          'Proyectos que deben revisarse porque los datos se actualizaron después de la Submission anterior',
        flightSubmissionTableBoarded:
          'Proyectos que se incluyen en la Submission actual',
        flightSubmissionTableQueue:
          'Revise y elija los proyectos que se incluirán en la Submission actual o solicite cambios al responsable del proyecto',
        flightSubmissionTableReturned:
          'Proyectos que se han solicitado cambiar',
      },
      submissionHeader: {
        submissionFinancialCard: {
          exportReport: 'Exportar informe',
        },
      },
      createSubmissionModal: {
        createSubmission: 'Hacer la Submission',
        submissionName: 'Nombre la de Submission',
        sendToETR: 'Enviar a ETR',
      },
      newInfoModal: {
        info: 'Información',
        projectDataWasUpdated: 'Se actualizaron los datos del proyecto.',
        dataUpdateTable: {
          loadingMessage: 'Cargando cambios',
          noPreviousValue: 'Sin valor anterior',
        },
      },
      revertProjectModal: {
        revertProjects: 'Revertir proyectos',
        revertToDraft: 'Volver al borrador',
        projectsRevertedToDraftStatus:
          'Proyectos que volverán al estado Borrador',
        bulkCommentForRevertedProjects:
          'Comentario masivo para proyectos revertidos',
      },
      table: {
        tootTips: {
          projectDataWasChangedClickToViewDetails:
            'Se cambiaron los datos del proyecto. Haga clic para ver los detalles.',
          boardedProject: 'Proyecto establecido',
        },
      },
    },
    user: {
      properties: {
        cluster: 'Cluster',
        userName: 'Nombre de usuario',
      },
    },
    admin: {
      adminPage: 'Página del administrador',
      updateUser: 'Actualizar usuario',
      addUser: 'Agregar usuario',
    },
    currency: {
      currencyPage: 'Página de moneda',
      updateCurrencyRates: 'Actualizar tipos de cambio',
      currencyTable: {
        currencyCode: 'Código de moneda',
        currencyRate: 'Tasa de cambio',
      },
    },
    filter: {
      allFilters: 'Todos los filtros',
      projectsFilters: 'Filtros de proyectos',
      clearFilters: 'Borrar filtros',
    },
    assets: {
      addNewAsset: 'Añadir nuevo equipo',
      addAsset: 'Añadir inmovilizado',
      manufacturerModelYear: 'Fabricante, modelo, año, etc...',
      properties: {
        assetDescription: 'Descripción de los equipos',
        endDate: 'Fecha final',
        replacementCost: 'Coste por reemplazarlo',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        organization: 'Organización',
        unitId: 'Código de Unidad',
        assetGroup: 'Grupo de inmovilizado',
        replaceAssetsDescription:
          'El inmovilizado se organizan según su fecha de su vida útil en CAFM. Elija los equipos que debe reemplazar en su BU. También puede buscar los equipos según la descripción del inmovilizado.',
      },
      replaceAsset: {
        cafmAssetsErrorMsg:
          'No hay inmovilizado en CAFM para la BU seleccionada',
        replaceAssets: 'Reemplazar equipos',
      },
    },
    snackbarMessages: {
      couldNotFetchETRAnalysis: 'Could not fetch ETR Analysis',
      sustainFactorsUpdated:
        'Los factores de sostenibilidad se actualizaron con éxito',
      sustainFactorsUpdateError:
        'No se pudieron actualizar los factores de sostenibilidad',
      fetchProjectError: 'Problema para obtener proyectos',
      projectCreated: 'Proyecto creado',
      couldNotCreateProject: 'No se pudo crear el proyecto',
      projectsSuccessfullyCreated: 'Proyectos creados con éxito',
      couldNotCreateProjects: 'No se pudieron crear proyectos',
      projectUpdated: 'Proyecto actualizado',
      projectCouldNotBeUpdated: 'No se pudo actualizar el proyecto',
      couldNotFetchAssets: 'No se pudo obtener el inmovilizado',
      couldNotFetchCafmAssets: 'No se pudo obtener el inmovilizado de CAFM',
      couldNotFetchUsers: 'No se pudieron recuperar los usuarios',
      updatedUserSuccessfully: 'Usuario actualizado con éxito',
      deletedUserSuccessfully: '',
      couldNotDeleteUser: '',
      couldNotUpdateUser: 'No se pudo actualizar el usuario',
      projectsStatusesWereUpdated: 'Se actualizó el estatus de los proyectos',
      couldNotUpdateProjectsStatuses:
        'No se pudo actualizar el estatus de los proyectos',
      problemGettingBusinessUnits: 'Problema para obtener Business Unit',
      problemGettingUserData: 'Problema al obtener los datos del usuario',
      problemGettingFlightData: 'Problema al obtener los datos transferidos',
      couldNotCreateNewSubmission: 'No se pudo crear una nueva submission',
      couldNotFetchArchiveData: 'No se pudieron obtener los datos del archivo',
      couldNotSendProjectsToArchive:
        'No se pudieron enviar los proyectos para archivar',
      couldNotFetchProjectChanges:
        'No se pudieron recuperar los cambios del proyecto',
      couldNotFetchCurrencyData: 'No se pudieron obtener los datos de moneda',
      successfullyUpdatedCurrencyRates:
        'Tipos de cambio de moneda actualizados con éxito',
      couldNotUpdateCurrencyData:
        'No se pudieron actualizar los datos de moneda',
      problemGettingUpdatedProjects:
        'Problema al obtener los proyectos actualizados',
      couldNotMergeProjects: 'No se pudieron unificar proyectos',
      couldNotFetchSustainFactors:
        'No se pudieron obtener los factores de mantenimiento',
      successfullyUpdatedSustainFactors:
        'Factores de sostenibilidad actualizados con éxito',
      successfullyUpdatedProjects:
        'Los proyectos se actualizaron correctamente',
      couldNotUpdateProjects: 'No se pudieron actualizar los proyectos',
      cannotEditApprovedOrPlannedProjects:
        'Algunos proyectos se eliminaron de la carga masiva porque tienen M Tool-id y están aprobados o planificados',
      problemToAddArchived:
        'Algunos de los proyectos seleccionados no se pueden archivar porque tienen M-Tool Id.',
      problemPushToEtr: 'Error al conectar a ETR',
      successPushToEtr:
        'Los elementos se sincronizarán con ETR en un par de minutos',
      projectsUnArchived: 'Los proyectos se movieron del archivo con éxito',
      projectsUnArchivedError: 'No se pudieron mover los proyectos del archivo',
    },
    validationMessages: {
      projectNameIsRequired: 'El nombre del proyecto es obligatorio',
      buIsRequired: 'Se requiere BU',
      additionalInformationIsRequired: 'Se requiere información adicional',
      benefitsAndRiskIsRequired:
        'Se requiere rellenar los beneficios y riesgos',
      priorityIsRequired: 'Se requiere la prioridad',
      solutionPurposeIsRequired: 'Se requiere la propuesta de la solución',
      solutionTypeIsRequired: 'El tipo de solución es obligatorio',
      completionFYIsRequired: 'Se requiere completar el FY',
      sourceChannelIsRequired: 'El canal de origen es obligatorio',
      programmeIsRequired: 'Se requiere programa',
      startFYIsRequired: 'Se requiere iniciar el FY',
      landValueMustBeANumber: 'El importe del terreno debe ser un importe',
      landValueIsRequired: 'Se requiere el importe del terreno',
      propertyInvestmentMustbeANumber:
        'La inversión de Property debe ser un importe',
      propertyInvestmentIsRequired: 'Se requiere inversión de Property',
      retailInvestmentMustBeANumber:
        'La inversión de Retail debe ser un importe',
      retailInvestmentIsRequired: 'Se requiere la inversión de Retail',
      retailCostMustbeANumber: 'El Retail cost debe ser un importe',
      retailCostIsRequired: 'Se requiere el coste de Retail',
      totalElectricityMustBeANumber:
        'La electricidad comprada debe ser numérico',
      totalElectricityIsRequired: 'Se requiere electricidad comprada',
      gasMustBeANumber: 'El gas debe ser numérico',
      gasIsRequired: 'Se requiere el importe de Gas',
      biofuelsMustBeANumber: 'Los biocombustibles deben ser numéricos',
      biofuelsIsrequired: 'Se requiere el importe de biocombustibles',
      districtHeatMustBeANumber: 'District Heat debe ser numérico',
      districtHeatIsRequired: 'Se requiere el valor del District Heat',
      districtCoolingMustBeANumber: 'District Cooling debe ser numérico',
      districtCoolingIsRequired: 'Se requiere el District Cooling',
      generatedkWhMustBeANumber: 'Los kWh generados deben ser numérico',
      generatedkWhIsRequired: 'Se requiere kWh generados',
      waterReductionMustBeANumber: 'El valor del agua debe ser numérico',
      waterReductionIsRequired: 'Se requiere el valor del agua',
      wasteReductionMustBeANumber:
        'Los residuos al vertedero deben ser numérico',
      wasteReductionIsRequired:
        'Los Residuos al vertedero es campo obligatorio',
      yearlyOperationalCostMustBeANumber:
        'El coste operativo anual debe ser numérico',
      yearlyOperationalCostIsRequired: 'Se requiere coste operativo anual',
      yearlySavingsMustBeANumber: 'Los ahorros anuales deben ser numérico',
      yearlySavingsCostIsRequired: 'Se requiere el importe del ahorro anual',
      yearlyIncomeMustbeANumber: 'El ingreso anual debe ser numérico',
      yearlyIncomeCostIsRequired: 'Se requiere el importe del ingreso anual',
      nameIsRequired: 'Se requiere el nombre',
      mustBeAValidEmail: 'Debe ser un correo electrónico válido',
      emailIsRequired: 'Correo electronico es requerido',
      userMustHaveARole: 'El usuario debe tener una posición',
      userMustHaveAtLeastOneBusinessUnit:
        'El usuario debe tener al menos una BU',
      userMustHaveAtLeastOneCountry: 'El usuario debe tener al menos un país',
      userMustBelongToAtLeastOneCluster:
        'El usuario debe pertenecer al menos a un Cluster',
      propertyInvestmentShouldBeMoreThanLandCost:
        'La Inversión Inmobiliaria (Edificio + Terreno) debe ser mayor o igual que el Terreno.',
      riskAvoidanceRequired: 'Se requiere evitar el riesgo',
      validationError: 'La validación ha fallado',
      shouldBeDateFormatProjectStart:
        'La fecha de inicio del proyecto debe estar en formato AAAA/MM/DD',
      shouldBeDateFormatProjectEnd:
        'La fecha de finalización del proyecto debe estar en formato AAAA/MM/DD',
    },
    solutionPuposes: {
      costsavings: 'Cost savings',
      businessContinuity: 'Business continuity',
      compliance: 'Compliance',
      lifeCycle: 'Life cycle',
      sustainability: 'Sustainability',
    },
    solutionTypes: {
      bmsUpgrade: 'BMS upgrade',
      commercialRepairs: 'Commercial repairs',
      energyEfficiency: 'Energy efficiency',
      led: 'dirigió',
      facadeRepairs: 'Facade repairs',
      fuelCell: 'Fuel cell',
      generators: 'Generators',
      hvac: 'HVAC',
      lightingNonLED: 'Lightning (non LED)',
      parkingRepairs: 'Parking repairs',
      publicInfrastructureIntervention: 'Public infrastructure intervention',
      photovoltaicPanels: 'Photovoltaic panels',
      restrooms: 'Restrooms',
      rhc: 'RHC',
      roofRepairs: 'Roof repairs',
      structuralUpgradesAndRepairs: 'Structural upgrades and repairs',
      equipmentReplacementOrUpgrade: 'Equipment replacement or upgrade',
      tradeDressReplacement: 'Trade dress replacement',
      wasteOther: 'Waste other',
      waterRelatedSystems: 'Water related systems',
      ecopilot: 'Ecopilot',
      flooringRepairs: 'Flooring repairs',
      safetyAndSecurity: 'Safety and security',
      wasteWaterManagement: 'Waste water management',
      evChargers: 'EV chargers',
      legalOrContractual: 'Legal or contractual',
      wasteBaler: 'Waste baler',
      poweroptimiserEPower: 'Power optimiser (E-power)',
      energyEnvelopeDoors: 'Energy envelope doors',
      energyEnvelopeRoof: 'Energy envelope roof',
      metering: 'Metering',
      energyEnvelopeFacade: 'Fachada envolvente energética',
      adaptiveScheduling: 'Programación adaptativa y optimización',
      'Commercial use': 'Uso comercial',
      'Other Food solution': 'Otra solución de alimentos',
    },
    projectPriorities: {
      critical: '1 - Critical',
      necessary: '2 - Necessary',
      recommended: '3 - Recommended',
    },
    programmes: {
      ecopilot: 'Ecopilot',
      electricVehicles: 'Electric vehicles',
      led: 'LED',
      metering: 'Metering',
      powerOptimizer: 'Power optimizer (E-Power)',
      wasteBalers: 'Waste balers',
      eVChargers: 'EV chargers',
      buildingManagementSystems: 'Sistemas de gestión de edificios [LEGACY]',
      electricalSystems: 'Sistemas eléctricos [LEGACY]',
      wasteHandling: 'Equipos de manejo de desechos [LEGACY]',
    },
    statuses: {
      UNQUALIFIED: 'Unqualified',
      QUALIFIED: 'Qualified',
      RETURNED: 'Returned',
      DRAFT: 'Draft',
      NOT_STARTED: 'Not started',
      RUNNING: 'Running',
      DELIVERED: 'Delivered',
      CLOSED: 'Closed',
      CANCELLED: 'Cancelled',
      ON_HOLD: 'On hold',
    },
    buTypes: {
      ikeaStore: 'IKEA Store',
      ikeaSmallStoreS: 'IKEA Small Store S',
      ikeaSmallStoreXS: 'IKEA Small Store XS',
      ikeaSmallStoreLadaS: 'IKEA Small Store (S) Lada',
      ikeaSmallStoreLadaM: 'IKEA Small Store (M) Lada',
      ikeaShop: 'IKEA Shop',
      ikeaPlanAndOrderPoint: 'IKEA Plan and Order Point',
      ikeaMiniPlanAndOrderPoint: 'IKEA Mini Plan and Order Point',
      ikeaPickUpAndOrderPoint: 'IKEA Pick up and Order Point',
      ikeaPickUpPointBranded: 'IKEA Pick up Point (branded)',
      ikeaPickUpPointUnbranded: 'IKEA Pick up Point (unbranded)',
      ikeaPopUp: 'IKEA Pop-up',
      ingkaCentresShopgMall: 'Ingka Centres - Shopg Mall',
      ingkaCentresRetailPark: 'Ingka Centres - Retail Park',
      ingkaCentresOutletCentre: 'Ingka Centres - Outlet Centre',
      customerSupportCentreCSC: 'Customer Support Centre (CSC)',
      distributionCentreDC: 'Distribution Centre (DC)',
      customerDistributionCentreCDC: 'Customer Distribution Centre (CDC)',
      centralParcelUnitCPU: 'Central Parcel Unit (CPU)',
      serviceOffice: 'Service Office',
      externalMerchandisePickUpUnitEMPU:
        'External Merchandise Pick-up Unit (EMPU)',
      externalWarehouse: 'External Warehouse',
      landbank: 'Landbank',
      explorationCase: 'Exploration Case',
      other: 'Other',
    },
    plImpact: {
      positive: 'Positive',
      negative: 'Negative',
    },
    roles: {
      Admin: 'Admin',
      FM: 'FM',
      OA: 'OA',
    },
    status: {
      draft: {
        description: 'El proyecto aún está en etapa de estudio',
      },
      proposed: {
        description:
          'El proyecto es propuesto por el creador del proyecto al District FM para que decida si el proyecto se incluye o no en la submission',
      },
      returned: {
        description:
          'El proyecto se devuelve al creador del proyecto para que lo revise en función de los comentarios.',
      },
      submitted: {
        description:
          'El proyecto se presenta para ser incluido en el  SISAN portfolio del BPLAN del país y Centres BPLAN',
      },
      planned: {
        description:
          'El proyecto está en el BPLAN ahora, pero podría necesitar aprobaciones adicionales basadas en el coste total del proyecto',
      },
      approved: {
        description:
          'El proyecto ha sido aprobado por el (IR, BC, etc.) y ahora se puede ejecutar',
      },
      cancelled: {
        description: 'Proyecto cancelado',
      },
      postponed: {
        description: 'El proyecto se pospone o se pone en espera',
      },
      running: {
        description: 'El proyecto se inicia o está en estudio previo',
      },
      completed: {
        description: 'Proyecto terminado',
      },
    },
    measurements: {
      kgCo2Ton: 'kg CO2e/tonelada',
      kgCo2M3: 'kg CO2e/m3',
      kgCo2Kwh: 'kg CO2e/kWh',
    },
    tooltips: {
      reltp: 'Real Estate Long-Term Planning 2.0 Digital Product',
      saveColumns: 'Guarde la selección de columnas para la vista seleccionada',
      reason: 'Causa de la devolución de un proyecto',
      projects: 'Proyectos bajo SISAN',
      bulkUpdate: 'Actualizar/guardar cambios',
      businessUnit: 'Las BUs vienen de CBD',
      createDraft: 'Crear y guardar el proyecto como borrador',
      updateProject: 'Actualizar/guardar detalles del proyecto',
      changeStatus: 'Cambiar el estado del proyecto',
      mergeByReferenceID:
        'Haga clic aquí si los proyectos se van a unificar con otro proyecto',
      removeFromSubmission:
        'El proyecto se envía de vuelta a la lista de submission',
      sendToArchive: 'El proyecto está archivado',
      fillTheRestAndPropose:
        'Complete la información restante del proyecto y proponga un Mando para su submission',
      createDraftProject: 'Crear y guardar el proyecto como borrador',
      fiscalYear:
        'p.ej. El FY 24 es del 1 de septiembre de 2023 al 31 de agosto de 2024',
      returnMessage: 'Causa para devolver el proyecto',
      projectResources: 'Recursos necesarios para ejecutar el proyecto.',
      updateAndPropose:
        'Actualizar/guardar cambios y proponer un Mando para la submission',
      updateAndApprove: 'Actualizar/guardar la selección y aprobar el proyecto',
      requestChanges:
        'Eliminar el proyecto de la pantalla de envío y solicitar al creador del proyecto que realice cambios en el proyecto',
      pushToEtr: 'Enviar proyecto(s) seleccionado(s) a ETR',
      etrSync: 'La submission se sincronizó con ETR',
      notEtrSync: 'La submission no se sincronizó con ETR',
      mergeProjects:
        'Unificar el proyecto si solo vincula uno o varios proyectos a otro a través del ID de referencia, sin unificar los datos actuales del proyecto',
      additionalApproval:
        'Los Portfolio projets necesitan aprobaciones adicionales, que se pueden seleccionar entre las siguientes opciones',
      totalProjectInvestmentCostDescription:
        'Esto se basa en los datos de reemplazar equipos en CAFM y solo es indicativo',
      annualCostImpactNetEUR: 'No incluye depreciación',
      benefitsAndRisk: 'Generado automáticamente en base a otros campos',
      annualPAndLImpact: 'Impactoen la P&L (incluye depreciación)',
      annualCostImpactNet:
        'Impacto en el coste anual (neto), pero no incluye depreciación',
      referenceID:
        'ID de referencia única del proyecto generado por el sistema en RELTP 2.0',
      locationBasedCO2:
        'Calculado en base a factores establecidos en RELTP 2.0 por el Sustain Superuser',
      ingkaClimateFootprintCalculated:
        'Calculado por la herramienta de Sostenibilidad',
      payback:
        'Calculado - Diviendo el total de la inversión entre el impacto del coste anual neto',
      localUniqueId: '',
      projectName: 'Nombre del proyecto creado',
      additionalInformation: 'Información adicional sobre el proyecto',
      priority: 'Project priority',
      SISANDimensionSolutionPurpose: 'Solución SISAN propuesta del proyecto',
      solutionType: 'Tipo de solución para el proyecto.',
      sourceChannel: 'Canal de origen del proyecto',
      removeAsset: 'Eliminar inmovilizado del proyecto',
      programmeStatus:
        'Seleccione si el programa debe aplicarse a este proyecto',
      replaceAssets: 'Reemplazar equipos seleccionados',
      landCost: 'Coste del terreno para el proyecto',
      programmeName: 'Seleccione el nombre del programa',
      assetQuantity: 'Especifique la cantidad de equipos recién agregados',
      propertyInvestmentBuilding: 'Project property investment',
      retailInvestment: 'Project retail investment',
      retailCost: 'Project retail cost',
      'recurringYearlyOperationalCost:':
        'Coste operativo anual recurrente del proyecto',
      recurringYearlySavings: 'Ahorros anuales recurrentes de los proyectos',
      asset: 'Especifique el grupo de equipos',
      depreciationCalculated: 'Depreciación calculada para el proyecto.',
      addAsset: 'Agregar inmovilizado al proyecto',
      potentialYearlyIncome: 'Ingresos anuales potenciales del proyecto',
      addNewAsset: 'Agregar nuevo inmovilizado',
      replaceAsset: 'Reemplazar inmovilizado existente de la lista',
      riskAvoidance:
        'Por favor, rellene las opciones de evitar los riesgos del proyecto',
      totalElectricity: 'Electricidad total del proyecto.',
      naturalGas: 'Gas natural del proyecto.',
      bioFuel: 'Biocombustibles del proyecto',
      districtHeat: 'Distrito de calor del proyecto',
      districtCooling: 'Refrigeración urbana del proyecto',
      electricityGenerated: 'Electricidad generada del proyecto',
      waterReduction: 'Reducción de agua del proyecto',
      wasteReduction: 'Reducción de residuos del proyecto.',
      createAndPropose: 'crear proyecto y proponer un Mando para su submission',
      discard: 'Descartar cambios y cerrar la pantalla',
      openNotifications: 'Abrir menú de opciones',
      changeLanguage: 'Cambiar el idioma de la aplicación',
      update: 'Actualizar/guardar el proyecto',
      createProject: 'Crear un proyecto',
      edit: 'Editar múltiples proyectos',
      delete: 'Eliminar proyectos seleccionados',
      copy: 'Copiar',
      revertFromArchive: 'Revertir proyectos del archivo',
      BulkCreateProject: 'Crear varios proyectos a la vez',
      countrySelectArchive:
        'Seleccione el país para ver el proyecto archivado de ese país',
      createProjectsFromCafmAssets:
        'Crear un proyecto a partir del inmovilizado de CAFM',
      fySelectFlight: 'Seleccione el FY para ver las submission de ese año',
      countrySelectFlight:
        'Seleccione el país para ver las submission de ese país',
      makeSubmission: 'Crear la submission',
      addToSubmission: 'Agregar proyectos a la submission actual',
      submissionName: 'Nombre de la nueva submission creada',
      archiveTab: 'Pestaña para ver los proyectos archivados',
      submissionTab: 'Pestaña para ver las submission',
      projectsTab: 'Pestaña para controlar los proyectos',
      projectsPageBUSelect: 'Seleccione BU para ver sus proyectos',
      filterAll: 'Haga clic para abrir las opciones de Filtros',
      filterRetail:
        'Haga clic para filtrar los proyectos del Portfolio de Retail',
      filterRetailCountry: 'Haga clic para filtrar los proyectos de Retail',
      filterCentre: 'Haga clic para filtrar los proyectos de INGKA Centres',
      totalInvestmentByType:
        'Importe total de la inversión por tipo de proyecto',
      actionCategory: 'Seleccione la categoría de acción',
      BulkCreateFromProject:
        'Crear nuevos proyectos a partir de uno seleccionado',
      etrPriority: 'Prioridad otorgada por ETR',
      bulkExistingProject: 'Este proyecto ya existe y está en modo de edición.',
      bulkExistingApprovedProject:
        'Los proyectos aprobados no se pueden editar en esta pantalla',
      unitType: '',
      resetColumns: '',
    },
    approval: {
      irApproved: 'IR aprobado',
      businessCaseApproved: 'Business case aprobado',
    },
    notApplicable:
      'No aplicable / No se necesita aprobación de un Business Case',
    privacy: {
      title: 'Declaracion de privacidad',
      header:
        'Cuando utiliza RELTP 2.0, el Controlador de datos de la empresa del Grupo Ingka (como se define a continuación) recopilará ciertos datos personales sobre usted.',
      personalDataBold: 'Los datos personales recabados son:',
      personalData:
        'ID de correo electrónico de trabajo, nombre, segundo nombre y apellido',
      purposeBold: 'La finalidad de la recogida de estos datos es:',
      purpose:
        'Para asegurar la responsabilidad del usuario y el historial de actividades. En RELTP2.0, guardamos el nombre de los compañeros de trabajo y la identificación de correo electrónico, ya que necesitamos saber quién ha creado proyectos y el historial de acciones realizadas en un proyecto.',
      legalBold: 'La base legal para el procesamiento es:',
      legal:
        'El interés legítimo del Responsable del Tratamiento en proporcionar las herramientas y aplicaciones necesarias a su equipo de trabajo.',
      dataBold: 'Los datos serán almacenados:',
      data: 'Los datos se almacenarán hasta la fecha de salida de los empleados de IKEA',
      controllerBold:
        'El controlador de datos para este procesamiento de datos personales es:',
      controller: 'IKEA limitada',
      footer:
        'Sus datos personales pueden compartirse con otras empresas del Grupo Ingka, así como con proveedores de servicios del Grupo Ingka con el fin de proporcionar el RELTP 2.0.',
      rights:
        'Usted tiene ciertos derechos en relación con su personal. Para saber más sobre tales derechos. Por favor visita',
    },
    actionCategories: {
      water: 'Agua',
      energy: 'Energía',
      waste: 'Desperdicio',
      na: 'N / A',
    },
    projectETRPriorities: {
      A: 'Alto',
      B: 'Medio',
      C: 'Bajo',
    },
  },
  en: {
    ppm: {
      selectCountry: 'Select Country',
      selectCountryHint: 'Select several countries if needed',
      actions: {
        resetToDefaults: 'Reset to defaults',
        changeStatus: 'Change Status',
        deleteProject: 'Delete project',
        archiveProject: 'Archive project',
        approve: 'Approve',
        captureRevisedBudget: 'Capture Revised Budget Baseline',
        approvedCRP: 'Approved CRP plan',
        addToCrp: 'Add CRP',
        addToApprovedCrp: 'Add Approved CRP',
      },
      isepStatuses: {
        PART_OF_CRP: 'Part of CRP',
        RISK_MONEY_APPROVED: 'Risk Money Approved',
        BPA_SUPPORTED: 'BPA Supported',
        IR_APPROVED: 'IR Approved',
        FINAL_IR_APPROVED: 'Final IR Approved',
        DELIVERED: 'Delivered',
      },
      validations: {
        NOT_STARTED: 'Not started',
        NOT_SUPPORTED: 'Not supported',
        IN_PROGRESS: 'In progress',
        VALIDATED: 'Validated',
        NOT_APPLICABLE: 'Not applicable',
      },
      subportfolios: {
        CENTRES_PORTFOLIO: 'Centres Portfolio',
        COMMERCIAL_AND_COWORKER_AREAS_AND_CONCEPT:
          'Commercial & co-worker areas and concept',
        COUNTRY_P_AND_L: 'Country P&L',
        DIGITAL_TECHNOLOGY: 'Digital Technology',
        FULFILMENT_AND_REPLENISHMENT:
          'Fulfilment & Replenishment (NEW + SISAN)',
        GROWTH_NEW_CMPS: 'Growth/New CMPs',
        PROPERTY_EXITS: 'Property exits',
        REAL_ESTATE:
          'Real Estate (Asset Lifecycle and compliance & Energy Water Waste)',
        SPACE_OPTIMISATION_WITH_3RD_PARTY: 'Space optimisation with 3rd party',
        NONE: 'None',
      },
      isepStatusesHistorical: {
        H_SITE_IR_APPROVED: 'Site IR approved',
        H_CITY_PLANS_APPROVED: 'City Plans approved',
        H_NEW_COUNTRY_PLANS_APPROVED: 'New Country plans approved',
      },
      isep: {
        description: 'Project part of the Ingka strategic expansion plan',
        approved: 'ISEP approved',
        directiveCaution:
          'The project(s) directive lacks required information. If project is set to ISEP yes, the project directive will be locked in its current state',
      },
      partOfFda: {
        description: 'Project part of the FDA',
        approved: 'FDA approved',
      },
      fundedBy: {
        description: 'Financial portfolio that is funding the project',
        options: {
          CC9: 'CC9',
          COUNTRY_P_AND_L: 'Country P&L',
          CENTRE: 'CENTRE',
          DIT: 'DIT',
          DIGITAL: 'DIGITAL',
          RMP: 'RMP',
        },
      },
      GEX: {
        alignedWithGex: 'RMP Portfolio status',
        alignedWithGexStartDate: 'Baseline Start Date',
        alignedWithGexOpeningDate: 'Baseline Opening Date',
        description:
          'Projects are aligned with the Ingka Expansion strategy and funding reserved in accordance with estimated budget:',
        comment: 'RMP Portfolio comment',
        commentDescription: 'GEX comment description:',
        options: {
          BASELINE: 'Baseline',
          UNDER_DISCUSSION: 'Under discussion',
          ADD_ON: 'Add on',
          SPILLOVER: 'Spillover',
        },
      },
      OCN: {
        description: 'Fulfillment and Replenishment project priorities',
      },
      columns: {
        id: 'ID',
        projectStatus: 'Project status',
        projectName: 'Project name',
        country: 'Country',
        city: 'City',
        unitType: 'Unit type',
        establishmentPlan: 'Establishment Plan',
        transactionType: 'Transaction type',
        startDate: 'Start date',
        openingDate: 'Project Delivery Date',
        solutionCategory: 'Solution Category',
        buCode: 'BU Code',
        responsible: 'Country Project Responsible',
        referenceId: 'Reference ID',
        mtoolId: 'MTool ID',
        isep: 'ISEP',
        partOfFda: 'Part of FDA',
        partOfOnePlan: 'Part Of One Plan',
        realEstateSISAN: 'Real Estate SISAN',
        upcomingDP: 'Upcoming DP',
        crp: 'Part of an approved CRP',
        cityPlan: 'Part of a city plan',
        partOfCRPPlan: 'Part of CRP plan',
        partOfApprovedCRP: 'Part of approved CRP plan',
        isepApproval: 'ISEP approval',
        totalBudget: 'Current FY Total budget',
        totalLand: 'Total Budget Land',
        totalProperty: 'Total Budget Property',
        totalRetail: 'Total Budget Retail',
        totalRetailCost: 'Total Budget Retail Cost',
        total: 'Total Investment',
        totalForecast: 'FY26 Total Forecast Euro',
        totalReleased: 'FY26 Total Released/Approved',
        totalActuals: 'FY26 Total Actuals',
        land: 'Total Budget land',
        property: 'Total Budget property',
        retail: 'Total Budget retail',
        retailCost: 'Total Budget retail cost',
        totalBudgetAllFY: 'All FY Total budget',
        forecastLandCost: 'FY26 Forecast Land Cost Euro',
        forecastPropertyInvestment: 'FY26 Forecast Property Investment Euro',
        forecastRetailInvestment: 'FY26 Forecast Retail Investment Euro',
        forecastRetailCost: 'FY26 Forecast Retail Cost Euro',
        forecastLandCostFY27: 'FY27 Forecast Land Cost Euro',
        forecastPropertyInvestmentFY27:
          'FY27 Forecast Property Investment Euro',
        forecastRetailInvestmentFY27: 'FY27 Forecast Retail Investment Euro',
        forecastRetailCostFY27: 'FY27 Forecast Retail Cost Euro',
        forecastLandCostFY28: 'FY28 Forecast Land Cost Euro',
        forecastPropertyInvestmentFY28:
          'FY28 Forecast Property Investment Euro',
        forecastRetailInvestmentFY28: 'FY28 Forecast Retail Investment Euro',
        forecastRetailCostFY28: 'FY28 Forecast Retail Cost Euro',
        forecastLandCostFY29: 'FY29 Forecast Land Cost Euro',
        forecastPropertyInvestmentFY29:
          'FY29 Forecast Property Investment Euro',
        forecastRetailInvestmentFY29: 'FY29 Forecast Retail Investment Euro',
        forecastRetailCostFY29: 'FY29 Forecast Retail Cost Euro',
        projectEndDateFY: 'Project End Date FY',
        countryName: 'Country Name',
        unitCategory: 'Unit Category',
        establishmentType: 'Establishment type',
        subPortfolio: 'Sub-portfolio',
        projectOwner: 'Project Owner',
        siteType: 'Site Type',
        solutionPurpose: 'Solution purpose',
        solutionType: 'Solution type',
        replenishmentUnit: 'Replenishment Unit',
        stockedRangeAdjustment:
          'Inbound: Net adjustment of Storage throughput (Th m3)',
        truckFulfilmentCapacityAdjustment:
          'Outbound: Net adjustment of Truck fulfilment capacity (Th m3)',
        parcelFulfilmentCapacityAdjustment:
          'Outbound: Net adjustment of Parcel fulfilment capacity (Th m3)',
        totalNumberOfFullTimeEmployees:
          'Total number of Full Time Employees (FTEs)',
        totalNumberOfEmployees: 'Total number of employees',
      },
    },
    transactionTypes: {
      BUY: 'Buy',
      DIVEST: 'Divest',
      FULLY_CONTRACTED_UNIT: 'Fully Contracted Unit',
      LEASE: 'Lease',
      LEASE_EXPIRATION: 'Lease Expiration',
      LEASE_TERMINATION: 'Lease Termination',
      NO_TRANSACTION: 'No Transaction',
    },
    actions: {
      createNewUnit: 'Create New Project',
    },
    projectTypes: {
      newUnit: 'Establish New',
      improve: 'Improve Existing (SISAN)',
      formatChange: 'Change Format',
      relocation: 'Relocate',
      close: 'Close',
      NEW: 'New Unit',
      SISAN: 'Improve',
      FORMAT_TRANSFORMATION: 'Change Format',
      RELOCATION: 'Relocate',
      CLOSE: 'Close',
    },
    establishmentTypes: {
      NEW: 'New Unit',
      SISAN: 'Improve',
      FORMAT_TRANSFORMATION: 'Change Format',
      RELOCATION: 'Relocate',
      CLOSE: 'Close',
    },
    projectTypesCaption: {
      newUnit:
        'Establishment of a New (Ingka) Business Unit, i.e. IKEA Store, Distribution Centre, Office, Meeting Place, non-core business asset.',
      improve:
        'Improve and optimize our Existing (Ingka) Business Units according to the defined solution categories, i.e. Space optimization with 3rd party, Commercial and co-worker areas, Fulfilment and Replenishment.',
      formatChange:
        'When the format of the unit changes to another type of format. Example: transforming an IKEA Store or PaOP into a Small Store.',
      relocation:
        'Relocation of an existing unit to a different location in the market.  Here you register the New (Ingka) Business Unit. The closure of the existing Business Unit should be registered separately with a dependency to the relocation.',
      close:
        'Closure of an existing (Ingka) Business Unit, i.e IKEA Store, land divestment. Can be a lease expiration, lease termination or divestment. Note! Closure projects are not funded by the RMP Portfolio.',
    },
    automationLevel: {
      NONE: 'None',
      HIGH: 'High',
      MEDIUM: 'Medium',
    },
    siteTypes: {
      BUILDING: 'Building',
      LAND: 'Land',
      PART_OF_BUILDING: 'Part of Building',
      PART_OF_LAND: 'Part of Land',
    },
    budgetTypes: {
      ACTUALS: 'Actuals',
      BASELINE: 'Baseline',
      SUBMITTED_FORECAST: 'P-Tools Forecast',
      BUDGET: 'Project budget',
      FORECAST: 'Forecast',
      RELEASED_APPROVED_BUDGET: 'Released/Approved amount',
    },
    siteProgress: {
      EXISTING_SITE: 'Existing site',
      SITE_SEARCH_NOT_STARTED: 'Site search not started',
      SITE_SEARCH_ONGOING: 'Site search ongoing',
      LIGHT_DUE_DILIGENCE_ONGOING: 'Light due diligence ongoing',
      FEASIBILITY_STUDY_ONGOING: 'Feasibility study ongoing',
      SITE_SELECTION_DP1: 'Site selection (DP1)',
      FULL_DUE_DILIGENCE_ONGOING: 'Full due diligence ongoing',
      SITE_ACQUISITION_ONGOING: 'Site acqusition ongoing',
      SITE_CONFIRMED_AND_AGREEMENT_SIGNED:
        'Site confirmation & agreement signed',
    },
    tabs: {
      overview: 'Overview',
      required: 'Required',
      project: 'Project',
      siteUnit: 'Site/Unit',
      solutions: 'Solutions',
      responsible: 'Responsible',
      capacity: 'Capacity',
      statuses: 'Statuses',
      financials: 'Financials',
      dp: 'Decision Points',
      confidentialUsers: 'Confidential Users',
      activityLog: 'Activity Log',
    },
    finances: {
      projectBudget: 'Project budget',
      totalProjectBudget: 'Total project budget',
    },
    labels: {
      partOfApprovedProgramme: 'Part of approved programme',
      updateProjectStatus: 'Update Project Status',
      openingFyTertial: 'Opening Fy-tertial',
      DP2: 'DP2',
      communicationsAndPcComplexity: 'Communications and P&C complexity',
      terminationOfFranchiseeAgreement:
        'Termination of Franchisee Agreement/Operating certificate',
      CBDName: 'CBD Name',
      externalLeaseCommitment: 'External Lease Commitment',
      costAtLeaseEnd: 'Cost at Lease End',
      leasedFromIngka: 'Leased from another Ingka company?',
      examplePlaceholderExternalLease:
        'External lease amount for the total lease period',
      Confidentiality: 'Confidentiality',
      countryRetailPlan: 'Country retail plan',
      chooseCrpFy: 'Choose the CRP FY',
      partOfCrp: 'Part of CRP',
      examplePlaceholderCostAtEnd:
        'Extra costs associated with exiting the site',
      dependencyLink: 'Link/Dependency to another project',
      establishmentType: 'Establishment type',
      projectBg: 'Project background and scope',
      solutionDescriptionAndCost: 'Solution description and cost',
      estimatedReturn: 'Estimated return or if no return please comment',
      projectPrioritisation: 'Project Prioritisation',
      inboundStockedRange:
        'Inbound: Net adjustment of Replenishment throughput (Th m3)',
      inboundStorageCapacity:
        'Inbound: Net adjustment of Storage throughput (Th m3)',
      outboundTruckCapacity:
        'Outbound: Net adjustment of Truck fulfilment capacity (Th m3)',
      outboundParcelCapacity:
        'Outbound: Net adjustment of Parcel fulfilment capacity (Th m3)',
      automationLevel: 'Automation Level',
      replenishmentUnit: 'Replenishment Unit',
      projectOwner: 'Project Owner',
      projectOrderer: 'Project Orderer',
      projectAdmin: 'Project Admin',
      projectManager: 'Project manager/leader',
      clusterREManager: 'Cluster Real Estate Manager',
      realEstateClusterResponsible: 'Cluster Real Estate Responsible',
      reDevLead: 'Real Estate Development Leader',
      planningLeader: 'CPH Planning Project Leader',
      constructionManager: 'Construction Project Manager',
      digitalLeader: 'Digital Expansion Leader/Specialist',
      state: 'State',
      address: 'Address',
      siteType: 'Site Type',
      leasePeriod: 'External Lease Period',
      projectStatusDate: 'Project Status Date',
      countryProjectStatusComment: 'Country Project Status Comments',
      projectTimeStatusComment: 'Project Time Status Comments',
      fySplit: 'Fy split',
      totals: 'Totals',
      projectDetails: 'Project Details',
      grossUnitArea: 'Gross unit area (m2)',
      unifierId: 'Unifier ID',
      isConfidential: 'Is project confidential',
      projectInformation: 'Project information',
      projectDates: 'Project dates',
      projectCloseDate: 'Project Delivery Date',
      projectClosingDate: 'Project Closing Date',
      CFFDesignStartDate: 'CFF design start date',
      centralPlanningHubStartDate: 'Central Planning hub start date',
      centresDesignStartDate: 'Centres design start date',
      constructionStartDate: 'Construction start date',
      siteInformation: 'Site information',
      BUCodeLocationName: 'BU code/Location name',
      initialProjectStartDate: 'Initial Start Date',
      initialOpeningDate: 'Initial Delivery Date',
      initialProjectClosingDate: 'Initial Project Closing Date',
      internalAnnouncementDate: 'Internal Announcement Date',
      externalAnnouncementDate: 'External Announcement Date',
      handoverToLandlordDate: 'Handover To Landlord Date (leased unit)',
      finalDeedDate: 'Final Deed Date (sale of owned asset)',
      partOfProgramme: 'Part of programme',
      siteProgress: 'Site Progress',
      siteAgreementSignDate: 'Site Agreement Sign Date',
      siteAccessibleDate: 'Site Accessible Date',
      landSize: 'Land size (m2)',
      grossBuildingArea: 'Gross Building Area (GBA) (m2)',
      businessUnitId: 'Business Unit ID',
      buNumber: 'BU Number',
      solutionTypeSelect: 'Select solution type',
      solutionDescription: 'Solution Description',
      solutionPurpose: 'Solution purpose',
      solutionType: 'Solution type',
      addSolution: 'Add Solution',
      people: 'People',
      employersNumber: `Total number of Full Time Employees (FTE's)`,
      employersTotalNumber: 'Total number of employees',
      estimatedPeopleImpact: 'Estimated people impact',
      expansionProjectEditors: 'Add users to the project',
      newUnitType: 'New Unit type',
      leaseExpirationDate: 'Lease expiration date',
      existingUnit: 'Existing Unit',
      unitDates: 'Unit Dates',
      unitOpeningDate: 'Date of Unit opening',
      plannedUnitClosureDate: 'Planned Unit Closure Date',
      unitClosureDate: 'Unit Closure Date',
      unitClosingDate: 'Unit Closing Date',
      closingDateFy: 'Closing date FY-tertial',
      lastDateOfOperations: 'Last Date of Operations',
      franchiseAgreementDate: 'Franchise Agreement Date',
      approvalInPrincipleDate: 'Approval in Principle Date',
      deedOfTerminationSignDate: 'Deed of termination sign date',
      reasonOfClosingUnit: 'Reason of Closing of the Unit',
      confidentialProject: 'Confidential Project',
      confidentialLevel: 'Confidential Level',
      plannedAnnouncementDate: 'Planned Announcement Date',
      internalCommunication: 'Internal Communication',
      externalCommunication: 'External Communication',
      astroDecommissioning: 'Need for Astro decommissioning',
      estimatedNetEffort: 'Estimated Net Effect (kEUR)',
      examplePlaceholderCity: 'City written in native language: E.g Älmhult',
      examplePlaceholderClosureFinancial:
        'Enter the “Net effect on operations P&L” found on the divestment tab of the “Repurposing Scenario Tool”.',
      examplePlaceholderAddress: '',
      examplePlaceholderLeasePeriod: 'Number of months e.g 12',
      examplePlaceholderState: 'Four characters state code. Example: ISO 3166',
      examplePlaceholderLocation: 'The specific area in the city',
      examplePlaceholderLand:
        'Area of a land plot planned to acquire specified in square meters.',
      examplePlaceholderGrossBuilding:
        'GBA is only applicable for buildings. The floor area at all levels measured from the outside face of external walls, excluding all types of parking.',
      examplePlaceholderGrossUnit:
        'Total surface of the IKEA unit and other areas measured in accordance with IKEA measurement principles',
      projectOpeningDate: 'Project Delivery Date',
      projectDeliveryDate: 'Project Delivery Date',
      initialProjectDeliveryDate: 'Initial Project Delivery Date',
      unifierIdHelperText: 'Expected format: CMT01234',
      viewProjectDirective: 'View project directive',
      projectDirective: 'Project Directive',
      exportToPdf: 'Export to PDF',
      sectionGeneral: 'General',
      sectionDates: 'Dates',
      isepDate: 'ISEP Date',
      sectionDependencies: 'Dependencies',
      sectionInvestment: 'Investment',
      sectionReplenishmentAndFulfilment: 'Replenishment and Fulfilment Network',
      sectionPeople: 'People',
      dependenciesToOtherProjects: 'Dependencies to other projects',
      propertyInvestmentCg0111: 'Property investment (CG 01-11)',
      retailCostsCg1516: 'Retail costs (CG 15-16)',
      retailInvestmentCg1214: 'Retail investment (CG 12-14)',
      centresComponentsCg1720: 'Centres components (CG 17-20)',
      totalProjectAmountInclExternalLease:
        'Total project amount incl. external lease commitment',
      inboundCapacityNetThroughput:
        'Inbound capacity: Net adjustment of throughput (Th m3)',
      totalFullTimeEmployees: 'Total number of Full Time Employees (FTEs)',
      totalEmployees: 'Total number of employees',
      unitCategoryLabel: 'Unit category',
      propertyInvestment: 'Property investment',
      retailInvestment: 'Retail investment',
      retailCost: 'Retail Cost',
      totalLeaseAmount: 'External Lease Commitment',
      notSet: 'Not set',
      noProject: 'No project',
      directiveMissingTooltip:
        'This information is required for the project directive.',
      directiveEditTooltip: 'Edit information in the project',
      directiveExportDisabledTooltip:
        'Once the project receives ISEP yes, it will be available for export.',
    },
    confidentialityLevels: {
      CONFIDENTIAL: 'Confidential',
      INTERNAL: 'Internal',
      STRICTLY_CONFIDENTIAL: 'Strictly confidential',
    },
    validation: {
      projectStatusDate: 'Project Status Date is required',
      projectStartDate: 'Project Start Date is required',
      projectCloseDate: 'Project Delivery Date is required',
      projectOpeningDate: 'Project Delivery Date is required',
      projectClosingDate: 'Project Closing Date is required',
      openingDate: 'Delivery Date is required',
      transactionTypeRequired: 'Transaction Type is required',
      leasedFromIngkaRequired:
        'Please select if leased from another Ingka company',
      country: 'Country is required',
      inboundStockedRange: 'Inbound: Net adjustment is required',
      inboundStorageCapacity: 'Inbound Storage Capacity is required',
      outboundTruckCapacity: 'Outbound Truck Capacity is required',
      outboundParcelCapacity: 'Outbound Parcel Capacity is required',
      automationLevel: 'Automation Level is required',
      confidential: 'Confidential status is required',
      siteType: 'Site Type is required',
      siteProgress: 'Site Progress is required',
      realEstateClusterResponsible:
        'Real Estate Cluster Responsible is required',
      projectDependency: 'Dependency is required',
      establishmentType: 'Establishment Type is required',
      businessUnitId: 'Business Unit ID is required',
      buType: 'BU Type is required',
      isPartOfProgram: 'Part of programmed is required',
      countryProjectResponsible: 'Country project responsible is required',
      projectEndDate: 'Project End Date is required',
    },
    message: {
      inputInLocalCurrency:
        'Input the financial details in the currency local to your region',
      inputInThousands:
        'Amount should be in thousands for example  1 million EUR  should be 1 000 and not 1 000 000 ',
      confidentialProject:
        'By marking a project as confidential it will not be available in the PBI reports',
      requiredMessage:
        'This tab is your starting point for project creation. It consolidates all necessary fields required for project initiation.',
      noSolutions: 'There are no solutions added yet. Add a solution bellow.',
      projectType: 'What type of project are you creating?',
    },
    sustainFactors: {
      updateSustainRates: 'Update Sustain Rates',
      sustainFactorsPage: 'Sustain Factors Page',
      properties: {
        countryName: 'Country Name',
        electricityPurchasedMarketBased: 'Electricity Purchased Market-based',
        electricityChange: 'Electricity Purchased Location-based',
        districtHeating: 'District Heating',
        gas: 'Gas',
        districtCooling: 'District Cooling',
        bioFuel: 'Bio Fuel',
        electricityGenerated: 'Electricity Generated',
        water: 'Water',
        waste: 'Waste to landfill',
      },
    },
    navigation: {
      manageUsers: 'Manage Users',
      manageCurrency: 'Manage Currency',
      sustainPage: 'Sustain Page',
    },
    common: {
      accept: 'Accept',
      activeDecisionPoint: 'Active Decision Point',
      editProject: 'Edit Project',
      fundedBy: 'Funded by',
      save: 'Save',
      yes: 'Yes',
      yesSure: `Yes, I'm sure`,
      no: 'No',
      underDiscussion: 'Under Discussion',
      OCNPriority: 'OCN Priority',
      create: 'Create',
      comment: 'Comment',
      all: 'All',
      loading: 'Loading...',
      id: 'ID',
      reltp: 'RELTP EN 2.0',
      signOut: 'Sign out',
      servicePages: 'Service Pages',
      saveColumns: 'SAVE COLUMNS',
      returnedNotification: 'returned!',
      requiredField: 'Required field',
      actions: 'Actions',
      reason: 'Reason',
      projects: 'Projects',
      confirm: 'Confirm',
      quantity: 'Quantity',
      reltpMessages: 'RELTP messages',
      fy: 'FY',
      country: 'Country',
      total: 'Total',
      email: 'Email',
      role: 'Role',
      bulkUpdate: 'Update',
      businessUnit: 'Business Unit',
      countryCode: 'CountryCode',
      createDraft: 'Create Draft',
      changeStatus: 'Change project status',
      changeStatusDescription:
        'Change the project status for selected projects using the dropdown menu. For more details on the available status options, refer to the FAQ.',
      partOfCRPPlan: 'Country retail plan',
      partOfCRPPlanDescription1: 'Choose the CRP this project belongs to.',
      partOfCRPPlanDescription2:
        'For qualified projects: Project will automatically be moved to Draft status and become available in Power BI reports.',
      notAdded: 'Not added',
      partOfApprovedCRP: 'Part of Approved CRP',
      partOfApprovedCRPPlan: 'Approved Country retail plan',
      partOfApprovedCRPDescription:
        'Project directional approved by Country Board i.e. saving the current information to capture projects part of the approved CRP.',
      mergeByReferenceID: 'Merge by reference ID',
      removeFromSubmission: 'Remove from Submission',
      sendToArchive: 'Send to Archive',
      fillTheRestAndPropose: 'Fill the rest and propose',
      createDraftProject: 'Create Draft Project',
      fiscalYear: 'Fiscal year',
      view: 'View',
      returnMessage: 'Return message',
      projectResources: 'Project Resources',
      updateAndPropose: 'Update & Propose',
      updateAndApprove: 'Update & Approve',
      viewProject: 'View Project',
      updateProject: 'Update The Project',
      update: 'Update',
      hours: 'Hours',
      name: 'Name',
      delete: 'Delete',
      archive: 'Archive',
      discard: 'Discard',
      cancel: 'Cancel',
      warning: 'Warning',
      deleteTheseProjects: 'Are you sure you want to delete these projects?',
      archiveTheseProjects: 'Are you sure you want to archive these projects?',
      bulkEdit: 'Bulk edit',
      loadingMsg: {
        checkingYourPermissions: 'Checking your permissions',
        loading: 'Loading...',
      },
      totalEUR: 'Total in EUR',
      areYouSure: 'Are you sure?',
      discardConfirmationMessage:
        'You have made some changes, do you want do discard them and close modal?',
      revertFromArchive: 'Revert from archive',
      bulk: 'Bulk',
      close: 'Close',
      resetColumns: 'RESET COLUMNS',
      saveLink: 'Connect',
      createMsTeamsSubTitle: 'Create new channel',
      createMsTeams: 'Create New Teams',
      addMsTeamsLink: 'Connect Microsoft Teams',
      addMsTeamsLinkDescription:
        'Connect your project to Microsoft Teams. You can either create a new channel or link an existing one.',
      msTeamsLinkTitle: 'Link Existing Channel',
      msTeamsLinkSubTitle: 'Microsoft Teams Channel URL',
      msTeamsLinkPlaceholder: `Teams Link e.g. https://teams.microsoft.com`,
      msTeamsLinkLabel: `Find the link in Teams by using the three dots next to the channel name > 'Copy link'`,
    },
    appBar: {
      openSettings: 'Open settings',
      mobileMenu: {
        accountOfCurrentUser: 'account of current user',
      },
      notificationMenu: {
        noNotifications: 'No notifications',
        new: 'new',
        returnedProjects: 'Returned Projects',
        showOldNotifications: 'Show old notifications',
        plannedProjects: 'Planned Projects',
        etrComments: 'ETR Comments',
      },
      navigation: {
        submissiontTab: 'Submission',
        archiveTab: 'Archive',
        projectsTab: 'Projects',
        financialFramesTab: 'Financial Frames',
      },
      countrySelect: {
        chooseCountry: 'Choose Country',
      },
    },
    login: {
      loginMessages: 'Signing you in',
    },
    dp: {
      overdraft: 'Overdraft',
    },
    etrSyncStatus: {
      synced: 'Synced With ETR',
      notSynced: 'Not Synced With ETR',
      notApplicable: 'Not Applicable',
    },
    projects: {
      downloadEtrAnalysis: 'Download ETR analysis',
      unlinkProject: 'Unlink Project',
      relinkProject: 'Relink Project',
      referenceIdModalText: `Are you sure you want to change project's Reference ID?`,
      confirmNotPlanningToStart:
        'Project will be converted to draft, and will have to pass full cycle again',
      notPlanningToStart: 'No intention to start this FY',
      manageProjects: 'Manage Projects',
      createProject: 'Create Project',
      bulkCreateProject: 'Bulk Projects Create',
      replaceCafmAssets: 'Replace CAFM Assets',
      returned: 'Returned',
      totalProjects: 'Total Projects',
      projectsAvailableForUser: 'All projects available for user',
      asset: 'Asset',
      archiveProject: 'Archive project',
      archiveProjectDescription:
        'Archiving this project will move it to the archive, preserving all information and progress. The project will no longer appear in the active project list, but you can restore it from the archive at any time.',
      deleteProjectDescription:
        'Deleting this project will permanently remove all associated information and progress. Any integrations with other tools will also be disconnected.',
      crpDescription:
        'Choose the CRP this project belongs to. Once selected, the project moves to Draft and becomes available in Power BI reports.',
      changeProjectStatus: 'Change Project Status',
      newStatus: 'New Status',
      assets: 'Assets',
      bulkApproval: 'Bulk Approval',
      requestChanges: 'Request Changes',
      pushToEtr: 'Push to ETR',
      etrSync: 'Synced with ETR',
      notEtrSync: 'Not synced with ETR',
      notSyncedWithEtrMessage:
        'ETR has a different version of this project than what RELTP has. Please align with RE user to push latest changes from RELTP into ETR, before approving this project',
      mergeProjects: 'Merge Projects',
      additionalApproval: 'Additional Approvals',
      properties: {
        unitId: 'Unit ID',
        POContractNumber: 'PO/Contract Number',
        POContractAmount: 'PO/Contract Amount',
        projectRisk: 'Project Risk',
        linkToDocuments: 'Link To Documents',
        deviationForecastVsBudget: 'Deviation (Forecast Vs. Budget)',
        totalForecast: 'Total Forecast',
        totalForecastEur: 'Total Forecast EUR',
        totalProjectForecast: 'Total Project Forecast',
        totalActuals: 'Total Actuals',
        totalProjectActuals: 'Total Project Actuals',
        noActualsFetched: 'No actuals fetched/reported',
        initialPlannedProjectStartDate: 'Initial Planned Project Start Date',
        initialPlannedProjectEndDate: 'Initial Planned Project End Date',
        totalProjectInvestmentCostDescription:
          'Total project investment should be at least',
        projectsSelected: 'Projects selected',
        additionalApprovalBody:
          'Project is now in a Planned state. Have you secured additional approvals?',
        additionalApprovalWarningSwitch:
          'You are about to switch the project status to Approved',
        additionalApprovalRequired: 'Additional approval required',
        totalInvestment: 'Total Investment',
        districtHeatNetKwh: 'District Heat Net Kwh',
        depreciationAccount: 'Depreciation Account',
        cpmFm: 'Cpm Fm',
        annualCostImpactNetEUR: 'Annual Cost Impact net EUR',
        totalInvestmentEUR: 'Total Investment EUR',
        investmentAmount: 'Investment Amount',
        status: 'Status',
        bioFuelsNetKwh: 'Bio fuels Net Kwh',
        projectInfo: 'Project Info',
        retailCost: 'Retail Cost',
        benefitsAndRisk: 'Benefits And Risk',
        riskAvoidance: 'Risk Avoidance',
        riskAvoidancePlaceholder:
          'What would be the risk of not doing this project?',
        depreciation: 'Depreciation',
        paybackYears: 'Payback (Years)',
        annualPAndLImpact: 'Annual P&L Impact',
        recurringYearlySavings: 'Recurring Yearly Savings',
        operationalCost: 'Operational Cost',
        totalInvestments: 'Total Investments',
        land: 'Land',
        benefitsAndRisks: 'Benefits & risks',
        additionalInformation: 'Additional information',
        projectName: 'Project name',
        businessUnitFullName: 'Location',
        projectStatus: 'Project Status',
        totalProjectInvestmentEUR: 'Total Project Investment EUR',
        annualCostImpactNet: 'Annual Cost ImpactNet',
        biofuelsNetKwh: 'Biofuels NetKwh',
        co2eNet: 'Co2e Net',
        etrprojectID: 'Etr Project ID',
        etrSolutionID: 'Etr Solution ID',
        etrUnitID: 'Etr Unit ID',
        unifierID: 'Unifier ID',
        msTeams: 'MS Teams Link',
        clusterFMSpecialist: 'Cluster FM Specialist',
        districtFM: 'District FM',
        responsiblLead: 'Responsible (Lead)',
        unitFM: 'Unit FM',
        cpm: 'CPM',
        assetManagement: 'Asset Management',
        externalPM: 'External PM',
        referenceID: 'Reference ID',
        projectID: 'Project Reference ID',
        etrID: 'ETR ID',
        projectAssets: 'Project Assets',
        bu: 'BU',
        landCost: 'Land cost',
        solutionPurpose: 'Solution Purpose',
        solutionType: 'Solution Type',
        startDate: 'Start Date',
        completionDate: 'Completion Date',
        landCG1: 'Land (CG1)',
        landCG1EUR: 'Land (CG1) EUR',
        propertyInvestmentCG111: 'Property Investment (CG1-11)',
        propertyInvestmentCG111EUR: 'Property Investment (CG1-11) EUR',
        retailCostCG1516: 'Retail Cost (CG15-16)',
        retailCostCG1516EUR: 'Retail Cost (CG15-16) EUR',
        accountable: 'Accountable',
        priority: 'Priority',
        annualCostImpact: 'Annual Cost Impact',
        currency: 'Currency',
        engineer: 'Engineer',
        portfolio: 'Portfolio',
        potentialYearlyIncome: 'Potential Yearly Income',
        projectStartFiscalYear: 'Project Start Fiscal Year',
        projectCompletionFiscalYear: 'Project Completion Fiscal Year',
        recurringYearlyOperationalCost: 'Recurring Yearly Operational Cost',
        retailInvestmentCG1214: 'Retail Investment (CG12-14)',
        retailInvestmentCG1214EUR: 'Retail Investment (CG12-14) EUR',
        unitType: 'Unit Type',
        newUnitType: 'New Unit Type',
        updatedAt: 'Updated At',
        co2eSociety: 'Co2e Society',
        createdBy: 'Created By',
        propertyInvestment: 'Property investment',
        totalElectricity: 'Electricity Purchased',
        retailInvestment: 'Retail investment',
        sustainID: 'Sustain ID',
        additionalInformationProject:
          'Additional Information (Project Background)',
        mergedWithProject: 'Merged with project',
        programmeName: 'Programme Name',
        programmeStatus: 'Programme Y/N',
        projectCompletionFY: 'Project completion FY',
        projectEndFY: 'Project end FY',
        projectStartFY: 'Project start FY',
        SISANDimensionSolutionPurpose: 'SISAN Dimension (Solution Purpose)',
        totalProjectInvestment: 'Total Project Investment',
        LandCG01: 'Land (CG01)',
        propertyInvestmentBuilding:
          'Property Investment (building + land) (CG01-11)',
        bioFuel: 'Biofuel',
        districtCooling: 'District Cooling',
        districHeat: 'District Heating',
        naturalGas: 'Natural Gas',
        electricityGenerated: 'Electricity generated',
        locationBasedCO2:
          'Location-based CO2 (based on country average emission factors)',
        ingkaClimateFootprintCalculated:
          'Ingka Climate footprint (market-based, actual site emission factors)',
        wasteReduction: 'Waste to landfill',
        waterReduction: 'Water',
        netkWh: 'Net kWh',
        pnlImpact: 'PnL Impact',
        depreciationAmount: 'Depreciation Amount',
        depreciationEur: 'Depreciation Eur',
        districtCoolingNetKwh: 'District Cooling Net Kwh',
        districtFm: 'District Fm',
        etrProjectId: 'Etr ProjectId',
        etrSolutionId: 'Etr SolutionId',
        etrUnitId: 'Etr UnitId',
        externalContractorsNeeded: 'External Contractors Needed',
        gasNetKwh: 'Gas Net Kwh',
        generatedNetKwh: 'Generated Net Kwh',
        impactYear1: 'Impact Year1',
        impactYear1Eur: 'impact Year1Eur',
        legalUnit: 'Legal Unit',
        mtoolId: 'M-Tool ID / PJ Code',
        co2e: 'Co2e',
        operationalCostEUR: 'Operational Cost EUR',
        plImpactAccount: 'Pl Impact Account',
        plImpactAmountPerAccount: 'Pl Impact Amount Per Account',
        potentialYearlyIncomeEUR: 'Potential Yearly Income EUR',
        realEstateDevelopment: 'Real Estate Development',
        recurringYearlyOperationalCostEUR:
          'Recurring Yearly Operational Cost EUR',
        recurringYearlySavingsEUR: 'Recurring Yearly Savings EUR',
        payback: 'Payback',
        referenceId: 'Reference Id',
        sustainId: 'Sustain Id',
        totalElectricityNetKwh: 'Electricity Purchased Net Kwh',
        unifierId: 'Unifier Id',
        unitCategory: 'Unit Category',
        unitFm: 'Unit Fm',
        wasteReductionT: 'Waste Reduction (t)',
        waterReductionM3: 'Water Reduction (m3)',
        pnLImpact: 'PnL Impact',
        projectMergeWithProjectReferenceId:
          'Project Merged with (Enter Project Reference ID)',
        localUniqueId: 'Local Unique Id',
        changeProjectMessage: `You're about to change the project's start and end year, which was already added to the latest submission(M-Tool ID is created and the project's status is approved). Please choose from the possible next steps below`,
        projectEndDate: 'Project end date',
        projectStartDate: 'Project start date',
        actionCategory: 'Action category',
        budgeting: 'Budgeting (Russia only)',
        subcategory: 'Subcategory (Russia only)',
        etrPriority: 'ETR Priority',
        etrSolutionIdTag: 'Solution ID',
        etrProjectIdTag: 'ETR Project ID',
        sourceChannel: 'Project Sourcing Channel',
        etrProjectExecutionStatus: 'ETR Execution status',
        projectPhase: 'Project Phase',
        initialPlannedProjectStartFY: 'Initial planned project start FY',
        initialPlannedProjectEndFY: 'Initial planned project end FY',
        landTotal: {
          budget: 'Total Project budget Land',
          forecast: 'Total Forecast Land',
          baseline: 'Total Baseline Land',
          releasedApproved: 'Total Released/Approved amount Land',
          pToolForecast: 'Total P-Tool Forecast Land',
          actuals: 'Total Actuals Land',
        },
        propertyInvestmentTotal: {
          budget: 'Total Project Property Investment',
          forecast: 'Total Forecast Property Investment',
          baseline: 'Total Baseline Property Investment',
          releasedApproved:
            'Total Released/Approved amount Property Investment',
          pToolForecast: 'Total P-Tool Forecast Property Investment',
          actuals: 'Total Actuals Property Investment',
        },
        retailInvestmentTotal: {
          budget: 'Total Project Retail Investment',
          forecast: 'Total Forecast Retail Investment',
          baseline: 'Total Baseline Retail Investment',
          releasedApproved: 'Total Released/Approved amount Retail Investment',
          pToolForecast: 'Total P-Tool Forecast Retail Investment',
          actuals: 'Total Actuals Retail Investment',
        },
        retailCostTotal: {
          budget: 'Total Project Retail Cost',
          forecast: 'Total Forecast Retail Cost',
          baseline: 'Total Baseline Retail Cost',
          releasedApproved: 'Total Released/Approved amount Retail Cost',
          pToolForecast: 'Total P-Tool Forecast Retail Cost',
          actuals: 'Total Actuals Retail Cost',
        },
        financialTotal: {
          budget: 'Total Budget',
          forecast: 'Total Forecast',
          baseline: 'Total Baseline',
          releasedApproved: 'Total Released/Approved',
          pToolForecast: 'Total P-Tool Forecast',
          actuals: 'Total Actuals',
        },
      },
      hintMessage: {
        chooseABU: 'Choose a BU',
        chooseBUs: 'Choose BUs',
        navigateToDocuments: 'Navigate to Documents',
      },
      create: {
        riskAvoidancePlaceholder: 'Please put risk avoidance for the project',
        projectInvestment: 'Project Investment',
        opexImpact: 'OPEX Impact',
        energyInformation: 'Energy Information',
        createAndPropose: 'Create and Propose',
        riskAvoidance: 'Risk Avoidance',
        descriptionForEnergyInformation:
          'Enter yearly changes the project generates with reductions as negative values',
        generalForm: {
          startFyIsBiggerErrorMessage: 'Start FY is bigger than end FY',
          hintMessage: {
            additionalProjectInformationErrorMessage:
              '# of units being replaced, specific parts being replaced, or brand names related to replacements, etc.',
          },
        },
        opexForm: {
          positivePAndLImpact: 'Positive P&L Impact',
          negativePAndLImpact: 'Negative P&L Impact',
          savingAsNegative: 'IMPORTANT: Enter savings as negative number',
          depreciationCalculated: 'Depreciation - CALCULATED',
          annualCostImpactCalculation: 'Annual Cost Impact Net - CALCULATED',
          paybackYearsCalculated: 'Payback (Years) - CALCULATED',
          paybackYears: 'Payback (Years)',
          annualPAndLImpactCalculated: 'Annual P&L Impact - CALCULATED',
          annualPAndLImpact: 'Annual P&L Impact',
        },
      },
      userModal: {
        userBusinessUnits: 'User Business Units',
        userClusters: 'User Clusters',
        userCountry: 'User Country',
      },
      createProjectsFromCafmAssets: 'Create Projects from CAFM Assets',
    },
    financialTotals: {
      BUDGET: 'Total Budget',
      FORECAST: 'Total Forecast',
      BASELINE: 'Total Baseline',
      RELEASED_APPROVED_BUDGET: 'Total Released Approved Amount',
      ACTUALS: 'Total Actuals',
      SUBMITTED_FORECAST: 'Total P-tool Forecast',
    },
    projectPhase: {
      FEASIBILITY: 'Feasibility',
      DESIGN_AND_DEVELOPMENT: 'Design & Development',
      IR_APPROVED: 'IR Approved',
      EXECUTION: 'Execution',
      MEASURE_AND_VERIFICATION: 'Measure & Verification',
    },
    bulkCreate: {
      createProjects: 'Create Projects',
      editProjects: 'Edit Projects',
      table: {
        removeRow: 'Remove row',
        copyRow: 'Copy row',
        addNewRow: 'Add New Row',
      },
      investmentModal: {
        projectInvestments: 'Project Investments',
        updateInvestments: 'Update Investments',
      },
      createDraftProjects: 'Create Draft Project(s)',
    },
    flight: {
      makeSubmission: 'Make Submission',
      retailPortfolio: 'Retail Portfolio',
      retailCountryUnit: 'Retail Country/Unit',
      pushSubmissionToEtr: 'Push Submission to ETR',
      centres: 'Centres',
      newInfo: 'New Info',
      projectsQueue: 'Projects Queue',
      boarded: 'Boarded',
      submitted: 'Added to submission',
      loadingProjects: 'Loading projects',
      noProjectsAvailable: 'No projects available',
      addToSubmission: 'Add to Submission',
      noSubmissionsForAGivenCountry: 'No Submissions For A Given Country',
      submission: {
        flightSubmissionTableNewInfo:
          'Projects that need to be reviewed because data was updated after the previous Submission',
        flightSubmissionTableBoarded:
          'Projects that are included to the Current Submission',
        flightSubmissionTableQueue:
          'Review and choose projects that will be included to the Current Submission or request changes from the Project Creator',
        flightSubmissionTableReturned:
          'Projects that have been requested to change',
        changeStatusToPlanned: 'Change status to Not Started',
        bulkMarkPlannedConfirmation:
          'Are you sure you wish to mark all these projects as Not Started?',
      },
      submissionHeader: {
        submissionFinancialCard: {
          exportReport: 'Export Report',
        },
      },
      createSubmissionModal: {
        delayForETR:
          'Due to some technical reasons, your projects might appear in ETR with a delay',
        createSubmission: 'Create Submission',
        submissionName: 'Submission Name',
        sendToETR: 'Send to ETR',
        capacity_info:
          'Please fill in Capacity related info for Central Fulfilment and Replenishment units',
        capacity_info_programme:
          'Please select at least one relevant solution in the Solutions tab',
        capacity_info_solution_types:
          'Please ensure selecting a relevant Programme Name in the Project tab',
      },
      newInfoModal: {
        info: 'Info',
        projectDataWasUpdated: 'Project data was updated',
        dataUpdateTable: {
          loadingMessage: 'Loading Changes',
          noPreviousValue: 'No previous value',
        },
      },
      revertProjectModal: {
        revertProjects: 'Revert Projects',
        revertToDraft: 'Revert to Draft',
        projectsRevertedToDraftStatus:
          'Projects that will be reverted to Draft status',
        bulkCommentForRevertedProjects: 'Bulk comment for reverted Projects',
      },
      table: {
        tootTips: {
          projectDataWasChangedClickToViewDetails:
            'Project data was changed. Click to view details.',
          boardedProject: 'Boarded Project',
        },
      },
    },
    user: {
      properties: {
        cluster: 'Cluster',
        userName: 'User name',
      },
    },
    admin: {
      adminPage: 'Admin Page',
      updateUser: 'Update User',
      addUser: 'Add User',
    },
    currency: {
      currencyPage: 'Currency Page',
      updateCurrencyRates: 'Update Currency Rates',
      currencyTable: {
        currencyCode: 'Currency Code',
        currencyRate: 'Currency Rate',
      },
    },
    filter: {
      allFilters: 'All Filters',
      projectsFilters: 'Projects Filters',
      clearFilters: 'Clear filters',
    },
    assets: {
      addNewAsset: 'Add new Asset',
      addAsset: 'Add asset',
      manufacturerModelYear: 'Manufacturer, model, year etc...',
      properties: {
        assetDescription: 'Asset Description',
        endDate: 'End Date',
        replacementCost: 'Replacement Cost',
        manufacturer: 'Manufacturer',
        model: 'Model',
        organization: 'Organization',
        unitId: 'Unit id',
        assetGroup: 'Asset Group',
        replaceAssetsDescription:
          'Assets are arranged as per their asset end date in CAFM. Please choose the assets you would like to replace from your BU. You may also search the assets based on asset description.',
      },
      replaceAsset: {
        cafmAssetsErrorMsg: 'There are no CAFM assets for selected BU',
        replaceAssets: 'Replace Assets',
      },
    },
    financialFrames: {
      columns: {
        country: 'Country',
        fiscalYear: 'FY',
        updated: 'Updated',
        growthNewCmps: 'Growth/New CMPs',
        countryPAndL: 'Country P&L',
        fulfilmentAndReplenishment: 'Fulfilment & Replenishment (NEW + SISAN)',
        centresPortfolio: 'Centres Portfolio',
        propertyExits: 'Property exits',
        commercialAndCoworkerAreasAndConcept:
          'Commercial & co-worker areas and concept',
        realEstate:
          'Real Estate (Asset Lifecycle and compliance & Energy Water Waste)',
        spaceOptimisationWith3rdParty: 'Space optimisation with 3rd party',
        digitalTechnology: 'Digital Technology',
        total: 'Total',
        actuals: 'Actuals',
        opex: 'Opex',
        capex: 'Capex',
      },
      emptyState: {
        message: `This page feels a bit empty right now. That's because no financial frames have been added yet for the countries you have access to — but they'll show up here as soon as they're available.`,
      },
      global: 'Global',
      globalRmpp: 'Global RMPP',
      unallocatedRmpp: 'Unallocated RMPP',
      rmppTotal: {
        title: 'RMPP Total',
        subPortfolio: 'Sub-portfolio',
        allocatedFrame: 'Allocated frame',
        reportedForecast: 'Reported forecast',
        diff: 'Diff',
        actuals: 'Actuals',
        globalForecast: 'Global forecast',
        globalForecastHelper: 'Use +/- to adjust the forecast frame',
        comment: 'Comment',
        commentHelper: 'Require the reason for this adjustment',
        reportedValue: 'Reported value',
        reportedRmppForecast: 'Reported RMPP forecast',
        submitForecast: 'Submit forecast',
        noData: 'No forecast data available for this sub-portfolio',
      },
    },
    snackbarMessages: {
      updated: 'Updated',
      couldNotFetchProjects: 'Could not fetch projects',
      noDataToCopy: 'No data available to copy',
      copied: 'Copied',
      failedToCopy: 'Failed To Copy',
      followUpProjectUpdated: 'Follow up project updated',
      couldNotUpdateFollowUpProject: 'Could not update follow up project',
      referenceIdIsUsed: 'Reference Id is used by another project',
      unlinkProjectError: 'Could not unlink the project',
      unlinkProjectSuccess: 'Project was unlinked successfully',
      relinkProjectError: 'Could not reassign the project',
      relinkProjectSuccess: 'Project was reassigned successfully',
      couldNotFetchEtrAnalysis: 'Could not fetch ETR analysis',
      submissionCreatedSuccessfully: 'Submission was created successfully',
      sustainFactorsUpdated: 'Sustain factors were updated successfully',
      sustainFactorsUpdateError: 'Could not update sustain factors',
      fetchProjectError: 'Problem getting projects',
      fetchSiteLocationError: 'Problem fetching site/unit data',
      problemCreatingProject: 'Failed to create project',
      projectCreated: 'Project created',
      couldNotCreateProject: 'Could not create project',
      projectsSuccessfullyCreated: 'Projects successfully created',
      couldNotCreateProjects: 'Could not create projects',
      projectUpdated: 'Project updated',
      projectCouldNotBeUpdated: 'Project could not be updated',
      couldNotFetchAssets: 'Could not fetch Assets',
      problemUpdatingPartOfCrp: 'Could not update Part of CRP',
      problemUpdatingPartOfApprovedCrp:
        'Failed to approve one or multiple projects',
      couldNotFetchCafmAssets: 'Could not fetch Cafm-assets',
      couldNotFetchUsers: 'Could not fetch users',
      updatedUserSuccessfully: 'Updated user successfully',
      deletedUserSuccessfully: 'Deleted user successfully',
      couldNotDeleteUser: 'Could not delete user',
      couldNotUpdateUser: 'Could not update user',
      couldNotCreateMSTeams: 'Could not create ms teams',
      projectsStatusesWereUpdated: 'Projects statuses were updated',
      couldNotUpdateProjectsStatuses: 'Could not update projects statuses',
      problemGettingBusinessUnits: 'Problem getting Business-units',
      problemGettingUserData: 'Problem getting user data',
      problemGettingFlightData: 'Problem getting Flight data',
      couldNotCreateNewSubmission: 'Could not create new submission',
      couldNotFetchArchiveData: 'Could not fetch Archive data',
      couldNotSendProjectsToArchive: 'Could not send projects to archive',
      couldNotFetchProjectChanges: 'Could not fetch project changes',
      couldNotFetchCurrencyData: 'Could not fetch currency data',
      successfullyUpdatedCurrencyRates: 'Successfully updated currency rates',
      couldNotUpdateCurrencyData: 'Could not update currency data',
      couldNotFetchFinancialFrames: 'Could not fetch financial frames',
      successfullyUpdatedFinancialFrame: 'Successfully updated financial frame',
      couldNotUpdateFinancialFrame: 'Could not update financial frame',
      couldNotFetchGlobalForecast: 'Could not fetch global forecast',
      successfullySubmittedGlobalForecast:
        'Successfully submitted global forecast',
      couldNotSubmitGlobalForecast: 'Could not submit global forecast',
      problemGettingUpdatedProjects: 'Problem getting updated projects',
      couldNotMergeProjects: 'Could not merge projects',
      couldNotFetchSustainFactors: 'Could not fetch sustain factors',
      successfullyUpdatedSustainFactors: 'Successfully updated sustain factors',
      successfullyUpdatedProjects: 'Projects were updated successfully',
      couldNotUpdateProjects: 'Could not update projects',
      cannotEditApprovedOrPlannedProjects:
        'Some projects were removed from bulk edit since they have M Tool-id and approved or planned',
      problemToAddArchived:
        'Some of selected projects cannot be archived since they have M-Tool Id',
      problemPushToEtr: 'Error pushing to etr',
      successPushToEtr: 'Item(s) will be synced to ETR in a couple of minutes',
      projectsUnArchived: 'Projects were moved from archive successfully',
      projectsUnArchivedError: 'could not move projects from archive',
      couldNotFetchEtrComments: 'Could not fetch Etr comments',
      revertFromArchive: 'Revert from archive',
    },
    validationMessages: {
      projectStartYearInPast: 'Project Start Date cannot be in the past',
      projectNameIsRequired: 'Project Name is required',
      buIsRequired: 'BU is required',
      additionalInformationIsRequired: 'Additional information is required',
      benefitsAndRiskIsRequired: 'Benefits & Risk is required',
      priorityIsRequired: 'Priority is required',
      solutionPurposeIsRequired: 'Solution Purpose is required',
      solutionTypeIsRequired: 'Solution Type is required',
      completionFYIsRequired: 'Completion FY is required',
      sourceChannelIsRequired: 'Source Channel is required',
      programmeIsRequired: 'Programme is required',
      startFYIsRequired: 'Start FY is required',
      landValueMustBeANumber: 'Land Value must be a number',
      landValueIsRequired: 'Land Value is required',
      propertyInvestmentMustbeANumber: 'Property Investment must be a number',
      propertyInvestmentIsRequired: 'Property Investment is required',
      retailInvestmentMustBeANumber: 'Retail Investment must be a number',
      retailInvestmentIsRequired: 'Retail Investment is required',
      retailCostMustbeANumber: 'Retail Cost must be a number',
      retailCostIsRequired: 'Retail Cost is required',
      totalElectricityMustBeANumber: 'Electricity Purchased must be a number',
      totalElectricityIsRequired: 'Electricity Purchased is required',
      gasMustBeANumber: 'Gas must be a number',
      gasIsRequired: 'Gas is required',
      biofuelsMustBeANumber: 'Biofuels must be a number',
      biofuelsIsrequired: 'Biofuels is required',
      districtHeatMustBeANumber: 'District Heat must be a number',
      districtHeatIsRequired: 'District Heat is required',
      districtCoolingMustBeANumber: 'District Cooling must be a number',
      districtCoolingIsRequired: 'District Cooling is required',
      generatedkWhMustBeANumber: 'Generated kWh must be a number',
      generatedkWhIsRequired: 'Generated kWh is required',
      waterReductionMustBeANumber: 'Water must be a number',
      waterReductionIsRequired: 'Water is required',
      wasteReductionMustBeANumber: 'Waste to landfill must be a number',
      wasteReductionIsRequired: 'Waste to landfill is required',
      yearlyOperationalCostMustBeANumber:
        'Yearly Operational Cost must be a number',
      yearlyOperationalCostIsRequired: 'Yearly Operational Cost is required',
      yearlySavingsMustBeANumber: 'Yearly Savings must be a number',
      yearlySavingsCostIsRequired: 'Yearly Savings Cost is required',
      yearlyIncomeMustbeANumber: 'Yearly Income must be a number',
      yearlyIncomeCostIsRequired: 'Yearly Income Cost is required',
      nameIsRequired: 'Name is required',
      mustBeAValidEmail: 'Must be a valid email',
      emailIsRequired: 'Email is required',
      userMustHaveARole: 'User must have a role',
      userMustHaveAtLeastOneBusinessUnit:
        'User must have at least one business unit',
      userMustHaveAtLeastOneCountry: 'User must have at least one country',
      userMustBelongToAtLeastOneCluster:
        'User must belong to at least one cluster',
      propertyInvestmentShouldBeMoreThanLandCost:
        'Property Investment (Building + Land) should be greater than or equal to Land.',
      riskAvoidanceRequired: 'Risk avoidance is required',
      validationError: 'Validation has failed',
      shouldBeDateFormatProjectStart:
        'Project start date should be in a YYYY/MM/DD format',
      shouldBeDateFormatProjectEnd:
        'Project end date should be in a YYYY/MM/DD format',
      businessUnitIsRequired: 'Business Unit is required',
      unitTypeIsRequired: 'Unit type is required',
      unitCategoryIsRequired: 'Unit Category is required',
      unifierIdWrongFormat: 'Expected format: CMT01234',
    },
    solutionPuposes: {
      costsavings: 'Cost savings',
      businessContinuity: 'Business continuity',
      compliance: 'Compliance',
      lifeCycle: 'Life cycle',
      sustainability: 'Sustainability',
      growth: 'Growth',
    },
    projectPriorities: {
      critical: '1 - Critical',
      necessary: '2 - Necessary',
      recommended: '3 - Recommended',
    },
    projectPrioritization: {
      HIGH: 'A',
      MEDIUM: 'B',
      LOW: 'C',
    },
    etrProjectPrioritization: {
      HIGH: 'A',
      MEDIUM: 'B',
      LOW: 'C',
    },
    programmes: {
      buCodeIntegration: 'BU code integration',
      ecopilot: 'Ecopilot',
      electricVehicles: 'Electric vehicles',
      eVChargers: 'EV chargers',
      hostingLCM: 'Hosting LCM',
      lada: 'LADA',
      led: 'LED',
      localConnectivitySwitches: 'Local Connectivity - Switches',
      localConnectivityWiFi: 'Local Connectivity - WiFi',
      metering: 'Metering',
      posLCM: 'POS LCM',
      powerOptimizer: 'Power optimizer (E-Power)',
      spaceOptimisation: 'Space optimisation',
      wan: 'WAN upgrade',
      wasteBalers: 'Waste balers',
    },
    ocnPriority: {
      ZERO: '0',
      ONE: '1',
      TWO: '2',
      THREE: '3',
      FOUR: '4',
      FIVE: '5',
      SIX: '6',
    },
    statuses: {
      UNQUALIFIED: 'Unqualified',
      QUALIFIED: 'Qualified',
      DRAFT: 'Draft',
      NOT_STARTED: 'Not started',
      RUNNING: 'Running',
      DELIVERED: 'Delivered',
      CLOSED: 'Closed',
      CANCELLED: 'Cancelled',
      ON_HOLD: 'On hold',
    },
    buTypes: {
      ikeaStore: 'IKEA Store',
      ikeaSmallStoreS: 'IKEA Small Store S',
      ikeaSmallStoreXS: 'IKEA Small Store XS',
      ikeaSmallStoreLadaS: 'IKEA Small Store (S) Lada',
      ikeaSmallStoreLadaM: 'IKEA Small Store (M) Lada',
      ikeaShop: 'IKEA Shop',
      ikeaPlanAndOrderPoint: 'IKEA Plan and Order Point',
      ikeaMiniPlanAndOrderPoint: 'IKEA Mini Plan and Order Point',
      ikeaPickUpAndOrderPoint: 'IKEA Pick up and Order Point',
      ikeaPickUpPointBranded: 'IKEA Pick up Point (branded)',
      ikeaPickUpPointUnbranded: 'IKEA Pick up Point (unbranded)',
      ikeaPopUp: 'IKEA Pop-up',
      ingkaCentresShopgMall: 'Ingka Centres - Shopg Mall',
      ingkaCentresRetailPark: 'Ingka Centres - Retail Park',
      ingkaCentresOutletCentre: 'Ingka Centres - Outlet Centre',
      customerSupportCentreCSC: 'Customer Support Centre (CSC)',
      distributionCentreDC: 'Distribution Centre (DC)',
      customerDistributionCentreCDC: 'Customer Distribution Centre (CDC)',
      centralParcelUnitCPU: 'Central Parcel Unit (CPU)',
      serviceOffice: 'Service Office',
      externalMerchandisePickUpUnitEMPU:
        'External Merchandise Pick-up Unit (EMPU)',
      externalWarehouse: 'External Warehouse',
      landbank: 'Landbank',
      explorationCase: 'Exploration Case',
      other: 'Other',
    },
    plImpact: {
      positive: 'Positive',
      negative: 'Negative',
    },
    roles: {
      Admin: 'Super Admin',
      FM: 'Project Creator',
      OA: 'Admin',
      EXP_PROJECT_CREATOR: 'Project Creator',
      EXP_ADMIN: 'Country Admin',
      EXP_SUPER_ADMIN: 'Super Admin',
      GUEST: 'Guest',
    },
    status: {
      draft: {
        description: 'Project is still in draft stage',
      },
      proposed: {
        description:
          'Project is proposed by project creator to the Cluster Operations Leader for the decision to whether or not the project is included in submission',
      },
      returned: {
        description:
          'Project is returned to project creator to revise based on feedback',
      },
      submitted: {
        description: `Project is submitted to be included in country's business plan including  portfolio, Centre's business plans`,
      },
      planned: {
        description:
          'Project is in the financial plans now, but might need additional approvals based on project total cost',
      },
      approved: {
        description:
          'Project has received additional applicable approvals (IR, BC, etc.) and can be now executed',
      },
      cancelled: {
        description: 'Project is cancelled',
      },
      postponed: {
        description: 'Project is either postponed or put on hold',
      },
      running: {
        description: 'Project is in progress or in pre-study (studies) mode',
      },
      completed: {
        description: 'Project is completed',
      },
    },
    measurements: {
      kgCo2Ton: 'kg CO2e/ton',
      kgCo2M3: 'kg CO2e/m3',
      kgCo2Kwh: 'kg CO2e/kWh',
    },
    tooltips: {
      downloadETRAnalysis: 'Click to download ETR Analysis',
      unlinkProject: 'Generate new reference Id from the project',
      relinkProject: 'Change reference Id for the project',
      notPlanningToStart: 'Project will be converted to Draft',
      recurringYearlyOperationalCost: 'Recurring Yearly Operational Cost',
      unitCategory: 'Please select Unit Category',
      reltp: 'Real Estate Long-Term Planning 2.0 Digital Product',
      saveColumns: 'Save column selection to suit your view',
      reason: 'Reason for returning a project',
      projects: 'Typically SISAN projects',
      bulkUpdate: 'Update / save changes',
      businessUnit: 'Business Units are populated from CBD',
      createDraft: 'Create and save project as draft',
      updateProject: 'Update / save project details',
      changeStatus: 'Change project status',
      mergeByReferenceID:
        'Click here if project(s) is/are to be merged with another project',
      removeFromSubmission:
        'Project is sent back to queue on the submission screen itself',
      sendToArchive: 'Project is archived',
      atLeastOneSolutionRequired:
        'One solution is required, add another to remove this one',
      fillTheRestAndPropose:
        'Fill remaining project information and propose as a possible candidate for submission',
      createDraftProject: 'Create and save project as draft',
      fiscalYear: 'e.g. FY 24 is 1st Sept 2023 to 31st August 2024',
      returnMessage: 'Reason for returning a project',
      projectResources: 'Resources needed to execute the project',
      updateAndPropose:
        'Update / save changes and propose as a possible candidate for submission',
      updateAndApprove: 'Update / save selection and approve the project',
      requestChanges:
        'Remove project from submission screen and request project creator to make changes to project',
      pushToEtr: 'Push selected project(s) to ETR',
      etrSync: 'Submission was synced with ETR',
      notEtrSync: 'Submission was not synced with ETR',
      mergeProjects:
        'Merge project only links one or many projects to another through reference ID, without merging the actual project data',
      additionalApproval:
        'Portfolio projects need additional approvals, which can be selected from the options below',
      totalProjectInvestmentCostDescription:
        'This is based on CAFM replacement cost data and is only indicative',
      annualCostImpactNetEUR: 'Does not include depreciation',
      benefitsAndRisk: 'Auto-generated based on other fields',
      annualPAndLImpact: 'Annual P&L impact (includes depreciation)',
      annualCostImpactNet:
        'Annual Cost Impact (Net), but does not incldue depreciation',
      referenceID: 'System-generated unique project reference ID in RELTP 2.0',
      locationBasedCO2:
        'Calculated based on factors set in RELTP 2.0 by Sustain super user',
      ingkaClimateFootprintCalculated: 'Calculated by the Sustain tool',
      payback:
        'Calculated by dividing total project investment by annual cost impact net',
      localUniqueId:
        'Field to add Local country unique ID for the project (“Project #” field from RELTP 1.0, e.g. in markets like FR)',
      projectName: 'Name for the created project',
      additionalInformation: 'Additional information about the project',
      priority: 'Project priority',
      SISANDimensionSolutionPurpose: 'SISAN solution purpose for the project',
      solutionType: 'Solution type for the project',
      sourceChannel: 'Source channel for the project',
      removeAsset: 'Remove asset from the project',
      programmeStatus: 'Select if programme should apply to this project',
      replaceAssets: 'Replace selected assets',
      landCost: 'Land-cost for the project',
      programmeName: 'Select programme name',
      assetQuantity: 'Please specify quantity of newly added asset',
      propertyInvestmentBuilding: 'Project property investment',
      retailInvestment: 'Project retail investment',
      retailCost: 'Project retail cost',
      'recurringYearlyOperationalCost:':
        'Recurring Yearly operational cost for the project',
      recurringYearlySavings: 'Recurring yearly savings for the projects',
      asset: 'Please specify asset group',
      depreciationCalculated: 'Calculated depreciation for the project',
      addAsset: 'Add asset to the project',
      potentialYearlyIncome: 'Potential yearly income for the project',
      addNewAsset: 'Add new asset',
      replaceAsset: 'Replace existing asset from the list',
      riskAvoidance: 'Please put Risk avoidance for the project',
      totalElectricity: 'Total electricity for the project',
      naturalGas: 'Natural gas for the project',
      bioFuel: 'Biofuels for the project',
      districtHeat: 'District heat for the project',
      districtCooling: 'District cooling for the project',
      electricityGenerated: 'Electricity generated for the project',
      waterReduction: 'Water reduction for the project',
      wasteReduction: 'Waste reduction for the project',
      createAndPropose:
        'create project and propose as a possible candidate for submission',
      discard: 'Discard changes and close modal',
      openNotifications: 'Open notifications menu',
      changeLanguage: 'Change language of the application',
      update: 'Update / save project',
      createProject: 'Create Project',
      edit: 'Edit multiple projects',
      delete: 'Delete selected projects',
      copy: 'Copy',
      revertFromArchive: 'Revert projects from archive',
      BulkCreateProject: 'Create several projects at once',
      countrySelectArchive:
        'Select country to view archived project from that country',
      createProjectsFromCafmAssets: 'Create project from cafm assets',
      fySelectFlight: 'Select fiscal year to see submissions from that year',
      countrySelectFlight:
        'Select country to see submissions from that country',
      makeSubmission: 'Create submission',
      addToSubmission: 'Add projects to the current submission',
      submissionName: 'Name for the newly created submission',
      archiveTab: 'Tab to view archived projects',
      submissionTab: 'Tab to view submissions',
      projectsTab: 'Tab to control projects',
      projectsPageBUSelect: `Select bu to view it's projects`,
      filterAll: 'Click to open Filters modal',
      filterRetail: 'Click to filter projects by Retail portfolio',
      filterRetailCountry: 'Click to filter projects by Retail country',
      filterCentre: 'Click to filter projects by Center',
      totalInvestmentByType: 'Total investment amount per project type',
      actionCategory: 'Please select action category',
      BulkCreateFromProject: 'Create new projects from selected one',
      etrPriority: 'Priority given by ETR',
      bulkExistingProject: 'This Project already exist and is in editing mode',
      bulkExistingApprovedProject:
        'Approved projects cannot be edited on this screen',
      unitType: 'Type of BU',
      resetColumns: 'Reset columns selection to default',
      linkToDocumentsTooltip: 'Link To Documents Tooltip',
      POContractNumber: 'PO/Contract Number',
      POContractNumberTooltip: 'PO/Contract Number Tooltip',
      POContractAmount: 'PO/Contract Amount',
      POContractAmountTooltip: 'PO/Contract Amount Tooltip',
      totalProjectInvestment: 'Total Project Investment Tooltip',
      totalActualsTooltip: 'Total Actuals Tooltip',
      projectRiskTooltip: 'Project Risk Tooltip',
      projectRisk: 'Project Risk',
      unifierIdTooltip: 'Unifier Id Tooltip',
      totalProjectForecastTooltip: 'Total Project Forecast Tooltip',
    },
    approval: {
      irApproved: 'IR approved',
      businessCaseApproved: 'Business Case Approved',
    },
    notApplicable: 'Not Applicable / Business Case Approval not needed',
    privacy: {
      title: 'Privacy statement',
      header:
        'When you use ETR 2.0, the Ingka Group company Data Controller (as defined below) will collect certain personal data about you.',
      personalDataBold: 'The personal data collected is:',
      personalData: 'Work email ID, First name, Middle name and Last name',
      purposeBold: 'The purpose of collecting this data is:',
      purpose:
        'To ensure the user accountability and history of activities . In ETR 2.0, we save the co-workers name and email ID, since we need to know who has createdprojects and the history of actions done on a project.',
      legalBold: 'The legal ground for the processing is:',
      legal:
        'The Data Controller’s legitimate interest to provide the necessary tools and applications to its work force.',
      dataBold: 'The data will be stored:',
      data: 'Data will be stored until the employees exit date from IKEA',
      controllerBold:
        'The data controller for this processing of personal data is:',
      controller: 'Local INGKA Entity',
      controllerAdvice:
        'However, we advise you to please also go through the Inside page where all the local data privacy notices are available:',
      footer:
        'Your personal data may be shared with other Ingka Group companies as well as service providers to Ingka Group for purposes of providing the ETR 2.0.',
      rights:
        'You have certain rights in relation to your personal. To learn more about such rights. Please visit',
    },
    actionCategories: {
      water: 'Water',
      energy: 'Energy',
      waste: 'Waste',
      na: 'N/A',
    },
    projectETRPriorities: {
      A: 'High',
      B: 'Medium',
      C: 'Low',
    },
    unitTypes: {
      CPU: 'Central Parcel Unit (CPU)',
      'Business Support Unit': 'Business Support Unit (Historical)',
      CDC: 'Customer Distribution Centre (CDC)',
      DCWH: 'DC External Warehouse (DCWH)',
      DC: 'Distribution Centre (DC)',
      landbank: 'Landbank',
      LDC: 'Local Distribution Centre(LDC)',
      'Local Distribution Centre (LDC)':
        'Local Distribution Centre (LDC) (Historical)',
      RWHCDC: 'Retail External Warehouse (RWH) belonging to a CDC',
      CSC: 'Customer Support Centre (CSC)',
      homeServicePoint: 'IKEA Home Service Point',
      ikeaMiniPlanAndOrderPoint: 'IKEA Mini Plan and Order Point',
      ikeaPickUpAndOrderPoint: 'IKEA Pick up and Order Point',
      ikeaPickUpPointBranded: 'IKEA Pick up Point (branded)',
      'IKEA Pick-up Point (branded)':
        'IKEA Pick-up Point (branded) (Historical)',
      ikeaPickUpPointUnbranded: 'IKEA Pick up Point (unbranded)',
      'IKEA Pick-up Point (unbranded)':
        'IKEA Pick-up Point (unbranded) (Historical)',
      ikeaPlanAndOrderPoint: 'IKEA Plan and Order Point',
      ikeaPlanAndOrderPointS: 'IKEA Plan and Order Point S',
      ikeaPlanAndOrderPointXS: 'IKEA Plan and Order Point XS',
      ikeaPopUp: 'IKEA Pop up',
      ikeaSmallStoreS: 'IKEA Small Store S',
      ikeaSmallStoreXS: 'IKEA Small Store XS',
      'IKEA Small Store (S)': 'IKEA Small Store (S)',
      'IKEA Small Store (L)': 'IKEA Small Store (L)',
      'IKEA Small Store (M)': 'IKEA Small Store (M)',
      IKEA_SMALL_STORE_LADA_S: 'IKEA Small Store (S) Lada',
      IKEA_SMALL_STORE_LADA_M: 'IKEA Small Store (M) Lada',
      ikeaSmallStoreLadaS: 'IKEA Small Store (S) Lada',
      ikeaSmallStoreLadaM: 'IKEA Small Store (M) Lada',
      ikeaStore: 'IKEA Store',
      ikeaShop: 'IKEA Shop',
      centresMeetingPlace: 'Centres Meeting Place',
      serviceOffice: 'Service Office',
      digitalHub: 'Digital Hub',
      explorationCase: 'Exploration Case',
      EMPU: 'External Merchandise Pick-up Unit (EMPU)',
      noneCoreAsset: 'Non-core business asset',
      RWHCMP: 'Retail External Warehouse (RWH) belonging to a CMP',
      Other: 'Other (Historical)',
      'Distribution Support Unit': 'Distribution Support Unit (Historical)',
    },
    unitCategories: {
      CFU: 'Central Fulfilment & Replenishment Unit (CFU)',
      CMP: 'Customer Meeting Point (CMP)',
      CUSTOMER_FULFILMENT_AND_REPLENISHMENT_UNIT:
        'Customer Fulfilment and Replenishment Unit',
      meetingPlace: 'Meeting Place',
      office: 'Office',
      other: 'Other',
    },
    etrCommentsTypes: {
      ETR_FETCH_COMMENTS: 'ETR Fetch',
      COUNTRY_PROJECT_STATUS_COMMENTS: 'Country Project Status',
      DESIGN_PROJECT_STATUS_COMMENTS: 'Design Project Status',
      CONSTRUCTION_STATUS_COMMENTS: 'Construction Status',
      UPDATE_COMMENTS: 'Updates',
    },
    accountableList: {
      cff: 'CFF',
      businessOwner: 'Business owner',
      customerExperience: 'Customer Experience',
      peopleCulture: 'People & Culture',
      ingkaFood: 'Ingka Food',
      communicationInteriorDesign: 'Communication & Interior Design',
      sustainability: 'Sustainability',
      digital: 'Digital',
      centresDigital: 'Centres Digital',
      riskCompliance: 'Risk & Compliance',
      realEstate: 'Real Estate',
      logistics: 'Logistics',
      meetingPlace: 'Meeting place',
      businessNavigation: 'Business Navigation',
      procurement: 'Procurement',
    },
    responsibleList: {
      siteFm: 'Site FM',
      districtFm: 'District FM',
      clusterFm: 'Cluster FM',
      clusterCpm: 'Cluster CPM',
      clusterEng: 'Cluster ENG',
      red: 'RED',
      am: 'AM',
      external: 'External',
    },
    solutionCategories: {
      COMMERCIAL_AND_COWORKER_AREAS: 'Commercial and Coworker Areas',
      CONCEPT: 'Concept',
      FULFILMENT_AND_REPLENISHMENT: 'Fulfilment and Replenishment',
      FOOD: 'Food',
      REAL_ESTATE: 'Real Estate',
      ASSET_LIFECYCLE_AND_COMPLIANCE: 'Asset Lifecycle & Compliance',
      ENERGY_WATER_WASTE_MANAGEMENT: 'Energy Water Waste Management',
      SPACE_OPTIMIZATION_WITH_3RD_PARTIES:
        'Space optimisation with 3rd parties',
      SUSTAINABILITY: 'Sustainability',
      DIGITAL_TECHNOLOGY: 'Digital Technology',
    },
    estimatedPeopleImpact: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
    },
    communicationsAndPcComplexity: {
      HIGH_COMPLEXITY: 'High Complexity',
      LOW_COMPLEXITY: 'Low Complexity',
    },
    terminationOfFranchiseeAgreement: {
      NA: 'N/A',
      REQUESTED: 'Requested',
      SUPPORTED: 'Supported',
      NOT_SUPPORTED: 'Not Supported',
      PENDING_DEPENDENCY: 'Pending dependency',
      SIGNED: 'Signed',
    },
    solutionTypes: {
      bmsUpgrade: 'BMS upgrade',
      commercialRepairs: 'Commercial repairs',
      energyEfficiency: 'Energy efficiency',
      led: 'LED',
      facadeRepairs: 'Facade repairs',
      fuelCell: 'Fuel cell',
      generators: 'Generators',
      hvac: 'HVAC',
      lightningNonLed: 'Lightning (non LED)',
      parkingRepairs: 'Parking repairs',
      publicInfrastructureIntervention: 'Public infrastructure intervention',
      photovoltaicPanels: 'Photovoltaic panels',
      restrooms: 'Restrooms',
      rhc: 'RHC',
      roofRepairs: 'Roof repairs',
      structuralUpgradesAndRepairs: 'Structural upgrades and repairs',
      equipmentReplacementOrUpgrade: 'Equipment replacement or upgrade',
      tradeDressReplacement: 'Trade dress replacement',
      wasteOther: 'Waste other',
      waterRelatedSystems: 'Water related systems',
      ecopilot: 'Ecopilot',
      flooringRepairs: 'Flooring repairs',
      safetyAndSecurity: 'Safety and security',
      wasteWaterManagement: 'Waste water management',
      evChargers: 'EV chargers',
      legalOrContractual: 'Legal or contractual',
      wasteBaler: 'Waste baler',
      poweroptimiserEPower: 'Power optimiser (E-power)',
      energyEnvelopeDoors: 'Energy envelope doors',
      energyEnvelopeRoof: 'Energy envelope roof',
      metering: 'Metering',
      energyEnvelopeFacade: 'Energy envelope facade',
      adaptiveScheduling: 'Adaptive Scheduling and Optimization',

      cashLine: 'Cash line',
      commercialExtension: 'Commercial extension',
      coWorkerRestaurantArea: 'Co-worker Restaurant/Area',
      coWorkerSpaces: 'Co-worker spaces',
      customerServicesClickAndCollect: 'Customer Services - click and collect',
      customerServicesOther: 'Customer Services - other',
      entrance: 'Entrance',
      exit: 'Exit',
      fullCommercialRebuild: 'Full commercial rebuild',
      kitchenAndDining: 'Kitchen ＆ Dining',
      marketHall: 'Market hall',
      otherCommercialSolution: 'Other commercial solution',
      'Commercial use': 'Commercial use',
      'Other Food solution': 'Other food solution',
      showRoom: 'Show room',
      swedishBistro: 'Swedish Bistro',
      swedishBite: 'Swedish Bite',
      swedishCafe: 'Swedish Cafe',
      swedishDeli: 'Swedish Deli',
      swedishFoodMarket: 'Swedish Food Market',
      swedishRestaurant: 'Swedish Resturant',
      swedishSnacks: 'Swedish snacks',
      zeroEmissionCoWorkerAndCustomerCharging:
        'Zero emission - Co-worker & Customer Charging',
      inStoreNavigation: 'In store navigation',
      otherConceptualSolution: 'Other conceptual solution',
      parkingAreas: 'Parking areas',
      tradeDress: 'Trade dress',
      concreteFlooring: 'Concrete Flooring',
      automationMedium: 'Automation – medium',
      automationHigh: 'Automation – high',
      conventionalWarehouseRacking: 'Conventional Warehouse Racking',
      dcFitForFuture: 'DC - Fit for Future',
      extension: 'Extension',
      redesignStep1Vass: 'Redesign step 1 (VASS)',
      redesignStep1Other: 'Redesign step 1 (Other)',
      redesignStep2: 'Redesign step 2',
      redesignStep3Layout: 'Redesign step 3 - Layout',
      redesignStep3Coss: 'Redesign step 3 – COSS',
      redesignStep3ClickAndCollectLockers:
        'Redesign step 3 – Click & Collect Lockers',
      redesignStep4: 'Redesign step 4',
      redesignStep5: 'Redesign step 5',
      redesignStep6: 'Redesign step 6',
      replenishmentCapabilities: 'Replenishment Capabilities',
      zeroEmissionLastMileDeliveryFleet:
        'Zero Emission – Last Mile Delivery – Fleet',
      zeroEmissionLastMileDeliveryCharging:
        'Zero Emission - Last Mile Delivery - Charging',
      zeroEmissionHdtChargers: 'Zero Emission - HDT Chargers',
      otherFulfilmentAndReplenishment: 'Other - Fulfilment & Replenishment',
      adaptiveSchedulingAndOptimization: 'Adaptive scheduling and optimization',
      powerOptimiserEPower: 'Power optimiser (E-power)',
      optimisationOfParkingLandWith3rdParty:
        'Optimisation of parking/land with 3rd party',
      optimisationOfBuildingPremiseWith3rdParty:
        'Optimisation of building/premise with 3rd party',
      goDark: 'Go Dark',
      spaceOptwOtherIKEABusinesses: 'Space opt. w other IKEA businesses',
      WAN: 'WAN',
      LAN: 'LAN',
      WIFI: 'WIFI',
      HOSTING: 'Hosting',
      CHECKOUT_POS: 'Checkout (POS)',
    },
    solutionTypesGrid: {
      ASAP: 'Asap',
      ADAPTIVE_SCHEDULING: 'Adaptive Scheduling and Optimization',
      ADAPTIVE_SCHEDULING_AND_OPTIMIZATION:
        'Adaptive Scheduling and Optimization',
      AUTOMATION: 'Automation',
      AUTOMATION_HIGH: 'Automation – High',
      AUTOMATION_MEDIUM: 'Automation – Medium',
      BMS_UPGRADE: 'BMS Upgrade',
      CASH_LINE: 'Cash Line',
      COMMERCIAL_EXTENSION: 'Commercial Extension',
      COMMERCIAL_REPAIRS: 'Commercial Repairs',
      COMMERCIAL_USE: 'Commercial Use',
      CONCRETE_FLOORING: 'Concrete Flooring',
      CONVENTIONAL_WAREHOUSE_RACKING: 'Conventional Warehouse Racking',
      CO_WORKER_SPACES: 'Co-Worker Spaces',
      COWORKER_RESTAURAN: 'Co-Worker Restaurant/Area',
      CUSTOMER_SERVICES_CLICK_AND_COLLECT:
        'Customer Services - Click and Collect',
      CUSTOMER_SERVICES_OTHER: 'Customer Services - Other',
      DC_FIT_FOR_FUTURE: 'DC - Fit for Future',
      ECOPILOT: 'Ecopilot',
      ELECTRIC_VEHICLES: 'Electric vehicles',
      ENERGY_EFFICIENCY: 'Energy Efficiency',
      ENERGY_ENVELOPE_DOORS: 'Energy Envelope Doors',
      ENERGY_ENVELOPE_FACADE: 'Energy Envelope Facade',
      ENERGY_ENVELOPE_ROOF: 'Energy Envelope Roof',
      ENERGY_ENVELOPE: 'Energy Envelope',
      EQUIPMENT_REPLACEMENT_OR_UPGRADE: 'Equipment Replacement or Upgrade',
      EV_CHARGERS: 'EV Chargers',
      EXIT: 'Exit',
      FACADES_REPAIRS: 'Facade Repairs',
      FLOORING_REPAIRS: 'Flooring Repairs',
      FUEL_CELL: 'Fuel Cell',
      GENERATORS: 'Generators',
      HVAC: 'HVAC',
      IHSP_RENTED_RETAIL_SPACE: 'IHSP Rented Retail Space',
      IN_STORE_NAVIGATION: 'In-Store Navigation',
      KITCHEN_AND_DINING: 'Kitchen & Dining',
      LED: 'LED',
      LEGAL_OR_CONTRACTUAL: 'Legal or Contractual',
      LIGHTNING_NON_LED: 'Lightning (Non LED)',
      METERING: 'Metering',
      MIXED_USE: 'Mixed Use',
      OTHER_COMMERCIAL_SOLUTION: 'Other Commercial Solution',
      OTHER_FULFILMENT_AND_REPLENISHMENT: 'Other - Fulfilment & Replenishment',
      OTHER_CONCEPTUAL_SOLUTION: 'Other Conceptual Solution',
      PARKING_AREAS: 'Parking Areas',
      PARKING_REPAIRS: 'Parking Repairs',
      PHOTOVOLTAIC_PANELS: 'Photovoltaic Panels',
      POWER_OPTIMISER_E_POWER: 'Power Optimiser (E-Power)',
      PUBLIC_INFRASTRUCTURE_INTERVENTION: 'Public Infrastructure Intervention',
      PV: 'PV',
      REDESIGN_STEP_1: 'Redesign Step 1',
      REDESIGN_STEP_1_OTHER: 'Redesign Step 1 (Other)',
      REDESIGN_STEP_1_VASS: 'Redesign Step 1 (VASS)',
      REDESIGN_STEP_2: 'Redesign Step 2',
      REDESIGN_STEP_3: 'Redesign Step 3',
      REDESIGN_STEP_3_COSS: 'Redesign Step 3 – COSS',
      REDESIGN_STEP_3_CLICK_AND_COLLECT_LOCKERS:
        'Redesign Step 3 – Click & Collect Lockers',
      REDESIGN_STEP_3_LAYOUT: 'Redesign Step 3 - Layout',
      REDESIGN_STEP_4: 'Redesign Step 4',
      REDESIGN_STEP_5: 'Redesign Step 5',
      REDESIGN_STEP_6: 'Redesign Step 6',
      REPLENISHMENT_CAPABILITIES: 'Replenishment Capabilities',
      RETAIL_SPACE: 'Retail Space',
      RHC: 'RHC',
      SAFETY_AND_SECURITY: 'Safety and Security',
      SHOWROOM: 'Show Room',
      STRUCTURAL_UPGRADES_AND_REPAIRS: 'Structural Upgrades and Repairs',
      TECHNICAL_SYSTEMS_AND_EQUIPMENT_REPLACEMENTS_UPGRADES_AND_REPAIRS:
        'Technical Systems and Equipment Replacements/Upgrades/Repairs',
      TRADE_DRESS: 'Trade Dress',
      TRADE_DRESS_REPLACEMENT: 'Trade Dress Replacement',
      WASTE_BALER: 'Waste Baler',
      WASTE_OTHER: 'Waste Other',
      WASTE_WATER_MANAGEMENT: 'Waste Water Management',
      WATER_RELATED_SYSTEMS: 'Water Related Systems',
      ZERO_EMISSION_CO_WORKER_AND_CUSTOMER_CHARGING:
        'Zero Emission - Co-Worker & Customer Charging',
      ZERO_EMISSION_COWORKER_AND_CUSTOMER_CHARGING:
        'Zero Emission - Co-Worker & Customer Charging',
      ZERO_EMISSION_LAST_MILE_DELIVERY_CHARGING:
        'Zero Emission - Last Mile Delivery - Charging',
      ZERO_EMISSION_LAST_MILE_DELIVERY_FLEET:
        'Zero Emission – Last Mile Delivery – Fleet',
      ZERO_EMISSION_HDT_CHARGERS: 'Zero Emission - HDT Chargers',
      ZERO_EMISSION: 'Zero Emission',
      RESTROOMS: 'Restrooms',
      ROOF_REPAIRS: 'Roof Repairs',
      SWEDISH_RESTAURANT: 'Swedish Restaurant',
      ADAPTIVE_SCHEDULING_AND_OPTIMIZATON:
        'Adaptive Scheduling and Optimization',
      COWORKER_RESTAURANT_AREA: 'Co-Worker Restaurant/Area',
      EV_LAST_MILE_DELIVERY: 'EV Last Mile Delivery',
      RACKING_AND_OTHER_WAREHOUSE_SOLUTIONS:
        'Racking and Other Warehouse Solutions',
      FACADE_REPAIRS: 'Facade Repairs',
      WASTE_BALERS: 'Waste Balers',
      FULL_COMMERCIAL_REBUILD: 'Full Commercial Rebuild',
      OPTIMISATION_OF_BUILDING_PREMISE_WITH_3RD_PARTY:
        'Optimisation of Building/Premise with 3rd Party',
      EXTENSION: 'Extension',
      ENTRANCE: 'Entrance',
      MARKET_HALL: 'Market Hall',
      SHOW_ROOM: 'Show Room',
      SWEDISH_BISTRO: 'Swedish Bistro',
      SWEDISH_BITE: 'Swedish Bite',
      SWEDISH_CAFE: 'Swedish Cafe',
      SWEDISH_DELI: 'Swedish Deli',
      SWEDISH_FOOD_MARKET: 'Swedish Food Market',
      SWEDISH_SNACKS: 'Swedish Snacks',
      OPTIMISATION_OF_PARKING_LAND_WITH_3RD_PARTY:
        'Optimisation of Parking/Land with 3rd Party',
      OTHER_FOOD_SOLUTION: 'Other food Solution',
      STORE_OF_TOMORROW: 'Store of tomorrow',
      COWORKER_SPACES: 'Coworker spaces',
      CPU_CAPACITY: 'CPU capacity',
      LIGHTING_NON_LED: 'Lighting non led',
      OTHER: 'Other',
      WAN: 'WAN',
      LAN: 'LAN',
      WIFI: 'WIFI',
      HOSTING: 'Hosting',
      CHECKOUT_POS: 'Checkout (POS)',
      GO_DARK: 'Go Dark',
      SPACE_OPT: 'Space opt. w other IKEA businesses',
    },
    guestAccessNotification: {
      title:
        'Oops! You are a guest user and need to be assigned a role and a country',
      description:
        'You are currently logged in as a guest user and do not have the required role or country assignment to access this page.',
      whatToDoTitle: 'What to do next?',
      whatToDoDescription:
        'Reach out to your respective Country Admin, who can assign you a role and the correct country for access. After the assignment, log back into the system to gain access.',
      linkText: 'Country Admin list',
    },
  },
};

export const getNestedValue = (object, key: string): string => {
  const keys = key.split('.');
  let value = object;

  keys.forEach((propertyKey) => {
    value = value && value[propertyKey];
  });

  return value;
};

export const translate = (key: string, locale: string, returnKey = true) => {
  const english = resources['en'];
  const userLang = resources[locale];
  const translationObject = userLang || english;
  try {
    const translation =
      getNestedValue(translationObject, key) || getNestedValue(english, key);
    if (!translation) {
      return returnKey && key;
    }
    return translation;
  } catch (e) {
    return getNestedValue(english, key) || key;
  }
};
//unFlattens translation json file
// export const unFlattenObject = (data) => {
//   'use strict';
//   if (Object(data) !== data || Array.isArray(data)) return data;
//   const regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
//     resultholder = {};
//   for (const p in data) {
//     let cur = resultholder,
//       prop = '',
//       m;
//     while ((m = regex.exec(p))) {
//       cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
//       prop = m[2] || m[1];
//     }
//     cur[prop] = data[p];
//   }
//   return resultholder[''] || resultholder;
// };
